/* eslint-disable quote-props */
/* eslint-disable quotes */
export const translations = {
  en: {
    "ADD_FOLDER_BTN": "Add folder",
    "ADD_FOLDER_BTN_TOOLTIP": "Add folder",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "Add first imported file to timeline at source start timecode",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "Allow timeline/media layout change",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "Bucket Name",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "Access Key ID",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "Secret Key",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "Importing",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "Import error",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "Imported sucessfully",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "Import media from AWS Bucket",
    "AMAZON_IMPORT_BTN_IMPORT": "Import",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "Import",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "Ask project name on New Project",
    "AUDIO_CAPTION_AUDIO": "Audio",
    "AUDIO_TEXT_FOUND_ITEMS": "Found items",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "No results found",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "It seems we can’t find any results based on your search.",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "Audio settings",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "Sound",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "Transition",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "Fade in (sec)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "Fade out (sec)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "Search genre",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "Search music",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "Search sound effects",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "Search in",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "Music by Genre",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "Sound Effects",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "Music by Mood",
    "AUDIO_MENU_ITEM_ALL": "All",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "Transitions",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "Auto play selected media",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "Remove asset from timeline?",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "Set timecode format based on media",
    "BATCH_IMPORT_FILES_HEAD": "Import files",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "Analysis",
    "CAPTION_ADDED": "Added",
    "CAPTION_SKIPPED": "Skipped",
    "COLOR_PICKER_BTN_COLOR": "Select color",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "Select color",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "Background color",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "Background color",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "Downloading media files",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "Importing media files",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "Uploading saved media",
    "COMMON_STATUS_TEXT_ABORTED": "Aborted",
    "COMMON_STATUS_TEXT_LOADING": "Loading",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "Operation is queued",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "Prepare images",
    "COMMON_STATUS_TEXT_RENDERING": "Rendering",
    "COMMON_STATUS_TEXT_CONVERT": "Convert",
    "COMMON_YES": "Yes",
    "COMMON_NO": "No",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "Reset all changes",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "Cancel",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "Cancel",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "User avatar",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "You can upload a file of default user avatar.",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "Avatar",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "Color theme",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "Custom JS script",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "Custom text",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "You can customize the editor's text",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "This script runs on editor's loading. Can be used to integrate analytics etc.",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "Edit JS script",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "Second accent color",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "Select the color of the main background.",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "The main accent color for the controls. Select your brand color here.",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "Additional color of controls in pair with the main color of buttons.",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "The audio file on the timeline has its own style.",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "You can upload a file of your Logo.",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "The voiceover file has its own style.",
    "CUSTOMIZATION_LABEL_DISPLAYED": "displayed",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "Choose one of the predefined themes or create your own. You can edit the CSS file to customize your theme.",
    "CUSTOMIZATION_TITLE_BASIC_BG": "Basic background",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "Primary buttons, links",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "Edit CSS file for Theme",
    "CUSTOMIZATION_TITLE_AUDIO": "Audio",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "Voice over",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "Edit text values",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "Edit text values",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "Edit text values",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "Format description",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "Format description",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "Reset all changes",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "Reset all changes",
    "CUSTOMIZATION_BTN_CANCEL": "Cancel",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "Cancel",
    "CUSTOMIZATION_BTN_SAVE": "Save",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "Save",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "Edit JS script",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "Edit JS script",
    "CUSTOMIZATION_BTN_EDIT_CSS": "Edit CSS",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "Edit CSS",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "Upload logo",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "Upload logo",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "Delete logo",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "Delete logo",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": 'Dark theme',
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": 'Light theme',
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": 'Custom theme',
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "Logo",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "Logo",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "Customize editor",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "Logo and name",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "Company name",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "Editor name",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "Accepted files:",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "No uploaded logo",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "View Settings",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "View Settings",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "Filters",
    "DUMMY_HEADER_BTN_FILTERS": "Filters",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Save project as..",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "Admin panel",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "New project",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "Publish",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "Customize editor",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Adobe CEP extentions",
    "EDITOR_MENU_MAIN_LOGS": "Logs",
    "EDITOR_MENU_MAIN_SETTINGS": "Settings",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "Unable to publish",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "Track is required",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "Render settings",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "Behaviour",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "View",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "Save",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "Cancel",
    "FILE_INPUT_BTN": "File input",
    "FILE_INPUT_BTN_TOOLTIP": "File input",
    "FORM_FIELD_LABEL_VOLUME": "Volume",
    "folder_not_empty": "The folder is not empty. The files can be used in projects. If you continue the file will not be available on timeline of the corresponding projects.",
    "HEAD_CONTROL_IMPORT_TEXT": "Import",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "Import media",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "Import from phone",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "Import folder with media",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Amazon S3 Bucket",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Google Drive",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "URL input",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Save project as..",
    "HEADER_MENU_LIST_ITEM_DELETE": "Delete",
    "HEADER_MENU_LIST_ITEM_RENAME": "Rename",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "Add license key",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "Log out",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "Do you want to leave the editor?",
    "HEADER_BTN_BACK_TO_MY_ACC": "Back to My Account",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "Back to My Account",
    "HEADER_BTN_HELP": "Help",
    "HEADER_BTN_HELP_TOOLTIP": "Help",
    "IMAGES_TEXT_NATIVE_IMAGES": "Native image",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "Images",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "Search in",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "Select collection",
    "IMAGES_TEXT_ALL_CATEGORIES": "All collections",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "No results found",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "It seems we can’t find any results based on your search.",
    "IMAGES_TAB_AI_GENERATED": "Ai-Generated",
    "IMAGES_TAB_SEARCH": "Search",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "Import media from URL",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "Click here to link to a file",
    "IMPORT_FROM_URL_BTN_IMPORT": "Import",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "Import",
    "IMPORT_TOKEN_INVALID": "Import token invalid",
    "LAYER_CONTROL_BTN_MOVE_UP": "Move Up",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "Move Up",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "Drag Layer",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "Drag Layer",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "Move Down",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "Move Down",
    "LAYER_CONTROL_BTN_DELETE": "Delete",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "Delete",
    "LAYER_CONTROL_BTN_HIDE": "Hide",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "Hide",
    "LAYER_CONTROL_BTN_SHOW": "Show",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "Show",
    "LAYER_CONTROL_BTN_MUTE": "Mute",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "Mute",
    "LAYER_CONTROL_BTN_UNMUTE": "Unmute",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "Unmute",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "My Media",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "My Media",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "Project Media",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "Project Media",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "Transitions",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "Transitions",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "Images",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "Images",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "Text",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "Text",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "Design",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "Design",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "Filters",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "Filters",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "Filters",
    "MEDIA_API_IS_NOT_AVAILABLE": "Error: Voiceover WebAPI requires https",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "Image settings",
    "MEDIA_FORM_CAPTION_POSITION": "Position",
    "MEDIA_FORM_CAPTION_ROTATION": "Rotation",
    "MEDIA_FORM_CAPTION_SETTINGS": "Settings",
    "MEDIA_FORM_CAPTION_OUTLINE": "Outline",
    "MEDIA_FORM_CAPTION_SHADOW": "Shadow",
    "MEDIA_FORM_CAPTION_SIZE": "Size",
    "MEDIA_FORM_CAPTION_VIDEO": "Video",
    "MEDIA_FORM_CAPTION_AUDIO": "Audio",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "Opacity",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "Filter",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "Filter",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "All",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "Video",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "Image",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "Audio",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "Folder",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "Voiceover",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "View settings",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "View settings",
    "MEDIA_UPLOADER_TEXT_OR": "or",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "Drag and drop your media here",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "import media",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "Importing",
    "MEDIA_PREVIEW_TEXT_RENDERING": "Rendering",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "Resolution",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "Rotation degrees",
    "MEDIA_INFO_LIST_ITEM_CODEC": "Codecs",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "Color space",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "Frame rate",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - Stereo",
    "MEDIA_INFO_LIST_ITEM_DURATION": "Duration",
    "MEDIA_INFO_LIST_ITEM_TYPE": "Type",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "Audio",
    "MEDIA_INFO_LIST_ITEM_SIZE": "Size",
    "MEDIA_INFO_LIST_TASK_STATUS": "Task status",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "Start timecode",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "Video encoder params",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "My media",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "Project media",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "Load more Media",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "Load more Media",
    "MEDIA_BTN_LOADING": "Loading",
    "MEDIA_BTN_LOADING_TOOLTIP": "Loading",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "Chroma Key",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "Position",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "Sound",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "SIZE",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "Media settings",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "Reset all settings",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "Reset all settings",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "Similarity",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "Smoothness",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "Key Color Spill Reduction",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "Pick color from the preview",
    "MEDIA_SORT_OPTION_DURATION": "Duration",
    "MEDIA_SORT_OPTION_DATE": "Date",
    "MEDIA_SORT_OPTION_SIZE": "Size",
    "MEDIA_SORT_OPTION_NAME": "Name",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "Sort By",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "Order",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "View",
    "MEDIA_SORT_OPTION_ASCENDING": "Ascending",
    "MEDIA_SORT_OPTION_DESCENDING": "Descending",
    "MEDIA_SORT_OPTION_LIST": "List",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "Large icons",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "My Recordings",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "My Recordings",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "My Media",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "My Media",
    "MEDIA_FILES_DELETE_FORM_TITLE": "Some files are used by projects and have not been removed",
    "MEDIA_FILES_DELETE_FORM_DESC": "The selected files will be deleted from the media library and will no longer available in projects",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "Files used in the projects",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "Select all",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "Are you sure you want to remove selected item(s)?",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "Browse for folder",
    "MEDIA_CONFIRM_BTN_DELETE": "Delete",
    "MEDIA_CANCEL_BTN_DELETE": "Cancel",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "Delete",
    "MEDIA_CONFIRM_TITLE_DELETE": "Delete",
    "MEDIA_TEXT_LOADING": "Loading",
    "MEDIA_BTN_ADD": "Add",
    "MEDIA_BTN_ADD_TOOLTIP": "Add",
    "MEDIA_PROGRESS_TEXT_LOADING": "Loading",
    "MEDIA_PROGRESS_TEXT_SAVING": "Saving",
    "MEDIA_PROGRESS_TEXT_CONVERT": "Convert",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "Transfer",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "Analysis",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "Select Folder",
    "MEDIA_MENU_ITEM_MEDIA": "Media",
    "MEDIA_MENU_ITEM_MOVE_TO": "Move to",
    "MEDIA_MENU_ITEM_SETTINGS": "Settings",
    "MEDIA_MENU_ITEM_NABLET_HLD": "Detect sport highlights",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "Transcribe",
    "MEDIA_MENU_ITEM_DELETE": "Delete",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "Delete selected clips",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "Browse media",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "Copy media address",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "Add using start timecode",
    "MEDIA_MENU_LABEL_MOVE_TO": "Move to",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "HTML5 Video Editor",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "Tablets and mobile are not supported yet :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "Video Editor works well on your computer",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "Go back to website",
    "MOBILE_UPLOAD_TITLE": "Upload files to the user’s storage",
    "MOBILE_UPLOAD_SUBTITLE": "Supports: video, audio, photos. Your files will be saved in the user’s storage",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "To switch language you need to restart the application",
    "MODAL_WINDOW_LOGS_TITLE": "To switch logs on/off you need to restart the application",
    "MODAL_WINDOW_INSTALL_COMPONENT_TITLE": "The requested component was installed. You need to restart the application",
    "MESSAGE_BOX_INSTALL_RUNNING": "Another installation is in progress.\nPlease wait for it to complete.",
    "MESSAGE_BOX_INSTALL_FAILED": "The installation failed to run. Check logs for details",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "Select a reference file",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "You add files with different FPS/resolution/codec. Select the file whose properties will be applied to the project",
    "MODAL_WINDOW_BUTTON_RESTART": "Restart",
    "MUTE_AUDIO_AT_CREATED_LAYERS": 'Mute audio at created layers',
    "NAVIGATION_TAB_EDITOR": "Editor",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "Editor",
    "NAVIGATION_TAB_PROJECTS": "Projects",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "Projects",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "No network connection",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "Last saved",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "min ago",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "just now",
    "PROJECTS_BTN_NEW_PROJECTS": "New project",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "New project",
    "PROJECTS_BTN_NEW_PROJECT": "New project",
    "PROJECTS_BTN_IMPORT": "Import",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "Import",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "Yes",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "Cancel",
    "PROJECTS_TITLE_TEXT_COPY": "Copy",
    "PROJECTS_BTN_SAVE": "Save",
    "PROJECTS_BTN_SAVE_TOOLTIP": "Save",
    "PROJECTS_BTN_CREATE": "Create",
    "PROJECTS_BTN_CREATE_TOOLTIP": "Create",
    "PROJECTS_TITLE_TEXT_RENAME": "Rename",
    "PROJECTS_TITLE_TEXT_DELETE": "Delete",
    "PROJECTS_TITLE_TEXT_EXPORT": "Export",
    "PROJECTS_CONFIRM_BTN_DELETE": "Delete",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "Edited %d hours ago",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "Edited just now",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "Edited %d minutes ago",
    "PROJECTS_PROGRESS_TEXT_LOADING": "Loading",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "Searching",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "Do you want to stop importing?",
    "PROJECTS_TEXT_NOTHING_FOUND": "Nothing found",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "Create a beautiful new project",
    "PROJECTS_TEXT_CAPTION": "Projects",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "Project name",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "Click to upload or, drag and drop a project file here",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "You can upload one file at a time only",
    "PROJECTS_PREFIX_TEXT_EDITED": "Edited",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "Are you sure you want to delete",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "This project will be deleted immediately. You can’t undo this action.",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "Project",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "Only one file can be uploaded",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "Invalid file extension. Should be *.edl.zip",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "Enter your value",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "Create a folder for this project in My Media",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "Open Editor",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "Try again",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "Select frame rate for the project",
    "PROJECTS_EXPORT_TITLE": "Export project",
    "PROJECTS_EXPORT_INPROGRESS": "Export in progress...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "Include media",
    "PROJECTS_EXPORT_COMPLETE": "Export project complete",
    "PROJECTS_EXPORT_BTN_BROWSE": "Browse",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "Download",
    "PROJECTS_EXPORT_BTN_COPY": "Copy",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "Files from media are played back here",
    "PREVIEW_BTN_PREV_TOOLTIP": "Prev",
    "PREVIEW_BTN_PREV": "Prev",
    "PREVIEW_BTN_PLAY_TOOLTIP": "Play",
    "PREVIEW_BTN_PLAY": "Play",
    "PREVIEW_BTN_STOP_TOOLTIP": "Stop",
    "PREVIEW_BTN_STOP": "Stop",
    "PREVIEW_BTN_NEXT_TOOLTIP": "Next",
    "PREVIEW_BTN_NEXT": "Next",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "Volume",
    "PREVIEW_BTN_VOLUME": "Volume",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "Mark in",
    "PREVIEW_BTN_MARK_IN": "Mark in",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "Mark out",
    "PREVIEW_BTN_MARK_OUT": "Mark out",
    "PREVIEW_BTN_FRAME_CAPTURE": "Capture frame",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "Capture frame",
    "PREVIEW_BTN_FULL_SCREEN": "Full screen",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "Full screen",
    "PREVIEW_HEADER_TITLE_SOURCE": "Source",
    "PREVIEW_HEADER_TITLE_TIMELINE": "Timeline",
    "PREVIEW_MODE_AUTO": "Auto",
    "PREVIEW_MODE_SOURCE": "Source preview",
    "PREVIEW_MODE_TIMELINE": "Timeline preview",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "output",
    "PUBLISH_SETTINGS_TITLE": "Title",
    "QR_CODE_DIALOG_TITLE": "Scan the QR code (valid 24 hours)",
    "QR_CODE_LOAD_ERROR": "Error! Unable to generate a QR code",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "Prevent adding video files with different video encoder parameters to the same timeline",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "Ignore quantizer video params mismatch",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "Start rendering from the first clip",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "Ask publish output name",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "Close Publish settings on cancel",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "Duration",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "Codec",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "Frame Rate",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - Stereo",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "Resolution",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "Audio",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "Size (approximate)",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "Link to transcoding file will be lost",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "Publish settings",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "Video Render Complete",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "Enter name",
    "SAVE_SETTINGS_BTN_RENDER_START": "Start",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "Start",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "Back to My Account",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "Back to My Account",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "Cancel",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "Cancel",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "Download",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "Download",
    "SAVE_SETTINGS_BTN_BROWSE": "Browse",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "Browse",
    "SAVE_SETTINGS_BTN_COPY": "Copy",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "Copy",
    "SAVE_SETTINGS_TEXT_TITLE": "Title",
    "SAVE_SETTINGS_TEXT_LOADING": "Loading",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "Prepare images",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "This video has been submitted to your account and should be available soon.",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "All",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "Search",
    "SHOW_MY_MEDIA_POOL": "Show my media pool",
    "SHOW_PROJECT_MEDIA_POOL": "Show project media pool",
    "SHOW_EDITOR_HEADER": "Show editor header",
    "SHOW_MENU_TABS": "Show menu tabs",
    "SHOW_PREVIEW_SPLIT_BUTTON": "Show preview split button",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "Show preview switch buttons",
    "SHOW_INOUT_POINTS_TIMELINE": "Show timeline in/out points",
    "SHOW_INOUT_POINTS_SOURCE": "Show source in/out points",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "Show import placeholder on empty timeline",
    "VIEW_SETTINGS_LANG": "Language",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "Description",
    "SETTINGS_HEAD_BTN_DELETE": "Delete",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "Delete",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "Select same",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "Select same",
    "SETTINGS_HEAD_BTN_CLOSE": "Close",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "Close",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "Width",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "Height",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "Keep the aspect ratio",
    "SETTINGS_BTN_FIT_TO_FRAME": "Fit to frame",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "Fit to frame",
    "SETTINGS_BTN_FILL_FRAME": "Fill frame",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "Fill frame",
    "SETTINGS_TEXT_AUTO": "auto",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "Text transform none",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "Text transform none",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "Text transform uppercase",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "Text transform uppercase",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "Text transform lowercase",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "Text transform lowercase",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "Text transform capitalize",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "Text transform capitalize",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "Font family",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "Font family",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "Font siz",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "Font size",
    "SETTINGS_TEXT_BTN_BOLD": "Bold",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "Bold",
    "SETTINGS_TEXT_BTN_ITALIC": "Italic",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "Italic",
    "SETTINGS_TEXT_BTN_UNDERLINE": "Underline",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "Underline",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "Left",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "Left",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "Right",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "Right",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "Center",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "Center",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "Justify",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "Justify",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "Top",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "Top",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "Top left",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "Top left",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "Top Right",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "Top Right",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "Left",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "Left",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "Middle center",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "Middle center",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "Right",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "Right",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "Bottom left",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "Bottom left",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "Bottom",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "Bottom",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "Bottom right",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "Bottom right",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "Horizontal",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "Vertical",
    "SETTINGS_ROTATION_TEXT_ROTATE": "Rotate",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "Enter text",
    "NABLET_HLD_PROJECT_POSTFIX": "highlights",
    "NABLET_HLD_CAPTION": "Detect highlights",
    "NABLET_HLD_DETECTED_BTN_START": "Start",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "Create project(s)",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "Cancel",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "Detected intervals count:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "Are you sure you want terminate task?",
    "NABLET_HLD_DETECTED_BTN_NO": "No",
    "NABLET_HLD_DETECTED_BTN_YES": "Yes",
    "NB_HLD_STATUS_TEXT_DETECTING": "Detecting",
    "NABLET_HLD_TARGET_DURATION_SEC": "Target duration seconds",
    "AI_MODEL": "AI model",
    "TRANSCRIBE_CAPTION": "Transcribe media",
    "TRANSCRIBE_PROJECT_POSTFIX": "transcribed",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "Transcribing",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "Text items count:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "Create project",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "This section is in development",
    "TEXT_FORM_CAPTION_SIZE": "Size",
    "TEXT_FORM_CAPTION_OUTLINE": "Outline",
    "TEXT_FORM_CAPTION_FONT": "Font",
    "TEXT_FORM_CAPTION_SHADOW": "Shadow",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "Text settings",
    "TEXT_FORM_TEXT_OFFSET": "Offset",
    "TEXT_FORM_TEXT_BLUR": "Blur",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "Text",
    "TIMELINE_TEXT_DRAG_N_DROP": "Drag & Drop",
    "TIMELINE_TEXT_ADD_LAYER": "+ Add Layer",
    "TIMELINE_TOOLBAR_BTN_UNDO": "Undo",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "Undo",
    "TIMELINE_TOOLBAR_BTN_REDO": "Redo",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "Redo",
    "TIMELINE_TOOLBAR_BTN_DELETE": "Delete",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "Delete",
    "TIMELINE_TOOLBAR_BTN_COPY": "Copy clip",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "Copy clip",
    "TIMELINE_TOOLBAR_BTN_CUT": "Cut clip(s)",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "Cut clip(s)",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "Add Marker",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "Add Marker",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "Paste",
    "TIMELINE_TOOLBAR_BTN_PASTE": "Paste",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "Settings",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "Settings",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "Voice Over",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "Voice Over",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "Web camera",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "Web camera",
    "TIMELINE_TOOLBAR_BTN_LIVE": "Live stream",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "Live stream",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "Click to cancel",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "Click to cancel",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "Drag & Drop",
    "TIMELINE_FOOTER_TEXT_DURATION": "Duration",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "Unable to publish project",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "Video track is required",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "Save",
    "TIMELINE_FOOTER_BTN_SAVE": "Save",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "Save",
    "TIMELINE_FOOTER_BTN_PUBLISH": "Publish",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "Publish",
    "TIMELINE_SLIDER_POINTER": "Slider pointer",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "Slider pointer",
    "TRANSITION_NAME_DISSOLVE": "Dissolve",
    "TRANSITION_NAME_FADE_IN": "Fade In",
    "TRANSITION_NAME_FADE_OUT": "Fade Out",
    "TRANSITION_NAME_DIP_TO_BLACK": "Dip to Black",
    "TRANSITION_NAME_DIP_TO_WHITE": "Dip to White",
    "TRANSITION_NAME_BLUR": "Blur",
    "TRANSITION_NAME_WIPE_RIGHT": "Wipe Right",
    "TRANSITION_NAME_WIPE_LEFT": "Wipe Left",
    "TRANSITION_NAME_WIPE_UP": "Wipe Up",
    "TRANSITION_NAME_WIPE_DOWN": "Wipe Down",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "Transition settings",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "Apply to all transitions from the timeline",
    "TRANSITION_FORM_SELECTED": "selected:",
    "TRANSITION_FORM_LABEL_TYPE": "Type",
    "TRANSITION_FORM_LABEL_DURATION": "Duration (sec)",
    "TRANSITION_LIST_CAPTION_TRANSITION": "Transition",
    "used_in_projects": "Media file was not deleted because it is in use in one or more projects. If you continue the file will not be available on timeline in corresponding projects and deleted from your account.",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "Use modal dialog for import local files",
    "VOICE_OVER_TITLE_LAST_RECORDING": "Last recording",
    "VOICE_OVER_BTN_RETAKE": "Retake",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "Retake",
    "VOICE_OVER_BTN_DELETE_FILE": "Delete file",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "Delete file",
    "VOICE_OVER_BTN_START_RECORDING": "Start recording",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "Start recording",
    "VOICE_OVER_BTN_CONNECTION": "Connection...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "Connection...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "The file will be deleted from the timeline and media.",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "Are you sure?",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "Voice Narration",
    "VOICE_OVER_TEXT_MIC": "Microphone",
    "VOICE_OVER_LABEL_SELECT_MIC": "Select microphone",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "No audio",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "Mute timeline while recording",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "Rewind slider at the start after record",
    "VOICE_OVER_TEXT_COUNTDOWN": "Countdown",
    "VOICE_OVER_BTN_TEST_MIC": "Test Mic",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "Test Mic",
    "VOICE_OVER_BTN_RECORDING": "Recording...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "Recording...",
    "VOICE_OVER_BTN_PLAYING": "Playing...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "Playing...",
    "VOICE_OVER_BTN_YES": "Yes",
    "VOICE_OVER_BTN_YES_TOOLTIP": "Yes",
    "VOICE_OVER_BTN_NO": "No",
    "VOICE_OVER_BTN_NO_TOOLTIP": "No",
    "VOICE_OVER_BTN_STOP": "Stop",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "Stop",
    "VOICE_OVER_BTN_DELETE": "Delete",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "Delete",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "Auto adjusting",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "Other settings",
    "WEBCAM_TEXT_RECORD_VIDEO": "Record video",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "Record live stream",
    "LIVE_STREAM_URL_INPUT_LABEL": "Live stream URL",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "Click here to link to a live stream",
    "LIVE_STREAM_BTN_CONNECTING": "Connecting...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "Connecting...",
    "LIVE_STREAM_BTN_CAPTURE": "Start capture",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "Start capture",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "Stop capture",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "Stop capture",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "Decrease zoom",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "Decrease zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "Increase zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "Increase zoom",
    "SETTINGS_HOTKEYS": "Hotkeys settings",
    "PRESET": "Preset",
    "DEFAULT": "Default",
    "ADD_NEW": "Add New",
    "SEARCH_COMMAND": "Search command",
    "COMMAND": "Command",
    "SHORTCUTS": "Shortcuts",
    "ALL": 'All',
    "TIMELINE": "Timeline",
    "TOOLS": "Tools",
    "PREVIEW": "Preview",
    "KEYBOARD_MAPPING_PRESET": "Keyboard Mapping Preset",
    "ENTER_PRESET_NAME": "Enter preset name",
    "THIS_PRESET_WILL_BE_DELETED": "This preset will be deleted immediately. You can’t undo this action.",
    "RESET_ALL_TO_DEFAULTS": 'Reset all to defaults',
    "HOTKEY_SETTINGS_UNDO": 'Undo',
    "HOTKEY_SETTINGS_REDO": 'Redo',
    "HOTKEY_SETTINGS_ZOOM_IN": 'Zoom in',
    "HOTKEY_SETTINGS_ZOOM_OUT": 'Zoom out',
    "HOTKEY_SETTINGS_PREV_FRAME": 'Previous frame',
    "HOTKEY_SETTINGS_NEXT_FRAME": 'Next frame',
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": 'Add to timeline',
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": 'Increase clip volume',
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": 'Decrease clip volume',
    "HOTKEY_SETTINGS_RIPPLE_DELETE": 'Ripple delete',
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": 'Ripple trim previous',
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": 'Ripple trim next',
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": 'Select clips at current position',
    "HOTKEY_SETTINGS_CUT_CLIPS": 'Cut clip(s)',
    "HOTKEY_SETTINGS_PLAY_PAUSE": 'Play/Pause',
    "HOTKEY_SETTINGS_DELETE": 'Delete',
    "HOTKEY_SETTINGS_COPY": 'Copy',
    "HOTKEY_SETTINGS_PASTE": 'Paste',
    "HOTKEY_SETTINGS_PLAY": "Play",
    "HOTKEY_SETTINGS_PAUSE": "Pause",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "Play the highlighted interval",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "Clear in out points",
    "HOTKEY_SETTINGS_MARK_IN": "Mark in point",
    "HOTKEY_SETTINGS_MARK_OUT": "Mark out point",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "Seek to in point",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "Seek to out point",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "Move the slider to the next clip edit point",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "Move the slider to the previous clip edit point",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "Toggle my media visible",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "Toggle editor settings visible",
    "CLIP_SETTINGS": "Clip settings",
    "MESSAGE_BOX_INCOMPATIBLE": "The files are not compatible",
    "MESSAGE_BOX_REMOVE_EXISTING": "The files are not compatible (Format mismatch)",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "The files are not compatible (Resolution mismatch)",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "The files are not compatible (Frame rate mismatch)",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "The files are not compatible (Codecs mismatch)",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "The files are not compatible (DF/NDF timecode format mismatch)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "The files are not compatible (Color space mismatch)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "The files are not compatible (Video encoder parameters mismatch)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "File is incompatible (please delete the offline clip)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "Transcribe models not found.\nWould you like to download (~882 MB) and install?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "Sport highlights detection models not found.\nWould you like to download (~3.9 GB) and install?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "Sport highlights detection requires NVIDIA GPU with compute capability >= 7.5",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "Prevent adding video files with different video codecs, resolutions, FPS, DF/NDF timecode, Color space to the same timeline",
    "MARKS_CONTEXT_MENU_MARK_IN": "Mark In",
    "MARKS_CONTEXT_MENU_MARK_OUT": "Mark Out",
    "MARKS_CONTEXT_MENU_CLEAR": "Clear in/out points",
    "MEDIA_ERROR_build_thumbnails_error": "Build thumbnails error",
    "MEDIA_ERROR_unsupported_media": "Unsupported media",
    "MEDIA_ERROR_exceeded_file_size": "Exceeded file size",
    "MEDIA_ERROR_exceeded_per_user_size": "Exceeded per user size",
    "MEDIA_ERROR_low_disk_space": "Low disk space",
    "MEDIA_ERROR_internal_server_error": "Internal server error",
    "MEDIA_ERROR_network_error": "Network error",
    "MEDIA_ERROR_not_found": "Media file not found",
    "MEDIA_ERROR_unable_get_media_info": "Unable to get media info",
    "MEDIA_ERROR_not_enough_tokens": "Not enough tokens",
  },
  ja: {
    "ADD_FOLDER_BTN": "フォルダの追加",
    "ADD_FOLDER_BTN_TOOLTIP": "フォルダの追加",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "最初にインポートしたファイルをソース開始タイムコードでタイムラインに追加する",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "タイムライン/メディアのレイアウト変更を許可する",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "バケット名",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "アクセスキーID",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "シークレットキー",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "インポート中",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "インポートエラー",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "インポートに成功しました",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "AWSバケットからメディアをインポート",
    "AMAZON_IMPORT_BTN_IMPORT": "インポート",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "インポート",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "新規プロジェクト作成時にプロジェクト名を尋ねる",
    "AUDIO_CAPTION_AUDIO": "オーディオ",
    "AUDIO_TEXT_FOUND_ITEMS": "見つかった項目",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "結果は見つかりませんでした",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "検索結果が見つかりません",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "オーディオ設定",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "サウンド",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "トランジション",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "フェードイン (秒)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "フェードアウト (秒)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "検索ジャンル",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "検索音楽",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "検索効果音",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "で検索",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "ジャンル別音楽",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "サウンドエフェクト",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "ムード別の音楽",
    "AUDIO_MENU_ITEM_ALL": "すべて",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "トランジション",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "選択したメディアを自動再生",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "タイムラインからアセットを削除しますか？",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "メディアに応じてタイムコードフォーマットを設定",
    "BATCH_IMPORT_FILES_HEAD": "ファイルをインポートする",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "分析",
    "CAPTION_ADDED": "追加",
    "CAPTION_SKIPPED": "スキップ",
    "COLOR_PICKER_BTN_COLOR": "色を選択",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "色を選択",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "背景色",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "背景色",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "メディアファイルをダウンロードしています",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "メディアファイルのインポート",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "保存メディアをアップロード中",
    "COMMON_STATUS_TEXT_ABORTED": "中止",
    "COMMON_STATUS_TEXT_LOADING": "ロード中",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "操作はキューに入れられました",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "画像を準備する",
    "COMMON_STATUS_TEXT_RENDERING": "エンコード中",
    "COMMON_STATUS_TEXT_CONVERT": "変換",
    "COMMON_YES": "はい",
    "COMMON_NO": "いいえ",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "すべての変更をリセット",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "キャンセル",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "キャンセル",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "ユーザーアバター",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "デフォルトのユーザーアバターファイルをアップロードできます",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "アバター",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "カラーテーマ",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "カスタムJSスクリプト",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "カスタムテキスト",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "エディターのテキストをカスタマイズできます",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "このスクリプトはエディタのロード時に実行されます。アナリティクスなどを統合するために使用できます",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "JSスクリプトの編集",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "第二アクセントカラー",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "メイン背景の色を選択します",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "コントロールのメインアクセントカラー。ここでブランドカラーを選択してください",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "ボタンのメインカラーと対になるコントロールの追加カラー",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "タイムライン上のオーディオファイルには独自のスタイルがあります",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "ロゴのファイルをアップロードできます",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "ナレーションファイルには独自のスタイルがあります",
    "CUSTOMIZATION_LABEL_DISPLAYED": "表示",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "定義済みのテーマの一つを選択するか独自のテーマを作成してください。CSSファイルを編集してテーマをカスタマイズできます。",
    "CUSTOMIZATION_TITLE_BASIC_BG": "基本背景",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "プライマリボタン、リンク",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "テーマのCSSファイルを編集する",
    "CUSTOMIZATION_TITLE_AUDIO": "オーディオ",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "ボイスオーバー",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "テキスト値の編集",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "テキスト値の編集",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "テキスト値の編集",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "フォーマットの説明",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "フォーマットの説明",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "すべての変更をリセット",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "すべての変更をリセット",
    "CUSTOMIZATION_BTN_CANCEL": "キャンセル",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "キャンセル",
    "CUSTOMIZATION_BTN_SAVE": "保存",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "保存",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "JSスクリプトの編集",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "JSスクリプトの編集",
    "CUSTOMIZATION_BTN_EDIT_CSS": "CSSの編集",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "CSSの編集",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "ロゴのアップロード",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "ロゴのアップロード",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "ロゴの削除",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "ロゴの削除",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "ダークテーマ",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "ライトテーマ",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "カスタムテーマ",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "ロゴ",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "ロゴ",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "エディタのカスタマイズ",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "ロゴと名前",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "会社名",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "エディター名",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "受け付けるファイル:",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "アップロードされたロゴはありません",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "ビュー設定",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "表示設定",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "フィルタ",
    "DUMMY_HEADER_BTN_FILTERS": "フィルタ",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "プロジェクトを別名で保存",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "管理パネル",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "新規プロジェクト",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "書き出し",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "エディタのカスタマイズ",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Adobe CEP 拡張機能",
    "EDITOR_MENU_MAIN_LOGS": "過去ログ",
    "EDITOR_MENU_MAIN_SETTINGS": "設定",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "公開できません",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "トラックは必須です",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "レンダリング設定",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "行動",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "表示",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "保存",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "キャンセル",
    "FILE_INPUT_BTN": "ファイル入力",
    "FILE_INPUT_BTN_TOOLTIP": "ファイル入力",
    "FORM_FIELD_LABEL_VOLUME": "ボリューム",
    "folder_not_empty": "フォルダは空ではありません。ファイルはプロジェクトで使用することができます。このままだと、対応するプロジェクトのタイムラインでファイルが利用できなくなります。",
    "HEAD_CONTROL_IMPORT_TEXT": "インポート",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "メディアのインポート",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "携帯電話からインポート",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "メディア付きフォルダのインポート",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Amazon S3バケット",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Googleドライブ",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "URL入力",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "プロジェクトを別名で保存",
    "HEADER_MENU_LIST_ITEM_DELETE": "削除",
    "HEADER_MENU_LIST_ITEM_RENAME": "名前の変更",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "ライセンスキーの追加",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "ログアウト",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "エディターから離れますか？",
    "HEADER_BTN_BACK_TO_MY_ACC": "マイアカウントに戻る",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "マイアカウントに戻る",
    "HEADER_BTN_HELP": "ヘルプ",
    "HEADER_BTN_HELP_TOOLTIP": "ヘルプ",
    "IMAGES_TEXT_NATIVE_IMAGES": "ネイティブ画像",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "画像",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "で検索",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "コレクションを選択",
    "IMAGES_TEXT_ALL_CATEGORIES": "すべてのコレクション",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "結果は見つかりませんでした",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "検索結果が見つかりません",
    "IMAGES_TAB_AI_GENERATED": "AI生成",
    "IMAGES_TAB_SEARCH": "検索",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "URLからメディアをインポート",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "ファイルへのリンクはこちら",
    "IMPORT_FROM_URL_BTN_IMPORT": "インポート",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "インポート",
    "IMPORT_TOKEN_INVALID": "インポートトークンが無効です",
    "LAYER_CONTROL_BTN_MOVE_UP": "上へ移動",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "上へ移動",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "ドラッグレイヤー",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "レイヤーをドラッグ",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "下に移動",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "下に移動",
    "LAYER_CONTROL_BTN_DELETE": "削除",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "削除",
    "LAYER_CONTROL_BTN_HIDE": "隠す",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "隠す",
    "LAYER_CONTROL_BTN_SHOW": "表示",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "表示",
    "LAYER_CONTROL_BTN_MUTE": "ミュート",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "ミュート",
    "LAYER_CONTROL_BTN_UNMUTE": "ミュート解除",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "ミュート解除",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "マイメディア",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "マイメディア",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "プロジェクト・メディア",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "プロジェクト・メディア",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "トランジション",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "トランジション",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "画像",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "画像",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "オーディオ",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "オーディオ",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "テキスト",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "テキスト",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "デザイン",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "デザイン",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "フィルター",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "フィルター",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "フィルター",
    "MEDIA_API_IS_NOT_AVAILABLE": "エラー: Voiceover WebAPI は https が必要です",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "画像設定",
    "MEDIA_FORM_CAPTION_POSITION": "位置",
    "MEDIA_FORM_CAPTION_ROTATION": "回転",
    "MEDIA_FORM_CAPTION_SETTINGS": "設定",
    "MEDIA_FORM_CAPTION_OUTLINE": "アウトライン",
    "MEDIA_FORM_CAPTION_SHADOW": "シャドウ",
    "MEDIA_FORM_CAPTION_SIZE": "サイズ",
    "MEDIA_FORM_CAPTION_VIDEO": "ビデオ",
    "MEDIA_FORM_CAPTION_AUDIO": "オーディオ",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "不透明度",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "フィルタ",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "フィルタ",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "すべて",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "ビデオ",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "イメージ",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "オーディオ",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "フォルダ",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "ナレーション",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "表示設定",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "ビューの設定",
    "MEDIA_UPLOADER_TEXT_OR": "または",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "ここにメディアをドラッグ＆ドロップしてください",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "インポートメディア",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "インポート",
    "MEDIA_PREVIEW_TEXT_RENDERING": "エンコード中",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "解像度",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "回転角度",
    "MEDIA_INFO_LIST_ITEM_CODEC": "コーデック",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "色空間",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "フレームレート",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - ステレオ",
    "MEDIA_INFO_LIST_ITEM_DURATION": "デュレーション",
    "MEDIA_INFO_LIST_ITEM_TYPE": "タイプ",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "オーディオ",
    "MEDIA_INFO_LIST_ITEM_SIZE": "サイズ",
    "MEDIA_INFO_LIST_TASK_STATUS": "タスクのステータス",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "スタート・タイムコード",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "ビデオエンコーダーのパラメータ",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "私のメディア",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "プロジェクトメディア",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "より多くのメディアを読み込む",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "より多くのメディアを読み込む",
    "MEDIA_BTN_LOADING": "ロード中",
    "MEDIA_BTN_LOADING_TOOLTIP": "ロード中",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "クロマキー",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "位置",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "音",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "SIZE",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "メディア設定",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "すべての設定をリセットする",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "すべての設定をリセット",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "類似度",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "滑らかさ",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "キーカラーの流出削減",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "プレビューから色を選ぶ",
    "MEDIA_SORT_OPTION_DURATION": "デュレーション",
    "MEDIA_SORT_OPTION_DATE": "日付",
    "MEDIA_SORT_OPTION_SIZE": "サイズ",
    "MEDIA_SORT_OPTION_NAME": "名前",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "ソート順",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "順序",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "ビュー",
    "MEDIA_SORT_OPTION_ASCENDING": "昇順",
    "MEDIA_SORT_OPTION_DESCENDING": "降順",
    "MEDIA_SORT_OPTION_LIST": "リスト",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "大きなアイコン",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "私の録音",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "私の記録",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "マイメディア",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "マイメディア",
    "MEDIA_FILES_DELETE_FORM_TITLE": "いくつかのファイルはプロジェクトで使用されており、削除されていません。",
    "MEDIA_FILES_DELETE_FORM_DESC": "選択したファイルはメディアライブラリから削除され、プロジェクトで使用できなくなります。",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "プロジェクトで使用するファイル",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "すべて選択",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "選択された項目を本当に削除しますか？",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "フォルダを参照",
    "MEDIA_CONFIRM_BTN_DELETE": "削除",
    "MEDIA_CANCEL_BTN_DELETE": "キャンセル",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "削除",
    "MEDIA_CONFIRM_TITLE_DELETE": "削除",
    "MEDIA_TEXT_LOADING": "読み込み中",
    "MEDIA_BTN_ADD": "追加",
    "MEDIA_BTN_ADD_TOOLTIP": "追加",
    "MEDIA_PROGRESS_TEXT_LOADING": "ロード中",
    "MEDIA_PROGRESS_TEXT_SAVING": "保存",
    "MEDIA_PROGRESS_TEXT_CONVERT": "変換",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "転送",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "分析",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "フォルダの選択",
    "MEDIA_MENU_ITEM_MEDIA": "メディア",
    "MEDIA_MENU_ITEM_MOVE_TO": "移動先",
    "MEDIA_MENU_ITEM_SETTINGS": "設定",
    "MEDIA_MENU_ITEM_NABLET_HLD": "スポーツハイライトを検出",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "文字起こし",
    "MEDIA_MENU_ITEM_DELETE": "削除",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "選択したクリップを削除する",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "メディアを見る",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "コピーメディアのアドレス",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "開始タイムコードを使用して追加する",
    "MEDIA_MENU_LABEL_MOVE_TO": "移動先",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "HTML5動画エディター",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "タブレットとモバイルはまだサポートされていません :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "ビデオエディターはパソコンでも使えます",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "ウェブサイトに戻る",
    "MOBILE_UPLOAD_TITLE": "Speicher von user」にファイルをアップロード",
    "MOBILE_UPLOAD_SUBTITLE": "対応形式：動画、音声、写真。ファイルは「Speicher von user」に保存されます。",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "言語を切り替えるには、アプリケーションを再起動する必要があります",
    "MODAL_WINDOW_LOGS_TITLE": "ログをオン/オフに切り替えるには、アプリケーションを再起動する必要があります",
    "MODAL_WINDOW_INSTALL_COMPONENT_TITLE": "要求されたコンポーネントがインストールされました。アプリケーションを再起動する必要があります",
    "MESSAGE_BOX_INSTALL_RUNNING": "別のインストールが進行中です。\n完了までお待ちください。",
    "MESSAGE_BOX_INSTALL_FAILED": "インストールを実行できませんでした。詳細はログを確認してください",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "参照ファイルを選択する",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "異なるFPS/解像度/コーデックのファイルを追加します。プロパティがプロジェクトに適用されるファイルを選択します。",
    "MODAL_WINDOW_BUTTON_RESTART": "リスタート",
    "MUTE_AUDIO_AT_CREATED_LAYERS": '作成したレイヤーのオーディオをミュートする',
    "NAVIGATION_TAB_EDITOR": "エディット",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "エディット",
    "NAVIGATION_TAB_PROJECTS": "プロジェクト",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "プロジェクト",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "ネットワーク接続がありません",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "最終保存日",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "分前",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "ちょうど今",
    "PROJECTS_BTN_NEW_PROJECTS": "新しいプロジェクト",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "新規プロジェクト",
    "PROJECTS_BTN_NEW_PROJECT": "新しいプロジェクト",
    "PROJECTS_BTN_IMPORT": "インポート",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "インポート",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "はい",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "キャンセル",
    "PROJECTS_TITLE_TEXT_COPY": "コピー",
    "PROJECTS_BTN_SAVE": "保存",
    "PROJECTS_BTN_SAVE_TOOLTIP": "保存",
    "PROJECTS_BTN_CREATE": "作成する",
    "PROJECTS_BTN_CREATE_TOOLTIP": "作成する",
    "PROJECTS_TITLE_TEXT_RENAME": "リネーム",
    "PROJECTS_TITLE_TEXT_DELETE": "削除",
    "PROJECTS_TITLE_TEXT_EXPORT": "エクスポート",
    "PROJECTS_CONFIRM_BTN_DELETE": "削除",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "%d時間前に編集",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "編集中",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "%d分前に編集",
    "PROJECTS_PROGRESS_TEXT_LOADING": "ロード中",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "検索",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "インポートを停止しますか？",
    "PROJECTS_TEXT_NOTHING_FOUND": "何も見つかりません",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "美しい新規プロジェクトを作成する",
    "PROJECTS_TEXT_CAPTION": "プロジェクト",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "プロジェクト名",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "クリックしてアップロードするか、ここにプロジェクトファイルをドラッグ＆ドロップしてください",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "一度にアップロードできるファイルは1つだけです",
    "PROJECTS_PREFIX_TEXT_EDITED": "編集済み",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "本当に削除しますか？",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "このプロジェクトは直ちに削除されます。元に戻すことはできません。",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "プロジェクト",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "アップロードできるファイルは1つだけです",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "無効なファイル拡張子です。.edl.zip でなければなりません",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "値を入力してください",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "このプロジェクトのフォルダをメディアに作成する",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "エディターを開く",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "再試行",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "プロジェクトのフレームレートを選択",
    "PROJECTS_EXPORT_TITLE": "プロジェクトのエクスポート",
    "PROJECTS_EXPORT_INPROGRESS": "エクスポート進行中...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "メディアを含む",
    "PROJECTS_EXPORT_COMPLETE": "プロジェクトのエクスポートが完了しました",
    "PROJECTS_EXPORT_BTN_BROWSE": "参照",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "ダウンロード",
    "PROJECTS_EXPORT_BTN_COPY": "コピー",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "メディアからのファイルはここで再生されます",
    "PREVIEW_BTN_PREV_TOOLTIP": "前",
    "PREVIEW_BTN_PREV": "前",
    "PREVIEW_BTN_PLAY_TOOLTIP": "再生",
    "PREVIEW_BTN_PLAY": "再生",
    "PREVIEW_BTN_STOP_TOOLTIP": "停止",
    "PREVIEW_BTN_STOP": "停止",
    "PREVIEW_BTN_NEXT_TOOLTIP": "次へ",
    "PREVIEW_BTN_NEXT": "次へ",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "ボリューム",
    "PREVIEW_BTN_VOLUME": "ボリューム",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "イン点",
    "PREVIEW_BTN_MARK_IN": "イン点",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "アウト点",
    "PREVIEW_BTN_MARK_OUT": "アウト点",
    "PREVIEW_BTN_FRAME_CAPTURE": "キャプチャフレーム",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "キャプチャフレーム",
    "PREVIEW_BTN_FULL_SCREEN": "フルスクリーン",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "フルスクリーン",
    "PREVIEW_HEADER_TITLE_SOURCE": "ソース",
    "PREVIEW_HEADER_TITLE_TIMELINE": "タイムライン",
    "PREVIEW_MODE_AUTO": "オート",
    "PREVIEW_MODE_SOURCE": "ソース",
    "PREVIEW_MODE_TIMELINE": "タイムライン",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "出力",
    "PUBLISH_SETTINGS_TITLE": "タイトル",
    "QR_CODE_DIALOG_TITLE": "QRコードをスキャンしてください（有効期限：24時間）",
    "QR_CODE_LOAD_ERROR": "エラー！QRコードの作成に失敗しました",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "異なるビデオエンコーダー設定を持つビデオファイルを同じタイムラインに追加できないようにする",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "量子化パラメータとビデオパラメータの不一致を無視",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "最初のクリップからレンダリングを開始する",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "書き出し時に出力名を尋ねる",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "キャンセル時に公開設定を閉じる",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "デュレーション",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "コーデック",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "フレームレート",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - ステレオ",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "解像度",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "オーディオ",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "サイズ（概算）",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "トランスコード・ファイルへのリンクが失われます",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "ファイルインサート",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "ファイルインサート完了",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "名前を入力",
    "SAVE_SETTINGS_BTN_RENDER_START": "開始",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "開始",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "マイアカウントに戻る",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "マイアカウントに戻る",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "キャンセル",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "キャンセル",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "ダウンロード",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "ダウンロード",
    "SAVE_SETTINGS_BTN_BROWSE": "ブラウズ",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "ブラウズ",
    "SAVE_SETTINGS_BTN_COPY": "コピー",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "コピー",
    "SAVE_SETTINGS_TEXT_TITLE": "タイトル",
    "SAVE_SETTINGS_TEXT_LOADING": "読み込み中",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "画像を準備する",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "このビデオはあなたのアカウントに送信されました",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "すべて",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "検索",
    "SHOW_MY_MEDIA_POOL": "メディアプールを表示する",
    "SHOW_PROJECT_MEDIA_POOL": "プロジェクトメディアプールを表示",
    "SHOW_EDITOR_HEADER": "エディタヘッダーを表示",
    "SHOW_MENU_TABS": "メニュータブを表示",
    "SHOW_PREVIEW_SPLIT_BUTTON": "プレビュー分割ボタンを表示する",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "プレビュー切替ボタンを表示する",
    "SHOW_INOUT_POINTS_TIMELINE": "タイムラインのイン／アウトポイントを表示する",
    "SHOW_INOUT_POINTS_SOURCE": "ソースのイン／アウトポイントを表示する",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "空のタイムラインにドロッププレースホルダーを表示する",
    "VIEW_SETTINGS_LANG": "言語",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "説明",
    "SETTINGS_HEAD_BTN_DELETE": "削除",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "削除",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "同じものを選ぶ",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "同じものを選ぶ",
    "SETTINGS_HEAD_BTN_CLOSE": "閉じる",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "閉じる",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "幅",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "高さ",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "アスペクト比を維持",
    "SETTINGS_BTN_FIT_TO_FRAME": "フレームに合わせる",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "フレームに合わせる",
    "SETTINGS_BTN_FILL_FRAME": "塗りつぶし枠",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "塗りつぶし枠",
    "SETTINGS_TEXT_AUTO": "自動",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "テキスト変換なし",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "テキスト変換なし",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "テキストの大文字変換",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "テキスト変換大文字",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "テキスト変換小文字",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "テキスト変換小文字",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "テキストを大文字に変換する",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "テキストを大文字に変換する",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "フォントファミリー",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "フォントファミリー",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "フォントサイズ",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "フォントサイズ",
    "SETTINGS_TEXT_BTN_BOLD": "太字",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "太字",
    "SETTINGS_TEXT_BTN_ITALIC": "イタリック",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "イタリック",
    "SETTINGS_TEXT_BTN_UNDERLINE": "下線",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "下線",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "左",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "左",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "右",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "右",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "中央",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "中央",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "ジャスティファイ",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "ジャスティファイ",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "トップ",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "トップ",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "左上",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "左上",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "右上",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "右上",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "左",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "左",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "中央",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "中央",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "右",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "右",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "左下",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "左下",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "下",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "下",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "下",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "右下",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "水平",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "垂直",
    "SETTINGS_ROTATION_TEXT_ROTATE": "回転",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "テキストを入力",
    "NABLET_HLD_PROJECT_POSTFIX": "ハイライト",
    "NABLET_HLD_CAPTION": "ハイライトを検出",
    "NABLET_HLD_DETECTED_BTN_START": "開始",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "プロジェクトを作成",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "キャンセル",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "検出されたインターバルの数:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "タスクを終了してもよろしいですか？",
    "NABLET_HLD_DETECTED_BTN_NO": "いいえ",
    "NABLET_HLD_DETECTED_BTN_YES": "はい",
    "NB_HLD_STATUS_TEXT_DETECTING": "検出中",
    "NABLET_HLD_TARGET_DURATION_SEC": "目標の秒数",
    "AI_MODEL": "AIモデル",
    "TRANSCRIBE_CAPTION": "メディアを文字起こし",
    "TRANSCRIBE_PROJECT_POSTFIX": "文字起こし済み",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "文字起こし中",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "テキスト項目数:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "プロジェクトを作成",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "このセクションは開発中です",
    "TEXT_FORM_CAPTION_SIZE": "サイズ",
    "TEXT_FORM_CAPTION_OUTLINE": "アウトライン",
    "TEXT_FORM_CAPTION_FONT": "フォント",
    "TEXT_FORM_CAPTION_SHADOW": "影",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "テキスト設定",
    "TEXT_FORM_TEXT_OFFSET": "オフセット",
    "TEXT_FORM_TEXT_BLUR": "ぼかし",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "テキスト",
    "TIMELINE_TEXT_DRAG_N_DROP": "ドラッグ＆ドロップ",
    "TIMELINE_TEXT_ADD_LAYER": "レイヤーを追加",
    "TIMELINE_TOOLBAR_BTN_UNDO": "元に戻す",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "元に戻す",
    "TIMELINE_TOOLBAR_BTN_REDO": "やり直し",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "やり直し",
    "TIMELINE_TOOLBAR_BTN_DELETE": "削除",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "削除",
    "TIMELINE_TOOLBAR_BTN_COPY": "コピークリップ",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "クリップをコピー",
    "TIMELINE_TOOLBAR_BTN_CUT": "クリップをカット",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "クリップをカット",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "マーカーを追加",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "マーカーを追加",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "貼り付け",
    "TIMELINE_TOOLBAR_BTN_PASTE": "貼り付け",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "設定",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "設定",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "ボイスオーバー",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "ボイスオーバー",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "ウェブカメラ",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "ウェブカメラ",
    "TIMELINE_TOOLBAR_BTN_LIVE": "ライブストリーム",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "ライブストリーム",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "クリックしてキャンセル",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "クリックしてキャンセル",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "ドラッグ＆ドロップ",
    "TIMELINE_FOOTER_TEXT_DURATION": "デュレーション",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "プロジェクトを公開できません",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "ビデオトラックが必要です",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "保存",
    "TIMELINE_FOOTER_BTN_SAVE": "インサート",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "インサート",
    "TIMELINE_FOOTER_BTN_PUBLISH": "公開",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "公開",
    "TIMELINE_SLIDER_POINTER": "スライダーのポインター",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "スライダーのポインター",
    "TRANSITION_NAME_DISSOLVE": "溶解",
    "TRANSITION_NAME_FADE_IN": "フェードイン",
    "TRANSITION_NAME_FADE_OUT": "フェードアウト",
    "TRANSITION_NAME_DIP_TO_BLACK": "ブラックへ移行",
    "TRANSITION_NAME_DIP_TO_WHITE": "ホワイトへ移行",
    "TRANSITION_NAME_BLUR": "ボケ",
    "TRANSITION_NAME_WIPE_RIGHT": "右へワイプ",
    "TRANSITION_NAME_WIPE_LEFT": "左へワイプ",
    "TRANSITION_NAME_WIPE_UP": "上へワイプ",
    "TRANSITION_NAME_WIPE_DOWN": "下へワイプ",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "トランジション設定",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "タイムラインから全てのトランジションに適用する",
    "TRANSITION_FORM_SELECTED": "選択済み:",
    "TRANSITION_FORM_LABEL_TYPE": "タイプ",
    "TRANSITION_FORM_LABEL_DURATION": "期間（秒）",
    "TRANSITION_LIST_CAPTION_TRANSITION": "トランジション",
    "used_in_projects": "メディアファイルが削除されませんでした。続行すると、ファイルは対応するプロジェクトのタイムラインで使用できなくなり、アカウントから削除されます。",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "ローカルファイルのインポートにはモーダルダイアログを使用する",
    "VOICE_OVER_TITLE_LAST_RECORDING": "最後の録音",
    "VOICE_OVER_BTN_RETAKE": "リテイク",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "リテイク",
    "VOICE_OVER_BTN_DELETE_FILE": "ファイルを削除",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "ファイルを削除",
    "VOICE_OVER_BTN_START_RECORDING": "録音開始",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "録音開始",
    "VOICE_OVER_BTN_CONNECTION": "接続...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "接続...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "このファイルはタイムラインとメディアから削除されます",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "よろしいですか？",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "音声ナレーション",
    "VOICE_OVER_TEXT_MIC": "マイク",
    "VOICE_OVER_LABEL_SELECT_MIC": "マイクを選択",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "音声なし",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "録音中のタイムラインのミュート",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "録音後の巻き戻しスライダー",
    "VOICE_OVER_TEXT_COUNTDOWN": "カウントダウン",
    "VOICE_OVER_BTN_TEST_MIC": "テストマイク",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "テストマイク",
    "VOICE_OVER_BTN_RECORDING": "録音...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "録音...",
    "VOICE_OVER_BTN_PLAYING": "再生中...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "再生中...",
    "VOICE_OVER_BTN_YES": "はい",
    "VOICE_OVER_BTN_YES_TOOLTIP": "はい",
    "VOICE_OVER_BTN_NO": "いいえ",
    "VOICE_OVER_BTN_NO_TOOLTIP": "いいえ",
    "VOICE_OVER_BTN_STOP": "停止",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "停止",
    "VOICE_OVER_BTN_DELETE": "削除",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "削除",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "自動調整",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "その他の設定",
    "WEBCAM_TEXT_RECORD_VIDEO": "ビデオを録画する",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "ライブストリームを録画する",
    "LIVE_STREAM_URL_INPUT_LABEL": "ライブストリームURL",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "ライブストリームへのリンクはこちらをクリックしてください",
    "LIVE_STREAM_BTN_CONNECTING": "接続中...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "接続中...",
    "LIVE_STREAM_BTN_CAPTURE": "キャプチャを開始",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "キャプチャを開始",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "キャプチャを停止",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "キャプチャを停止",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "ズームを減らす",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "ズームを減らす",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "ズームを増やす",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "ズームを増やす",
    "SETTINGS_HOTKEYS": "ショートカットキー",
    "PRESET": "プリセット",
    "DEFAULT": "デフォルト",
    "ADD_NEW": "新規追加",
    "SEARCH_COMMAND": "検索コマンド",
    "COMMAND": "コマンド",
    "SHORTCUTS": "ショートカット",
    "ALL": "すべて",
    "TIMELINE": "タイムライン",
    "TOOLS": "ツール",
    "PREVIEW": "プレビュー",
    "KEYBOARD_MAPPING_PRESET": "キーボードマッピングプリセット",
    "ENTER_PRESET_NAME": "プリセット名を入力",
    "THIS_PRESET_WILL_BE_DELETED": "このプリセットは直ちに削除されます。元に戻すことはできません。",
    "RESET_ALL_TO_DEFAULTS": "すべてをデフォルトに戻す",
    "HOTKEY_SETTINGS_UNDO": "元に戻す",
    "HOTKEY_SETTINGS_REDO": "やり直し",
    "HOTKEY_SETTINGS_ZOOM_IN": "ズームイン",
    "HOTKEY_SETTINGS_ZOOM_OUT": "ズームアウト",
    "HOTKEY_SETTINGS_PREV_FRAME": "前のフレーム",
    "HOTKEY_SETTINGS_NEXT_FRAME": "次のフレーム",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "タイムラインに追加",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "クリップの音量を上げる",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "クリップの音量を下げる",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "リップル削除",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "リップル・トリムの前",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "リップルトリムネクスト",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "現在の位置でクリップを選択",
    "HOTKEY_SETTINGS_CUT_CLIPS": "クリップをカット",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "再生/一時停止",
    "HOTKEY_SETTINGS_DELETE": "削除",
    "HOTKEY_SETTINGS_COPY": "コピー",
    "HOTKEY_SETTINGS_PASTE": "貼り付け",
    "HOTKEY_SETTINGS_PLAY": "プレー",
    "HOTKEY_SETTINGS_PAUSE": "一時停止",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "ハイライトされた区間を再生する",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "明確なインアウト・ポイント",
    "HOTKEY_SETTINGS_MARK_IN": "マークインポイント",
    "HOTKEY_SETTINGS_MARK_OUT": "マークアウトポイント",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "シーク・トゥ・イン・ポイント",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "アウトポイントへ",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "スライダーをクリップの次の編集ポイントに移動する",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "スライダーをクリップの前の編集ポイントに移動する",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "メディアの表示を切り替える",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "エディタ設定の表示を切り替える",
    "CLIP_SETTINGS": "クリップ設定",
    "MESSAGE_BOX_INCOMPATIBLE": "ファイルに互換性がありません",
    "MESSAGE_BOX_REMOVE_EXISTING": "ファイルに互換性がありません（フォーマットが一致しません）",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "ファイルに互換性がありません（解像度が一致しません）",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "ファイルに互換性がありません（フレームレートが一致しません）",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "ファイルに互換性がありません（コーデックが一致しません）",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "ファイルは互換性がありません（DF/NDFタイムコード形式の不一致)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "ファイルが互換性ありません（色空間の不一致)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "ファイルが互換性ありません（ビデオエンコーダーのパラメータが一致しません)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "ファイルが互換性ありません（オフラインクリップを削除してください)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "文字起こしモデルが見つかりません。ダウンロード (~882 MB) してインストールしますか？",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "スポーツハイライト検出モデルが見つかりません。ダウンロード (~3.9 GB) してインストールしますか？",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "スポーツハイライト検出には計算能力 7.5 以上の NVIDIA GPU が必要です",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "異なるコーデック、解像度、FPS、DF/NDFタイムコード、色空間を持つ動画ファイルを同じタイムラインに追加しないようにする",
    "MARKS_CONTEXT_MENU_MARK_IN": "イン点",
    "MARKS_CONTEXT_MENU_MARK_OUT": "アウト点",
    "MARKS_CONTEXT_MENU_CLEAR": "イン点/アウト点を削除",
    "MEDIA_ERROR_build_thumbnails_error": "サムネイル作成エラー",
    "MEDIA_ERROR_unsupported_media": "サポートされていないメディア",
    "MEDIA_ERROR_exceeded_file_size": "ファイルサイズが超過",
    "MEDIA_ERROR_exceeded_per_user_size": "ユーザーあたりのサイズが超過",
    "MEDIA_ERROR_low_disk_space": "ディスク容量不足",
    "MEDIA_ERROR_internal_server_error": "内部サーバーエラー",
    "MEDIA_ERROR_network_error": "ネットワークエラー",
    "MEDIA_ERROR_not_found": "メディアファイルが見つかりません",
    "MEDIA_ERROR_unable_get_media_info": "メディア情報を取得できません",
    "MEDIA_ERROR_not_enough_tokens": "トークンが不足しています",
  },
  bz: {
    "ADD_FOLDER_BTN": "Adicionar pasta",
    "ADD_FOLDER_BTN_TOOLTIP": "Adicionar pasta",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "Adicionar o primeiro arquivo importado à linha do tempo no código de tempo inicial da fonte",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "Permitir alteração do layout da linha do tempo/mídia",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "Nome do Bucket",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "ID da chave de acesso",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "Chave secreta",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "Importando",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "Erro de importação",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "Importado com sucesso",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "Importar mídia do AWS Bucket",
    "AMAZON_IMPORT_BTN_IMPORT": "Importar",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "Importar",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "Perguntar o nome do projeto em Novo Projeto",
    "AUDIO_CAPTION_AUDIO": "Áudio",
    "AUDIO_TEXT_FOUND_ITEMS": "Itens encontrados",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "Nenhum resultado encontrado",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "Parece que não conseguimos encontrar nenhum resultado com base em sua pesquisa.",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "Configurações de áudio",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "Som",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "Transição",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "Fade in (seg)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "Fade out (seg)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "Pesquisar gênero",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "Pesquisar música",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "Pesquisar efeitos sonoros",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "Pesquisar em",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "Música por gênero",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "Efeitos sonoros",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "Música por estado de espírito",
    "AUDIO_MENU_ITEM_ALL": "Todos",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "Transições",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "Reproduzir automaticamente a mídia selecionada",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "Remover ativo da linha do tempo?",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "Definir o formato de timecode com base na mídia",
    "BATCH_IMPORT_FILES_HEAD": "Importar arquivos",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "Análise",
    "CAPTION_ADDED": "Adicionado",
    "CAPTION_SKIPPED": "Ignorado",
    "COLOR_PICKER_BTN_COLOR": "Selecionar cor",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "Selecionar cor",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "Cor de fundo",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "Cor de fundo",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "Download de arquivos de mídia",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "Importação de arquivos de mídia",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "Upload de mídia salva",
    "COMMON_STATUS_TEXT_ABORTED": "Abortado",
    "COMMON_STATUS_TEXT_LOADING": "Carregando",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "A operação está na fila",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "Prepare as imagens",
    "COMMON_STATUS_TEXT_RENDERING": "Renderização",
    "COMMON_STATUS_TEXT_CONVERT": "Converter",
    "COMMON_YES": "Sim",
    "COMMON_NO": "Não",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "Redefinir todas as alterações",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "Cancelar",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "Cancelar",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "Avatar do usuário",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "Você pode carregar um arquivo do avatar padrão do usuário.",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "Avatar",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "Tema de cor",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "Script JS personalizado",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "Texto personalizado",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "Você pode personalizar o texto do editor",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "Este script é executado no carregamento do editor. Pode ser usado para integrar análises etc.",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "Editar script JS",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "Segunda cor de destaque",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "Selecione a cor do plano de fundo principal",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "A cor de destaque principal para os controles. Selecione a cor de sua marca aqui.",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "Cor adicional dos controles em conjunto com a cor principal dos botões.",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "O arquivo de áudio na linha do tempo tem seu próprio estilo.",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "Você pode carregar um arquivo de seu logotipo.",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "O arquivo de narração tem seu próprio estilo",
    "CUSTOMIZATION_LABEL_DISPLAYED": "exibido",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "Escolha um dos temas predefinidos ou crie o seu próprio. Você pode editar o arquivo CSS para personalizar seu tema.",
    "CUSTOMIZATION_TITLE_BASIC_BG": "Fundo básico",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "Botões primários, links",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "Editar arquivo CSS para o tema",
    "CUSTOMIZATION_TITLE_AUDIO": "Áudio",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "Voice over",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "Editar valores de texto",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "Editar valores de texto",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "Editar valores de texto",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "Descrição do formato",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "Descrição do formato",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "Redefinir todas as alterações",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "Redefinir todas as alterações",
    "CUSTOMIZATION_BTN_CANCEL": "Cancelar",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "Cancelar",
    "CUSTOMIZATION_BTN_SAVE": "Salvar",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "Salvar",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "Editar script JS",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "Editar script JS",
    "CUSTOMIZATION_BTN_EDIT_CSS": "Editar CSS",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "Editar CSS",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "Carregar logotipo",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "Carregar logotipo",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "Excluir logotipo",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "Excluir logotipo",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "Tema escuro",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "Tema leve",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "Tema personalizado",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "Logo",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "Logotipo",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "Personalizar editor",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "Logotipo e nome",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "Nome da empresa",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "Nome do editor",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "Arquivos aceitos:",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "Nenhum logotipo carregado",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "Exibir configurações",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "Configurações de visualização",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "Filtros",
    "DUMMY_HEADER_BTN_FILTERS": "Filtros",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Salvar projeto como...",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "Painel de administração",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "Novo projeto",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "Publicar",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "Personalizar editor",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Extensões Adobe CEP",
    "EDITOR_MENU_MAIN_LOGS": "Registros",
    "EDITOR_MENU_MAIN_SETTINGS": "Configurações",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "Não foi possível publicar",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "A trilha é obrigatória",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "Configurações de renderização",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "Comportamento",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "Ver",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "Salvar",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "Cancelar",
    "FILE_INPUT_BTN": "Entrada de arquivo",
    "FILE_INPUT_BTN_TOOLTIP": "Entrada de arquivo",
    "FORM_FIELD_LABEL_VOLUME": "Volume",
    "folder_not_empty": "The folder is not empty. The files can be used in projects. If you continue the file will not be available on timeline of the corresponding projects.",
    "HEAD_CONTROL_IMPORT_TEXT": "Importar",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "Importar mídia",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "Importar do celular",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "Importar pasta com mídia",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Amazon S3 Bucket",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Google Drive",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "Entrada de URL",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Salvar projeto como...",
    "HEADER_MENU_LIST_ITEM_DELETE": "Excluir",
    "HEADER_MENU_LIST_ITEM_RENAME": "Renomear",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "Adicionar chave de licença",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "Sair",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "Você quer sair do editor?",
    "HEADER_BTN_BACK_TO_MY_ACC": "Voltar para minha conta",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "Voltar para minha conta",
    "HEADER_BTN_HELP": "Ajuda",
    "HEADER_BTN_HELP_TOOLTIP": "Ajuda",
    "IMAGES_TEXT_NATIVE_IMAGES": "Imagem nativa",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "Images",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "Pesquisar em",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "Selecionar coleção",
    "IMAGES_TEXT_ALL_CATEGORIES": "Todas as coleções",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "Nenhum resultado encontrado",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "Parece que não conseguimos encontrar nenhum resultado com base em sua pesquisa.",
    "IMAGES_TAB_AI_GENERATED": "Ai-Generated",
    "IMAGES_TAB_SEARCH": "Pesquisar",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "Importar mídia do URL",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "Clique aqui para criar um link para um arquivo",
    "IMPORT_FROM_URL_BTN_IMPORT": "Importar",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "Importar",
    "IMPORT_TOKEN_INVALID": "Token de importação inválido",
    "LAYER_CONTROL_BTN_MOVE_UP": "Mover para cima",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "Mover para cima",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "Camada de arrasto",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "Drag Layer",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "Mover para baixo",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "Mover para baixo",
    "LAYER_CONTROL_BTN_DELETE": "Excluir",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "Excluir",
    "LAYER_CONTROL_BTN_HIDE": "Hide",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "Hide",
    "LAYER_CONTROL_BTN_SHOW": "Mostrar",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "Mostrar",
    "LAYER_CONTROL_BTN_MUTE": "Silenciar",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "Silenciar",
    "LAYER_CONTROL_BTN_UNMUTE": "Desativar o som",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "Desativar o som",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "Minha mídia",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "Minha mídia",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "Mídia do projeto",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "Mídia do projeto",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "Transições",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "Transições",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "Imagens",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "Imagens",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "Áudio",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "Áudio",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "Texto",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "Texto",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "Design",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "Design",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "Filtros",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "Filtros",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "Filtros",
    "MEDIA_API_IS_NOT_AVAILABLE": "Erro: A API Web do Voiceover requer https",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "Configurações de imagem",
    "MEDIA_FORM_CAPTION_POSITION": "Posição",
    "MEDIA_FORM_CAPTION_ROTATION": "Rotação",
    "MEDIA_FORM_CAPTION_SETTINGS": "Configurações",
    "MEDIA_FORM_CAPTION_OUTLINE": "Esboço",
    "MEDIA_FORM_CAPTION_SHADOW": "Sombra",
    "MEDIA_FORM_CAPTION_SIZE": "Tamanho",
    "MEDIA_FORM_CAPTION_VIDEO": "Vídeo",
    "MEDIA_FORM_CAPTION_AUDIO": "Áudio",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "Opacidade",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "Filtro",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "Filtro",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "Todos",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "Vídeo",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "Imagem",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "Áudio",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "Pasta",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "Locução",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "Configurações de visualização",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "Configurações de visualização",
    "MEDIA_UPLOADER_TEXT_OR": "ou",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "Arraste e solte sua mídia aqui",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "importar mídia",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "Importando",
    "MEDIA_PREVIEW_TEXT_RENDERING": "Renderização",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "Resolução",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "Graus de rotação",
    "MEDIA_INFO_LIST_ITEM_CODEC": "Codecs",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "Espaço de cores",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "Taxa de quadros",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - Estéreo",
    "MEDIA_INFO_LIST_ITEM_DURATION": "Duração",
    "MEDIA_INFO_LIST_ITEM_TYPE": "Tipo",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "Áudio",
    "MEDIA_INFO_LIST_ITEM_SIZE": "Tamanho",
    "MEDIA_INFO_LIST_TASK_STATUS": "Status da tarefa",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "Iniciar código de tempo",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "Parâmetros do codificador de vídeo",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "Minhas mídias",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "Mídia do projeto",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "Carregar mais mídia",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "Carregar mais mídia",
    "MEDIA_BTN_LOADING": "Carregando",
    "MEDIA_BTN_LOADING_TOOLTIP": "Carregando",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "Chroma Key",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "Posição",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "Som",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "Tamanho",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "Configurações de mídia",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "Redefinir todas as configurações",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "Redefinir todas as configurações",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "Similaridade",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "Suavidade",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "Redução de derramamento de cores-chave",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "Escolher cor da visualização",
    "MEDIA_SORT_OPTION_DURATION": "Duração",
    "MEDIA_SORT_OPTION_DATE": "Data",
    "MEDIA_SORT_OPTION_SIZE": "Tamanho",
    "MEDIA_SORT_OPTION_NAME": "Nome",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "Classificar por",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "Ordem",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "Exibir",
    "MEDIA_SORT_OPTION_ASCENDING": "Ascendente",
    "MEDIA_SORT_OPTION_DESCENDING": "Descendente",
    "MEDIA_SORT_OPTION_LIST": "List",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "Ícones grandes",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "Minhas gravações",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "Minhas gravações",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "Minha mídia",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "Minha mídia",
    "MEDIA_FILES_DELETE_FORM_TITLE": "Alguns arquivos são usados por projetos e não foram removidos",
    "MEDIA_FILES_DELETE_FORM_DESC": "Os arquivos selecionados serão excluídos da biblioteca de mídia e não estarão mais disponíveis nos projetos",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "Arquivos usados no projetos",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "Selecionar tudo",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "Tem certeza de que deseja remover o(s) item(ns) selecionado(s)?",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "Procurar por pasta",
    "MEDIA_CONFIRM_BTN_DELETE": "Excluir",
    "MEDIA_CANCEL_BTN_DELETE": "Cancelar",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "Excluir",
    "MEDIA_CONFIRM_TITLE_DELETE": "Excluir",
    "MEDIA_TEXT_LOADING": "Carregando",
    "MEDIA_BTN_ADD": "Adicionar",
    "MEDIA_BTN_ADD_TOOLTIP": "Adicionar",
    "MEDIA_PROGRESS_TEXT_LOADING": "Carregando",
    "MEDIA_PROGRESS_TEXT_SAVING": "Salvando",
    "MEDIA_PROGRESS_TEXT_CONVERT": "Converter",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "Transferir",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "Análise",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "Selecionar pasta",
    "MEDIA_MENU_ITEM_MEDIA": "Mídia",
    "MEDIA_MENU_ITEM_MOVE_TO": "Mover para",
    "MEDIA_MENU_ITEM_SETTINGS": "Configurações",
    "MEDIA_MENU_ITEM_NABLET_HLD": "Detectar destaques esportivos",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "Transcrever",
    "MEDIA_MENU_ITEM_DELETE": "Excluir",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "Excluir clipes selecionados",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "Navegar na mídia",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "Copiar endereço de mídia",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "Adicionar usando o timecode de início",
    "MEDIA_MENU_LABEL_MOVE_TO": "Mover para",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "Editor de vídeo HTML5",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "Tablets e celulares ainda não são suportados :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "O editor de vídeo funciona bem em seu computador",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "Voltar ao site",
    "MOBILE_UPLOAD_TITLE": "Carregar arquivos para o “Armazenamento do usuário”",
    "MOBILE_UPLOAD_SUBTITLE": "Formatos suportados: vídeo, áudio, foto. Seus arquivos serão salvos no “Armazenamento do usuário”",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "Para mudar de idioma, você precisa reiniciar o aplicativo",
    "MODAL_WINDOW_LOGS_TITLE": "Para ligar/desligar os logs, é necessário reiniciar o aplicativo",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "Selecione um arquivo de referência",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "Você adiciona arquivos com FPS/resolução/codec diferentes. Selecione o arquivo cujas propriedades serão aplicadas ao projeto",
    "MODAL_WINDOW_BUTTON_RESTART": "Reiniciar",
    "MUTE_AUDIO_AT_CREATED_LAYERS": 'Silenciar o áudio nas camadas criadas',
    "NAVIGATION_TAB_EDITOR": "Editor",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "Editor",
    "NAVIGATION_TAB_PROJECTS": "Projetos",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "Projetos",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "Sem conexão de rede",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "Last saved",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "min ago",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "agora mesmo",
    "PROJECTS_BTN_NEW_PROJECTS": "Novo projeto",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "Novo projeto",
    "PROJECTS_BTN_NEW_PROJECT": "Novo projeto",
    "PROJECTS_BTN_IMPORT": "Importação",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "Importação",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "Sim",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "Cancelar",
    "PROJECTS_TITLE_TEXT_COPY": "Cópia",
    "PROJECTS_BTN_SAVE": "Salvar",
    "PROJECTS_BTN_SAVE_TOOLTIP": "Salvar",
    "PROJECTS_BTN_CREATE": "Criar",
    "PROJECTS_BTN_CREATE_TOOLTIP": "Criar",
    "PROJECTS_TITLE_TEXT_RENAME": "Renomear",
    "PROJECTS_TITLE_TEXT_DELETE": "Excluir",
    "PROJECTS_TITLE_TEXT_EXPORT": "Exportar",
    "PROJECTS_CONFIRM_BTN_DELETE": "Excluir",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "Editado %d horas atrás",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "Editado agora mesmo",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "Editado %d minutos atrás",
    "PROJECTS_PROGRESS_TEXT_LOADING": "Carregando",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "Pesquisa",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "Você quer parar de importar?",
    "PROJECTS_TEXT_NOTHING_FOUND": "Nada encontrado",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "Criar um novo e belo projeto",
    "PROJECTS_TEXT_CAPTION": "Projetos",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "Nome do projeto",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "Clique para fazer upload ou arraste e solte um arquivo de projeto aqui",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "Você pode carregar apenas um arquivo por vez",
    "PROJECTS_PREFIX_TEXT_EDITED": "Editado",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "Tem certeza de que deseja excluir",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "Este projeto será excluído imediatamente. Você não pode desfazer essa ação.",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "Projeto",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "Somente um arquivo pode ser carregado",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "Extensão de arquivo inválida. Deve ser *.edl.zip",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "Digite seu valor",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "Criar uma pasta para este projeto em Mídia",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "Abrir Editor",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "Tente novamente",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "Selecione a taxa de quadros para o projeto",
    "PROJECTS_EXPORT_TITLE": "Exportar projeto",
    "PROJECTS_EXPORT_INPROGRESS": "Exportação em andamento...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "Incluir mídia",
    "PROJECTS_EXPORT_COMPLETE": "Exportação do projeto concluída",
    "PROJECTS_EXPORT_BTN_BROWSE": "Navegar",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "Baixar",
    "PROJECTS_EXPORT_BTN_COPY": "Copiar",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "Os arquivos de mídia são reproduzidos aqui",
    "PREVIEW_BTN_PREV_TOOLTIP": "Anterior",
    "PREVIEW_BTN_PREV": "Anterior",
    "PREVIEW_BTN_PLAY_TOOLTIP": "Reproduzir",
    "PREVIEW_BTN_PLAY": "Reproduzir",
    "PREVIEW_BTN_STOP_TOOLTIP": "Parar",
    "PREVIEW_BTN_STOP": "Parar",
    "PREVIEW_BTN_NEXT_TOOLTIP": "Próximo",
    "PREVIEW_BTN_NEXT": "Próximo",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "Volume",
    "PREVIEW_BTN_VOLUME": "Volume",
    "PREVIEW_BTN_FRAME_CAPTURE": "Quadro de captura",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "Quadro de captura",
    "PREVIEW_BTN_FULL_SCREEN": "Tela cheia",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "Tela cheia",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "Marcar em",
    "PREVIEW_BTN_MARK_IN": "Marcar em",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "Marcar",
    "PREVIEW_BTN_MARK_OUT": "Marcar",
    "PREVIEW_HEADER_TITLE_SOURCE": "Fonte",
    "PREVIEW_HEADER_TITLE_TIMELINE": "Linha do tempo",
    "PREVIEW_MODE_AUTO": "Automotivo",
    "PREVIEW_MODE_SOURCE": "Fonte",
    "PREVIEW_MODE_TIMELINE": "Linha do tempo",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "saída",
    "PUBLISH_SETTINGS_TITLE": "Título",
    "QR_CODE_DIALOG_TITLE": "Leia o código QR (válido por 24 horas)",
    "QR_CODE_LOAD_ERROR": "Erro! Não foi possível criar o código QR",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "Evite adicionar arquivos de vídeo com parâmetros de codificador diferentes à mesma linha do tempo",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "Ignorar incompatibilidade entre os parâmetros de quantização e os parâmetros de vídeo",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "Iniciar a renderização a partir do primeiro clipe",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "Perguntar o nome do arquivo de saída",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "Fechar configurações de publicação ao cancelar",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "Duração",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "Codec",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "Frame Rate",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - Estéreo",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "Resolução",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "Áudio",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "Tamanho (aproximado)",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "O link para o arquivo de transcodificação será perdido",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "Configurações de publicação",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "Renderização de vídeo concluída",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "Digite o nome",
    "SAVE_SETTINGS_BTN_RENDER_START": "Iniciar",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "Iniciar",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "Voltar para minha conta",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "Voltar para minha conta",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "Cancelar",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "Cancelar",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "Baixar",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "Baixar",
    "SAVE_SETTINGS_BTN_BROWSE": "Navegar",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "Navegar",
    "SAVE_SETTINGS_BTN_COPY": "Cópia",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "Cópia",
    "SAVE_SETTINGS_TEXT_TITLE": "Título",
    "SAVE_SETTINGS_TEXT_LOADING": "Carregando",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "Prepare as imagens",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "Este vídeo foi enviado para sua conta e deverá estar disponível em breve",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "Todos",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "Pesquisar",
    "SHOW_MY_MEDIA_POOL": "Mostrar minha galeria de mídia",
    "SHOW_PROJECT_MEDIA_POOL": "Mostrar mídia do projeto",
    "SHOW_EDITOR_HEADER": "Mostrar cabeçalho do editor",
    "SHOW_MENU_TABS": "Mostrar abas do menu",
    "SHOW_PREVIEW_SPLIT_BUTTON": "Mostrar botão de divisão da pré-visualização",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "Mostrar botões de alteração da pré-visualização",
    "SHOW_INOUT_POINTS_TIMELINE": "Mostrar pontos de entrada/saída da linha do tempo",
    "SHOW_INOUT_POINTS_SOURCE": "Mostrar pontos de entrada/saída da origem",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "Mostrar marcador de importação na linha do tempo vazia",
    "VIEW_SETTINGS_LANG": "Idioma",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "Descrição",
    "SETTINGS_HEAD_BTN_DELETE": "Excluir",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "Excluir",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "Selecionar o mesmo",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "Selecionar o mesmo",
    "SETTINGS_HEAD_BTN_CLOSE": "Fechar",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "Fechar",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "Largura",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "Altura",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "Manter a proporção de aspecto",
    "SETTINGS_BTN_FIT_TO_FRAME": "Ajustar ao quadro",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "Ajustar ao quadro",
    "SETTINGS_BTN_FILL_FRAME": "Preencher quadro",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "Preencher quadro",
    "SETTINGS_TEXT_AUTO": "Automotivo",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "Transformação de texto nenhuma",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "Transformação de texto nenhuma",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "Transformação de texto em maiúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "Transformação de texto em maiúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "Transformação de texto em minúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "Transformação de texto em minúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "Transformação de texto em maiúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "Transformação de texto em maiúsculas",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "Família de fontes",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "Família de fontes",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "Tamanho da fonte",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "Tamanho da fonte",
    "SETTINGS_TEXT_BTN_BOLD": "Negrito",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "Negrito",
    "SETTINGS_TEXT_BTN_ITALIC": "Itálico",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "Itálico",
    "SETTINGS_TEXT_BTN_UNDERLINE": "Sublinhado",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "Sublinhado",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "Esquerda",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "Esquerda",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "Direita",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "Direita",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "Centro",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "Centro",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "Justificar",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "Justificar",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "Superior",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "Superior",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "Superior esquerdo",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "Superior esquerdo",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "Superior direito",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "Superior direito",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "Esquerda",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "Esquerda",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "Centro do meio",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "Centro do meio",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "Direita",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "Direita",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "Esquerda  inferior",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "Esquerda inferior",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "Inferior",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "Inferior",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "Direito inferior",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "Direito inferior",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "Horizontal",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "Vertical",
    "SETTINGS_ROTATION_TEXT_ROTATE": "Girar",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "Inserir texto",
    "NABLET_HLD_PROJECT_POSTFIX": "destaques",
    "NABLET_HLD_CAPTION": "Detectar destaques",
    "NABLET_HLD_DETECTED_BTN_START": "Iniciar",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "Criar projeto(s)",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "Cancelar",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "Contagem de intervalos detectados:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "Tem certeza de que deseja encerrar a tarefa?",
    "NABLET_HLD_DETECTED_BTN_NO": "Não",
    "NABLET_HLD_DETECTED_BTN_YES": "Sim",
    "NB_HLD_STATUS_TEXT_DETECTING": "Detectando",
    "NABLET_HLD_TARGET_DURATION_SEC": "Duração alvo em segundos",
    "AI_MODEL": "Modelo de IA",
    "TRANSCRIBE_CAPTION": "Transcrever mídia",
    "TRANSCRIBE_PROJECT_POSTFIX": "transcrito",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "Transcrevendo",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "Quantidade de itens de texto:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "Criar projeto",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "Esta seção está em desenvolvimento",
    "TEXT_FORM_CAPTION_SIZE": "Tamanho",
    "TEXT_FORM_CAPTION_OUTLINE": "Esboço",
    "TEXT_FORM_CAPTION_FONT": "Fonte",
    "TEXT_FORM_CAPTION_SHADOW": "Sombra",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "Configurações de texto",
    "TEXT_FORM_TEXT_OFFSET": "Deslocamento",
    "TEXT_FORM_TEXT_BLUR": "Desfoque",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "Texto",
    "TIMELINE_TEXT_DRAG_N_DROP": "Arrastar e soltar",
    "TIMELINE_TEXT_ADD_LAYER": "#NAME?",
    "TIMELINE_TOOLBAR_BTN_UNDO": "Desfazer",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "Desfazer",
    "TIMELINE_TOOLBAR_BTN_REDO": "Refazer",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "Refazer",
    "TIMELINE_TOOLBAR_BTN_DELETE": "Excluir",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "Excluir",
    "TIMELINE_TOOLBAR_BTN_COPY": "Copiar clipe",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "Copiar clipe",
    "TIMELINE_TOOLBAR_BTN_CUT": "Cortar clipe(s)",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "Cortar clipe(s)",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "Adicionar marcador",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "Adicionar marcador",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "Colar",
    "TIMELINE_TOOLBAR_BTN_PASTE": "Colar",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "Configurações",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "Configurações",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "Locução",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "Locução",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "Câmera da Web",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "Câmera da Web",
    "TIMELINE_TOOLBAR_BTN_LIVE": "Transmissão ao vivo",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "Transmissão ao vivo",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "Clique para cancelar",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "Clique para cancelar",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "Arrastar e soltar",
    "TIMELINE_FOOTER_TEXT_DURATION": "Duração",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "Não foi possível publicar o projeto",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "A trilha de vídeo é necessária",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "Salvar",
    "TIMELINE_FOOTER_BTN_SAVE": "Salvar",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "Salvar",
    "TIMELINE_FOOTER_BTN_PUBLISH": "Publicar",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "Publicar",
    "TIMELINE_SLIDER_POINTER": "Ponteiro do controle deslizante",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "Ponteiro do controle deslizante",
    "TRANSITION_NAME_DISSOLVE": "Dissolver",
    "TRANSITION_NAME_FADE_IN": "Fade In",
    "TRANSITION_NAME_FADE_OUT": "Fade Out",
    "TRANSITION_NAME_DIP_TO_BLACK": "Mergulho para Preto",
    "TRANSITION_NAME_DIP_TO_WHITE": "Mergulho para Branco",
    "TRANSITION_NAME_BLUR": "Desfocar",
    "TRANSITION_NAME_WIPE_RIGHT": "Passar para a Direita",
    "TRANSITION_NAME_WIPE_LEFT": "Passar para a Esquerda",
    "TRANSITION_NAME_WIPE_UP": "Passar para Cima",
    "TRANSITION_NAME_WIPE_DOWN": "Passar para Baixo",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "Configurações de transição",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "Aplicar a todas as transições da linha do tempo",
    "TRANSITION_FORM_SELECTED": "selecionado:",
    "TRANSITION_FORM_LABEL_TYPE": "Tipo",
    "TRANSITION_FORM_LABEL_DURATION": "Duração (seg)",
    "TRANSITION_LIST_CAPTION_TRANSITION": "Transição",
    "used_in_projects": "O arquivo de mídia não foi excluído porque está em uso em um ou mais projetos. Se você continuar, o arquivo não estará disponível na linha do tempo nos projetos correspondentes e será excluído de sua conta.",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "Use a caixa de diálogo modal para importar arquivos locais",
    "VOICE_OVER_TITLE_LAST_RECORDING": "Última gravação",
    "VOICE_OVER_BTN_RETAKE": "Reto",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "Retomar",
    "VOICE_OVER_BTN_DELETE_FILE": "Excluir arquivo",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "Excluir arquivo",
    "VOICE_OVER_BTN_START_RECORDING": "Iniciar gravação",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "Iniciar gravação",
    "VOICE_OVER_BTN_CONNECTION": "Conexão...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "Conexão...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "O arquivo será excluído da linha do tempo e da mídia.",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "Tem certeza?",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "Narração de voz",
    "VOICE_OVER_TEXT_MIC": "Microfone",
    "VOICE_OVER_LABEL_SELECT_MIC": "Selecione o microfone",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "Sem áudio",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "Silenciar a linha do tempo durante a gravação",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "Controle deslizante de retrocesso no início após o registro",
    "VOICE_OVER_TEXT_COUNTDOWN": "Contagem regressiva",
    "VOICE_OVER_BTN_TEST_MIC": "Microfone de teste",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "Testar microfone",
    "VOICE_OVER_BTN_RECORDING": "Gravação...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "Gravando...",
    "VOICE_OVER_BTN_PLAYING": "Reproduzindo...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "Reproduzindo...",
    "VOICE_OVER_BTN_YES": "Sim",
    "VOICE_OVER_BTN_YES_TOOLTIP": "Sim",
    "VOICE_OVER_BTN_NO": "Não",
    "VOICE_OVER_BTN_NO_TOOLTIP": "Não",
    "VOICE_OVER_BTN_STOP": "Parar",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "Parar",
    "VOICE_OVER_BTN_DELETE": "Excluir",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "Excluir",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "Ajuste automático",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "Outras configurações",
    "WEBCAM_TEXT_RECORD_VIDEO": "Gravar vídeo",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "Gravar transmissão ao vivo",
    "LIVE_STREAM_URL_INPUT_LABEL": "URL da transmissão ao vivo",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "Clique aqui para acessar uma transmissão ao vivo",
    "LIVE_STREAM_BTN_CONNECTING": "Conectando...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "Conectando...",
    "LIVE_STREAM_BTN_CAPTURE": "Iniciar captura",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "Iniciar captura",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "Parar capture",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "Parar captura",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "Diminuir o zoom",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "Diminuir o zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "Aumentar o zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "Aumentar o zoom",
    "SETTINGS_HOTKEYS": "Configurações de teclas de atalho",
    "PRESET": "Predefinição",
    "DEFAULT": "Padrão",
    "ADD_NEW": "Adicionar novo",
    "SEARCH_COMMAND": "Comando de pesquisa",
    "COMMAND": "Comando",
    "SHORTCUTS": "Shortcuts",
    "ALL": "Todos",
    "TIMELINE": "Linha do tempo",
    "TOOLS": "Ferramentas",
    "PREVIEW": "Pré-visualização",
    "KEYBOARD_MAPPING_PRESET": "Predefinição de mapeamento de teclado",
    "ENTER_PRESET_NAME": "Digite o nome da predefinição",
    "THIS_PRESET_WILL_BE_DELETED": "Essa predefinição será excluída imediatamente. Você não pode desfazer essa ação.",
    "RESET_ALL_TO_DEFAULTS": "Redefinir tudo para os padrões",
    "HOTKEY_SETTINGS_UNDO": "Desfazer",
    "HOTKEY_SETTINGS_REDO": "Redo",
    "HOTKEY_SETTINGS_ZOOM_IN": "Zoom in",
    "HOTKEY_SETTINGS_ZOOM_OUT": "Zoom out",
    "HOTKEY_SETTINGS_PREV_FRAME": "Quadro anterior",
    "HOTKEY_SETTINGS_NEXT_FRAME": "Próximo quadro",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "Adicionar à linha do tempo",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "Aumentar o volume do clipe",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "Diminuir o volume do clipe",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "Ripple delete",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "Ripple trim anterior",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "Ripple trim next",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "Selecionar clipes na posição atual",
    "HOTKEY_SETTINGS_CUT_CLIPS": "Cortar clipe(s)",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "Reproduzir/Pausar",
    "HOTKEY_SETTINGS_DELETE": "Excluir",
    "HOTKEY_SETTINGS_COPY": "Copiar",
    "HOTKEY_SETTINGS_PASTE": "Colar",
    "HOTKEY_SETTINGS_PLAY": "Reproduzir",
    "HOTKEY_SETTINGS_PAUSE": "Pausar",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "Reproduzir o intervalo destacado",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "Limpar pontos de entrada e saída",
    "HOTKEY_SETTINGS_MARK_IN": "Marcar ponto de entrada",
    "HOTKEY_SETTINGS_MARK_OUT": "Marcar ponto de saída",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "Procurar entrar no ponto",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "Buscar o ponto de saída",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "Mover o controle deslizante para o próximo ponto de edição do clipe",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "Mover o controle deslizante para o ponto anterior de edição do clipe",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "Alternar minha mídia visível",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "Alternar configurações do editor visíveis",
    "CLIP_SETTINGS": "Configurações do clipe",
    "MESSAGE_BOX_INCOMPATIBLE": "Os arquivos não são compatíveis",
    "MESSAGE_BOX_REMOVE_EXISTING": "Os arquivos não são compatíveis (incompatibilidade de formato)",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "Os arquivos não são compatíveis (incompatibilidade de resolução)",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "Os arquivos não são compatíveis (incompatibilidade de taxa de quadros)",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "Os arquivos não são compatíveis (incompatibilidade de codecs)",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "Os arquivos não são compatíveis (incompatibilidade de formato de código de tempo DF/NDF)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "Os arquivos não são compatíveis (incompatibilidade de espaço de cores)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "Os arquivos não são compatíveis (incompatibilidade nos parâmetros do codificador de vídeo)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "O arquivo é incompatível (exclua o clipe offline)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "Modelos de transcrição não encontrados. Deseja baixar (~882 MB) e instalar?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "Modelos de detecção de destaques esportivos não encontrados. Deseja baixar (~3.9 GB) e instalar?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "A detecção de destaques esportivos requer NVIDIA GPU com capacidade de computação >= 7.5",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "Evite adicionar arquivos de vídeo com codecs, resoluções, FPS, código de tempo DF/NDF e espaço de cor diferentes à mesma linha do tempo",
    "MARKS_CONTEXT_MENU_MARK_IN": "Marcar entrada",
    "MARKS_CONTEXT_MENU_MARK_OUT": "Marcar saída",
    "MARKS_CONTEXT_MENU_CLEAR": "Limpar pontos de entrada/saída",
    "MEDIA_ERROR_build_thumbnails_error": "Erro de miniaturas de construção",
    "MEDIA_ERROR_unsupported_media": "Mídia não suportada",
    "MEDIA_ERROR_exceeded_file_size": "Tamanho de arquivo excedido",
    "MEDIA_ERROR_exceeded_per_user_size": "Tamanho por usuário excedido",
    "MEDIA_ERROR_low_disk_space": "Pouco espaço em disco",
    "MEDIA_ERROR_internal_server_error": "Erro interno do servidor",
    "MEDIA_ERROR_network_error": "Erro de rede",
    "MEDIA_ERROR_not_found": "Arquivo de mídia não encontrado",
    "MEDIA_ERROR_unable_get_media_info": "Não foi possível obter informações sobre a mídia",
    "MEDIA_ERROR_not_enough_tokens": "Bunun üçün kifayət qədər token yoxdur",
  },
  de: {
    "ADD_FOLDER_BTN": "Ordner hinzufügen",
    "ADD_FOLDER_BTN_TOOLTIP": "Ordner hinzufügen",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "Füge die erste importierte Datei zum Startzeitcode der Quelle zur Zeitleiste hinzu",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "Änderung des Zeitachsen-/Medienlayouts zulassen",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "Bucket Name",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "Zugriffsschlüssel-ID",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "Geheimer Schlüssel",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "Importieren",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "Importfehler",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "Erfolgreich importiert",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "Medien aus AWS Bucket importieren",
    "AMAZON_IMPORT_BTN_IMPORT": "Importieren",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "Importieren",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "Fragen Sie nach dem Projektnamen bei „Neues Projekt“",
    "AUDIO_CAPTION_AUDIO": "Audio",
    "AUDIO_TEXT_FOUND_ITEMS": "Gefundene Elemente",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "Keine Ergebnisse gefunden",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "Es scheint, dass wir keine Ergebnisse zu Ihrer Suche finden konnten.",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "Audio-Einstellungen",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "Ton",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "Transition",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "Einblendung (sek.)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "Ausblenden (sek.)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "Genre suchen",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "Musik suchen",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "Klangeffekte suchen",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "Suche in",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "Musik nach Genre",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "Toneffekte",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "Musik nach Stimmungen",
    "AUDIO_MENU_ITEM_ALL": "Alle",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "Übergänge",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "Ausgewähltes Medium automatisch abspielen",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "Asset aus der Zeitleiste entfernen?",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "Timecode-Format je nach Medium einstellen",
    "BATCH_IMPORT_FILES_HEAD": "Dateien importieren",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "Analyse",
    "CAPTION_ADDED": "Hinzugefügt",
    "CAPTION_SKIPPED": "Übersprungen",
    "COLOR_PICKER_BTN_COLOR": "Farbe auswählen",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "Farbe auswählen",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "Hintergrundfarbe",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "Hintergrundfarbe",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "Mediendateien werden heruntergeladen",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "Mediendateien importieren",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "Gespeicherte Medien hochladen",
    "COMMON_STATUS_TEXT_ABORTED": "Abgebrochen",
    "COMMON_STATUS_TEXT_LOADING": "Laden",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "Der Vorgang wird in die Warteschlange gestellt",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "Bilder vorbereiten",
    "COMMON_STATUS_TEXT_RENDERING": "Rendering",
    "COMMON_STATUS_TEXT_CONVERT": "Konvertieren",
    "COMMON_YES": "Ja",
    "COMMON_NO": "Nein",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "Alle Änderungen zurücksetzen",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "Abbrechen",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "Abbrechen",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "Benutzer-Avatar",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "Sie können eine Datei mit dem Standard-Benutzeravatar hochladen.",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "Avatar",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "Farbthema",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "Benutzerdefiniertes JS-Skript",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "Benutzerdefinierter Text",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "Sie können den Text des Editors anpassen",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "Dieses Skript wird beim Laden des Editors ausgeführt. Kann für die Integration von Analysen usw. verwendet werden",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "JS-Skript bearbeiten",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "Zweite Akzentfarbe",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "Wählen Sie die Farbe des Haupthintergrunds aus.",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "Die Haupt-Akzentfarbe für die Steuerelemente. Wählen Sie hier Ihre Markenfarbe aus.",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "Zusätzliche Farbe der Steuerelemente im Paar mit der Hauptfarbe der Schaltflächen",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "Die Audiodatei auf der Zeitachse hat ihren eigenen Stil.",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "Sie können eine Datei mit Ihrem Logo hochladen.",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "Die Voiceover-Datei hat ihren eigenen Stil.",
    "CUSTOMIZATION_LABEL_DISPLAYED": "angezeigt",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "Wählen Sie eines der vordefinierten Themes oder erstellen Sie Ihr eigenes. Sie können die CSS-Datei bearbeiten, um Ihr Thema anzupassen.",
    "CUSTOMIZATION_TITLE_BASIC_BG": "Grundlegender Hintergrund",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "Primäre Schaltflächen, Links",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "CSS-Datei für Theme bearbeiten",
    "CUSTOMIZATION_TITLE_AUDIO": "Audio",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "Voice over",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "Textwerte bearbeiten",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "Textwerte bearbeiten",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "Textwerte bearbeiten",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "Formatbeschreibung",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "Formatbeschreibung",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "Alle Änderungen zurücksetzen",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "Alle Änderungen zurücksetzen",
    "CUSTOMIZATION_BTN_CANCEL": "Abbrechen",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "Abbrechen",
    "CUSTOMIZATION_BTN_SAVE": "Speichern",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "Speichern",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "JS-Skript bearbeiten",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "JS-Skript bearbeiten",
    "CUSTOMIZATION_BTN_EDIT_CSS": "CSS bearbeiten",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "CSS bearbeiten",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "Logo hochladen",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "Logo hochladen",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "Logo löschen",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "Logo löschen",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "Dunkles Thema",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "Helles Thema",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "Benutzerdefiniertes Thema",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "Logo",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "Logo",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "Editor anpassen",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "Logo und Name",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "Firmenname",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "Name des Editors",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "Akzeptierte Dateien:",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "Kein hochgeladenes Logo",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "Einstellungen anzeigen",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "Ansichtseinstellungen",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "Filter",
    "DUMMY_HEADER_BTN_FILTERS": "Filter",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Projekt speichern unter...",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "Admin-Bereich",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "Neues Projekt",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "Veröffentlichen",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "Editor anpassen",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Adobe-CEP-Erweiterungen",
    "EDITOR_MENU_MAIN_LOGS": "Protokolle",
    "EDITOR_MENU_MAIN_SETTINGS": "Einstellungen",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "Kann nicht veröffentlicht werden",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "Titel ist erforderlich",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "Render-Einstellungen",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "Verhalten",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "Ansicht",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "Speichern",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "Abbrechen",
    "FILE_INPUT_BTN": "Dateieingabe",
    "FILE_INPUT_BTN_TOOLTIP": "Dateieingabe",
    "FORM_FIELD_LABEL_VOLUME": "Volumen",
    "folder_not_empty": "Der Ordner ist nicht leer. Die Dateien können in Projekten verwendet werden. Wenn Sie fortfahren, wird die Datei nicht auf der Zeitachse der entsprechenden Projekte verfügbar sein.",
    "HEAD_CONTROL_IMPORT_TEXT": "Importieren",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "Medien importieren",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "Vom Handy importieren",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "Ordner mit Medien importieren",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Amazon S3 Bucket",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Google Drive",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "URL-Eingabe",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Projekt speichern unter...",
    "HEADER_MENU_LIST_ITEM_DELETE": "Löschen",
    "HEADER_MENU_LIST_ITEM_RENAME": "Umbenennen",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "Lizenzschlüssel hinzufügen",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "Abmelden",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "Wollen Sie den Editor verlassen?",
    "HEADER_BTN_BACK_TO_MY_ACC": "Zurück zu meinem Konto",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "Zurück zu meinem Konto",
    "HEADER_BTN_HELP": "Hilfe",
    "HEADER_BTN_HELP_TOOLTIP": "Hilfe",
    "IMAGES_TEXT_NATIVE_IMAGES": "Natives Bild",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "Bilder",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "Suchen in",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "Sammlung auswählen",
    "IMAGES_TEXT_ALL_CATEGORIES": "Alle Sammlungen",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "Keine Ergebnisse gefunden",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "Es scheint, dass wir keine Ergebnisse zu Ihrer Suche finden konnten.",
    "IMAGES_TAB_AI_GENERATED": "Ai-Generiert",
    "IMAGES_TAB_SEARCH": "Suche",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "Medien von URL importieren",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "Klicken Sie hier, um auf eine Datei zu verlinken",
    "IMPORT_FROM_URL_BTN_IMPORT": "Importieren",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "Importieren",
    "IMPORT_TOKEN_INVALID": "Import-Token ungültig",
    "LAYER_CONTROL_BTN_MOVE_UP": "Nach oben bewegen",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "Nach oben bewegen",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "Ebene ziehen",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "Ebene ziehen",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "Nach unten bewegen",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "Nach unten bewegen",
    "LAYER_CONTROL_BTN_DELETE": "Löschen",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "Löschen",
    "LAYER_CONTROL_BTN_HIDE": "Ausblenden",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "Ausblenden",
    "LAYER_CONTROL_BTN_SHOW": "Anzeigen",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "Anzeigen",
    "LAYER_CONTROL_BTN_MUTE": "Stumm",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "Stumm",
    "LAYER_CONTROL_BTN_UNMUTE": "Stummschaltung aufheben",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "Stummschaltung aufheben",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "Meine Medien",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "Meine Medien",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "Projektmedien",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "Projektmedien",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "Übergänge",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "Übergänge",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "Bilder",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "Bilder",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "Text",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "Text",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "Design",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "Design",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "Filter",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "Filter",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "Filter",
    "MEDIA_API_IS_NOT_AVAILABLE": "Fehler: Voiceover WebAPI erfordert https",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "Bildeinstellungen",
    "MEDIA_FORM_CAPTION_POSITION": "Position",
    "MEDIA_FORM_CAPTION_ROTATION": "Rotation",
    "MEDIA_FORM_CAPTION_SETTINGS": "Einstellungen",
    "MEDIA_FORM_CAPTION_OUTLINE": "Gliederung",
    "MEDIA_FORM_CAPTION_SHADOW": "Schatten",
    "MEDIA_FORM_CAPTION_SIZE": "Größe",
    "MEDIA_FORM_CAPTION_VIDEO": "Video",
    "MEDIA_FORM_CAPTION_AUDIO": "Audio",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "Opazität",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "Filter",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "Filter",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "Alle",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "Video",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "Bild",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "Audio",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "Mappe",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "Voiceover",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "Ansichtseinstellungen",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "Ansichtseinstellungen",
    "MEDIA_UPLOADER_TEXT_OR": "oder",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "Ziehen Sie Ihre Medien hierher und legen Sie sie ab",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "Medien importieren",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "Importieren",
    "MEDIA_PREVIEW_TEXT_RENDERING": "Rendering",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "Auflösung",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "Drehung in Grad",
    "MEDIA_INFO_LIST_ITEM_CODEC": "Codecs",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "Farbraum",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "Bildrate",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - Stereo",
    "MEDIA_INFO_LIST_ITEM_DURATION": "Dauer",
    "MEDIA_INFO_LIST_ITEM_TYPE": "Typ",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "Audio",
    "MEDIA_INFO_LIST_ITEM_SIZE": "Größe",
    "MEDIA_INFO_LIST_TASK_STATUS": "Aufgabenstatus",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "Start-Timecode",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "Parameter für den Video-Encoder",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "Meine Medien",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "Projektmedien",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "Mehr Medien laden",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "Mehr Medien laden",
    "MEDIA_BTN_LOADING": "Laden",
    "MEDIA_BTN_LOADING_TOOLTIP": "Laden",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "Chroma-Schlüssel",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "Position",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "Ton",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "SIZE",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "Medieneinstellungen",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "Alle Einstellungen zurücksetzen",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "Alle Einstellungen zurücksetzen",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "Ähnlichkeit",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "Glattheit",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "Key Color Spill Reduction",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "Farbe aus der Vorschau auswählen",
    "MEDIA_SORT_OPTION_DURATION": "Dauer",
    "MEDIA_SORT_OPTION_DATE": "Datum",
    "MEDIA_SORT_OPTION_SIZE": "Größe",
    "MEDIA_SORT_OPTION_NAME": "Name",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "Sortieren nach",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "Reihenfolge",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "Ansicht",
    "MEDIA_SORT_OPTION_ASCENDING": "Aufsteigend",
    "MEDIA_SORT_OPTION_DESCENDING": "Absteigend",
    "MEDIA_SORT_OPTION_LIST": "Liste",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "Große Symbole",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "Meine Aufnahmen",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "Meine Aufnahmen",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "Meine Medien",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "Meine Medien",
    "MEDIA_FILES_DELETE_FORM_TITLE": "Einige Dateien werden von Projekten verwendet und wurden nicht entfernt",
    "MEDIA_FILES_DELETE_FORM_DESC": "Die ausgewählten Dateien werden aus der Medienbibliothek gelöscht und sind nicht mehr in Projekten verfügbar.",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "In den Projekten verwendete Dateien",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "Alle auswählen",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "Sind Sie sicher, dass Sie das/die ausgewählte(n) Element(e) entfernen möchten?",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "Nach Ordner suchen",
    "MEDIA_CONFIRM_BTN_DELETE": "Löschen",
    "MEDIA_CANCEL_BTN_DELETE": "Abbrechen",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "Löschen",
    "MEDIA_CONFIRM_TITLE_DELETE": "Löschen",
    "MEDIA_TEXT_LOADING": "Laden",
    "MEDIA_BTN_ADD": "Hinzufügen",
    "MEDIA_BTN_ADD_TOOLTIP": "Hinzufügen",
    "MEDIA_PROGRESS_TEXT_LOADING": "Laden",
    "MEDIA_PROGRESS_TEXT_SAVING": "Speichern",
    "MEDIA_PROGRESS_TEXT_CONVERT": "Konvertieren",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "Übertragung",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "Analyse",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "Ordner auswählen",
    "MEDIA_MENU_ITEM_MEDIA": "Medien",
    "MEDIA_MENU_ITEM_MOVE_TO": "Verschieben nach",
    "MEDIA_MENU_ITEM_SETTINGS": "Einstellungen",
    "MEDIA_MENU_ITEM_NABLET_HLD": "Sport-Highlights erkennen",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "Transkribieren",
    "MEDIA_MENU_ITEM_DELETE": "Löschen",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "Ausgewählte Clips löschen",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "Medien durchsuchen",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "Medienadresse kopieren",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "Hinzufügen mit Start-Timecode",
    "MEDIA_MENU_LABEL_MOVE_TO": "Verschieben nach",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "HTML5 Video Editor",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "Tablets und Handys werden noch nicht unterstützt :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "Video Editor funktioniert gut auf Ihrem Computer",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "Zurück zur Website",
    "MOBILE_UPLOAD_TITLE": "Upload files to Speicher von user",
    "MOBILE_UPLOAD_SUBTITLE": "Supports: video, audio, photo. Your files will be saved in Speicher von user",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "Um die Sprache zu wechseln, müssen Sie die Anwendung neu starten",
    "MODAL_WINDOW_LOGS_TITLE": "Um die Protokolle ein- oder auszuschalten, müssen Sie die Anwendung neu starten",
    "MODAL_WINDOW_INSTALL_COMPONENT_TITLE": "Die angeforderte Komponente wurde installiert. Sie müssen die Anwendung neu starten",
    "MESSAGE_BOX_INSTALL_RUNNING": "Eine andere Installation wird ausgeführt.\nBitte warten Sie, bis sie abgeschlossen ist.",
    "MESSAGE_BOX_INSTALL_FAILED": "Die Installation konnte nicht ausgeführt werden. Details finden Sie in den Protokollen",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "Wählen Sie eine Referenzdatei",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "Sie fügen Dateien mit unterschiedlichen FPS/Auflösung/Codec hinzu. Wählen Sie die Datei, deren Eigenschaften auf das Projekt angewendet werden sollen",
    "MODAL_WINDOW_BUTTON_RESTART": "Neustart",
    "MUTE_AUDIO_AT_CREATED_LAYERS": 'Stummschalten von Audio auf erstellten Ebenen',
    "NAVIGATION_TAB_EDITOR": "Editor",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "Editor",
    "NAVIGATION_TAB_PROJECTS": "Projekte",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "Projekte",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "Keine Netzwerkverbindung",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "Zuletzt gespeichert",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "min ago",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "gerade jetzt",
    "PROJECTS_BTN_NEW_PROJECTS": "Neues Projekt",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "Neues Projekt",
    "PROJECTS_BTN_NEW_PROJECT": "Neues Projekt",
    "PROJECTS_BTN_IMPORT": "Importieren",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "Importieren",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "Ja",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "Abbrechen",
    "PROJECTS_TITLE_TEXT_COPY": "Kopie",
    "PROJECTS_BTN_SAVE": "Speichern",
    "PROJECTS_BTN_SAVE_TOOLTIP": "Speichern",
    "PROJECTS_BTN_CREATE": "Erstellen",
    "PROJECTS_BTN_CREATE_TOOLTIP": "Erstellen",
    "PROJECTS_TITLE_TEXT_RENAME": "Umbenennen",
    "PROJECTS_TITLE_TEXT_DELETE": "Löschen",
    "PROJECTS_TITLE_TEXT_EXPORT": "Exportieren",
    "PROJECTS_CONFIRM_BTN_DELETE": "Löschen",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "Bearbeitet %d vor Stunden",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "Bearbeitet gerade jetzt",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "Bearbeitet %d vor Minuten",
    "PROJECTS_PROGRESS_TEXT_LOADING": "Laden",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "Suche",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "Möchten Sie den Import stoppen?",
    "PROJECTS_TEXT_NOTHING_FOUND": "Nichts gefunden",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "Erstellen Sie ein schönes neues Projekt",
    "PROJECTS_TEXT_CAPTION": "Projekte",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "Projektname",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "Klicken Sie zum Hochladen oder ziehen Sie eine Projektdatei hierher",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "Sie können jeweils nur eine Datei hochladen",
    "PROJECTS_PREFIX_TEXT_EDITED": "Bearbeitet",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "Sind Sie sicher, dass Sie löschen wollen",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "Dieses Projekt wird sofort gelöscht. Sie können diese Aktion nicht rückgängig machen.",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "Projekt",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "Es kann nur eine Datei hochgeladen werden",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "Ungültige Dateierweiterung. Sollte *.edl.zip sein",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "Geben Sie Ihren Wert ein",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "Erstellen Sie einen Ordner für dieses Projekt in Media",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "Editor öffnen",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "Erneut versuchen",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "Bildrate für das Projekt auswählen",
    "PROJECTS_EXPORT_TITLE": "Projekt exportieren",
    "PROJECTS_EXPORT_INPROGRESS": "Export wird durchgeführt...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "Medien einbeziehen",
    "PROJECTS_EXPORT_COMPLETE": "Projekt-Export abgeschlossen",
    "PROJECTS_EXPORT_BTN_BROWSE": "Durchsuchen",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "Herunterladen",
    "PROJECTS_EXPORT_BTN_COPY": "Kopieren",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "Dateien aus Medien werden hier wiedergegeben",
    "PREVIEW_BTN_PREV_TOOLTIP": "Vorherige",
    "PREVIEW_BTN_PREV": "Vorherige",
    "PREVIEW_BTN_PLAY_TOOLTIP": "Abspielen",
    "PREVIEW_BTN_PLAY": "Abspielen",
    "PREVIEW_BTN_STOP_TOOLTIP": "Stopp",
    "PREVIEW_BTN_STOP": "Stopp",
    "PREVIEW_BTN_NEXT_TOOLTIP": "Weiter",
    "PREVIEW_BTN_NEXT": "Weiter",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "Volumen",
    "PREVIEW_BTN_VOLUME": "Lautstärke",
    "PREVIEW_BTN_FRAME_CAPTURE": "Frame erfassen",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "Frame erfassen",
    "PREVIEW_BTN_FULL_SCREEN": "Vollbild",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "Vollbild",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "Markieren in",
    "PREVIEW_BTN_MARK_IN": "Markieren in",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "Abgrenzung",
    "PREVIEW_BTN_MARK_OUT": "Abgrenzung",
    "PREVIEW_HEADER_TITLE_SOURCE": "Quelle",
    "PREVIEW_HEADER_TITLE_TIMELINE": "Zeitleiste",
    "PREVIEW_MODE_AUTO": "Auto",
    "PREVIEW_MODE_SOURCE": "Quelle",
    "PREVIEW_MODE_TIMELINE": "Zeitleiste",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "Ausgabe",
    "PUBLISH_SETTINGS_TITLE": "Titel",
    "QR_CODE_DIALOG_TITLE": "Scannen Sie den QR-Code (24 Stunden gültig)",
    "QR_CODE_LOAD_ERROR": "Fehler! Der QR-Code konnte nicht erstellt werden",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "Verhindern Sie, dass Videodateien mit unterschiedlichen Codierungsparametern zur selben Zeitleiste hinzugefügt werden",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "Abweichung zwischen Quantisierungs- und Videoparametern ignorieren",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "Beginnen Sie das Rendering mit dem ersten Clip",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "Nach Ausgabedateinamen fragen",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "Veröffentlichungseinstellungen beim Abbrechen schließen",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "Dauer",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "Codec",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "Bildrate",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - Stereo",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "Auflösung",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "Audio",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "Größe (ungefähr)",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "Link zur Transkodierungsdatei wird verloren gehen",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "Einstellungen veröffentlichen",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "Video-Rendering abgeschlossen",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "Name eingeben",
    "SAVE_SETTINGS_BTN_RENDER_START": "Start",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "Start",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "Zurück zu meinem Konto",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "Zurück zu meinem Konto",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "Abbrechen",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "Abbrechen",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "Herunterladen",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "Herunterladen",
    "SAVE_SETTINGS_BTN_BROWSE": "Durchsuchen",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "Durchsuchen",
    "SAVE_SETTINGS_BTN_COPY": "Kopieren",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "Kopieren",
    "SAVE_SETTINGS_TEXT_TITLE": "Titel",
    "SAVE_SETTINGS_TEXT_LOADING": "Laden",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "Bilder vorbereiten",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "Dieses Video wurde an Ihr Konto übermittelt und sollte bald verfügbar sein.",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "Alle",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "Suche",
    "SHOW_MY_MEDIA_POOL": "Meine Medienbibliothek anzeigen",
    "SHOW_PROJECT_MEDIA_POOL": "Projektmedienpool anzeigen",
    "SHOW_EDITOR_HEADER": "Editor-Kopfzeile anzeigen",
    "SHOW_MENU_TABS": "Menüregister anzeigen",
    "SHOW_PREVIEW_SPLIT_BUTTON": "Vorschau-Teilungs-Button anzeigen",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "Vorschau-Umschalt-Buttons anzeigen",
    "SHOW_INOUT_POINTS_TIMELINE": "Zeitachsen-Ein-/Ausgangspunkte anzeigen",
    "SHOW_INOUT_POINTS_SOURCE": "Quellen-Ein-/Ausgangspunkte anzeigen",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "Import-Platzhalter auf leerer Timeline anzeigen",
    "VIEW_SETTINGS_LANG": "Sprache",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "Beschreibung",
    "SETTINGS_HEAD_BTN_DELETE": "Löschen",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "Löschen",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "Gleich auswählen",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "Gleich auswählen",
    "SETTINGS_HEAD_BTN_CLOSE": "Schließen",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "Schließen",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "Breite",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "Höhe",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "Das Seitenverhältnis beibehalten",
    "SETTINGS_BTN_FIT_TO_FRAME": "An Rahmen anpassen",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "An Rahmen anpassen",
    "SETTINGS_BTN_FILL_FRAME": "Rahmen ausfüllen",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "Rahmen ausfüllen",
    "SETTINGS_TEXT_AUTO": "auto",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "Texttransformation keine",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "Texttransformation keine",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "Texttransformation in Großbuchstaben",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "Texttransformation in Großbuchstaben",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "Texttransformation Kleinbuchstaben",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "Texttransformation Kleinbuchstaben",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "Texttransformation Großbuchstaben",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "Texttransformation groß schreiben",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "Schriftfamilie",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "Schriftfamilie",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "Schriftgröße",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "Schriftgröße",
    "SETTINGS_TEXT_BTN_BOLD": "Fett",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "Fett",
    "SETTINGS_TEXT_BTN_ITALIC": "Kursiv",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "Kursiv",
    "SETTINGS_TEXT_BTN_UNDERLINE": "Unterstreichen",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "Unterstreichen",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "Links",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "Links",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "Rechts",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "Rechts",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "Mitte",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "Mitte",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "Ausrichten",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "Ausrichten",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "Oben",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "Oben",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "Oben links",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "Oben links",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "Oben rechts",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "Oben rechts",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "Links",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "Links",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "Mittlere Mitte",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "Mittlere Mitte",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "Rechts",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "Rechts",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "Unten links",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "Unten links",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "Unten",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "Unten",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "Unten",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "Unten rechts",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "Horizontal",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "Vertikal",
    "SETTINGS_ROTATION_TEXT_ROTATE": "Drehen",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "Text eingeben",
    "NABLET_HLD_PROJECT_POSTFIX": "Highlights",
    "NABLET_HLD_CAPTION": "Highlights erkennen",
    "NABLET_HLD_DETECTED_BTN_START": "Starten",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "Projekt(e) erstellen",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "Abbrechen",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "Erkannte Intervallanzahl:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "Möchten Sie die Aufgabe wirklich beenden?",
    "NABLET_HLD_DETECTED_BTN_NO": "Nein",
    "NABLET_HLD_DETECTED_BTN_YES": "Ja",
    "NB_HLD_STATUS_TEXT_DETECTING": "Erkennung läuft",
    "NABLET_HLD_TARGET_DURATION_SEC": "Zielzeit in Sekunden",
    "AI_MODEL": "KI-Modell",
    "TRANSCRIBE_CAPTION": "Medien transkribieren",
    "TRANSCRIBE_PROJECT_POSTFIX": "transkribiert",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "Transkribiere",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "Anzahl der Textelemente:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "Projekt erstellen",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "Dieser Abschnitt befindet sich in der Entwicklung",
    "TEXT_FORM_CAPTION_SIZE": "Größe",
    "TEXT_FORM_CAPTION_OUTLINE": "Gliederung",
    "TEXT_FORM_CAPTION_FONT": "Schriftart",
    "TEXT_FORM_CAPTION_SHADOW": "Schatten",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "Texteinstellungen",
    "TEXT_FORM_TEXT_OFFSET": "Versatz",
    "TEXT_FORM_TEXT_BLUR": "Unschärfe",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "Text",
    "TIMELINE_TEXT_DRAG_N_DROP": "Ziehen und Ablegen",
    "TIMELINE_TEXT_ADD_LAYER": "+ Ebene hinzufügen",
    "TIMELINE_TOOLBAR_BTN_UNDO": "Rückgängig",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "Rückgängig",
    "TIMELINE_TOOLBAR_BTN_REDO": "Wiederholen",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "Wiederholen",
    "TIMELINE_TOOLBAR_BTN_DELETE": "Löschen",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "Löschen",
    "TIMELINE_TOOLBAR_BTN_COPY": "Clip kopieren",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "Clip kopieren",
    "TIMELINE_TOOLBAR_BTN_CUT": "Clip(s) ausschneiden",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "Clip(s) ausschneiden",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "Markierung hinzufügen",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "Markierung hinzufügen",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "Einfügen",
    "TIMELINE_TOOLBAR_BTN_PASTE": "Einfügen",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "Einstellungen",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "Einstellungen",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "Voice Over",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "Voice Over",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "Webkamera",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "Webkamera",
    "TIMELINE_TOOLBAR_BTN_LIVE": "Livestream",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "Livestream",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "Zum Abbrechen klicken",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "Zum Abbrechen klicken",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "Ziehen und Ablegen",
    "TIMELINE_FOOTER_TEXT_DURATION": "Dauer",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "Projekt kann nicht veröffentlicht werden",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "Videospur ist erforderlich",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "Speichern",
    "TIMELINE_FOOTER_BTN_SAVE": "Speichern",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "Speichern",
    "TIMELINE_FOOTER_BTN_PUBLISH": "Veröffentlichen",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "Veröffentlichen",
    "TIMELINE_SLIDER_POINTER": "Schieberegler-Zeiger",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "Schieberegler-Zeiger",
    "TRANSITION_NAME_DISSOLVE": "Überblenden",
    "TRANSITION_NAME_FADE_IN": "Einblenden",
    "TRANSITION_NAME_FADE_OUT": "Ausblenden",
    "TRANSITION_NAME_DIP_TO_BLACK": "Schwarz einblenden",
    "TRANSITION_NAME_DIP_TO_WHITE": "Weiß einblenden",
    "TRANSITION_NAME_BLUR": "Weichzeichnen",
    "TRANSITION_NAME_WIPE_RIGHT": "Nach rechts wischen",
    "TRANSITION_NAME_WIPE_LEFT": "Nach links wischen",
    "TRANSITION_NAME_WIPE_UP": "Nach oben wischen",
    "TRANSITION_NAME_WIPE_DOWN": "Nach unten wischen",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "Einstellungen für den Übergang",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "Auf alle Übergänge in der Zeitleiste anwenden",
    "TRANSITION_FORM_SELECTED": "ausgewählt:",
    "TRANSITION_FORM_LABEL_TYPE": "Typ",
    "TRANSITION_FORM_LABEL_DURATION": "Dauer (sek.)",
    "TRANSITION_LIST_CAPTION_TRANSITION": "Übergang",
    "used_in_projects": "Die Mediendatei wurde nicht gelöscht, da sie in einem oder mehreren Projekten verwendet wird. Wenn Sie fortfahren, ist die Datei in den entsprechenden Projekten auf der Zeitachse nicht mehr verfügbar und wird aus Ihrem Konto gelöscht.",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "Modalen Dialog zum Importieren lokaler Dateien verwenden",
    "VOICE_OVER_TITLE_LAST_RECORDING": "Letzte Aufnahme",
    "VOICE_OVER_BTN_RETAKE": "Wiederholung",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "Wiederholung",
    "VOICE_OVER_BTN_DELETE_FILE": "Datei löschen",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "Datei löschen",
    "VOICE_OVER_BTN_START_RECORDING": "Aufnahme starten",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "Aufnahme starten",
    "VOICE_OVER_BTN_CONNECTION": "Connection...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "Verbindung...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "Die Datei wird aus der Zeitleiste und den Medien gelöscht.",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "Sind Sie sicher?",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "Sprachnotiz",
    "VOICE_OVER_TEXT_MIC": "Mikrofon",
    "VOICE_OVER_LABEL_SELECT_MIC": "Mikrofon auswählen",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "Kein Ton",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "Stummschalten der Zeitleiste während der Aufnahme",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "Schieberegler für das Zurückspulen am Anfang nach der Aufnahme",
    "VOICE_OVER_TEXT_COUNTDOWN": "Countdown",
    "VOICE_OVER_BTN_TEST_MIC": "Test Mic",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "Test Mic",
    "VOICE_OVER_BTN_RECORDING": "Recording...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "Recording...",
    "VOICE_OVER_BTN_PLAYING": "Playing...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "Playing...",
    "VOICE_OVER_BTN_YES": "Ja",
    "VOICE_OVER_BTN_YES_TOOLTIP": "Ja",
    "VOICE_OVER_BTN_NO": "Nein",
    "VOICE_OVER_BTN_NO_TOOLTIP": "Nein",
    "VOICE_OVER_BTN_STOP": "Stop",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "Stopp",
    "VOICE_OVER_BTN_DELETE": "Löschen",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "Löschen",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "Automatische Anpassung",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "Andere Einstellungen",
    "WEBCAM_TEXT_RECORD_VIDEO": "Video aufzeichnen",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "Livestream URL",
    "LIVE_STREAM_URL_INPUT_LABEL": "Live stream url",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "Klicken Sie hier, um zu einem Livestream zu gelangen",
    "LIVE_STREAM_BTN_CONNECTING": "Verbinden...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "Verbinden...",
    "LIVE_STREAM_BTN_CAPTURE": "Aufnahme starten",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "Aufnahme starten",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "Aufnahme beenden",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "Aufnahme beenden",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "Zoom verkleinern",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "Zoom verkleinern",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "Zoom erhöhen",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "Zoom vergrößern",
    "SETTINGS_HOTKEYS": "Einstellungen für Hotkeys",
    "PRESET": "Voreinstellung",
    "DEFAULT": "Standard",
    "ADD_NEW": "Neu hinzufügen",
    "SEARCH_COMMAND": "Suchbefehl",
    "COMMAND": "Befehl",
    "SHORTCUTS": "Abkürzungen",
    "ALL": "Alle",
    "TIMELINE": "Zeitleiste",
    "TOOLS": "Werkzeuge",
    "PREVIEW": "Vorschau",
    "KEYBOARD_MAPPING_PRESET": "Voreinstellung für Tastaturbelegung",
    "ENTER_PRESET_NAME": "Voreinstellungsname eingeben",
    "THIS_PRESET_WILL_BE_DELETED": "Diese Voreinstellung wird sofort gelöscht. Sie können diese Aktion nicht rückgängig machen.",
    "RESET_ALL_TO_DEFAULTS": "Alles auf Standardwerte zurücksetzen",
    "HOTKEY_SETTINGS_UNDO": "Rückgängig",
    "HOTKEY_SETTINGS_REDO": "Wiederholen",
    "HOTKEY_SETTINGS_ZOOM_IN": "Vergrößern",
    "HOTKEY_SETTINGS_ZOOM_OUT": "Herauszoomen",
    "HOTKEY_SETTINGS_PREV_FRAME": "Vorheriges Bild",
    "HOTKEY_SETTINGS_NEXT_FRAME": "Nächstes Bild",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "Zur Zeitleiste hinzufügen",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "Clip-Lautstärke erhöhen",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "Clip-Lautstärke verringern",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "Ripple löschen",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "Ripple schneiden vorheriges Element",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "Ripple schneiden nächstes Element",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "Clips an aktueller Position auswählen",
    "HOTKEY_SETTINGS_CUT_CLIPS": "Clip(s) ausschneiden",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "Abspielen/Pause",
    "HOTKEY_SETTINGS_DELETE": "Löschen",
    "HOTKEY_SETTINGS_COPY": "Kopieren",
    "HOTKEY_SETTINGS_PASTE": "Einfügen",
    "HOTKEY_SETTINGS_PLAY": "Abspielen",
    "HOTKEY_SETTINGS_PAUSE": "Pause",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "Abspielen des markierten Intervalls",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "Klare In-Out-Punkte",
    "HOTKEY_SETTINGS_MARK_IN": "Markieren Sie den Eingangspunkt",
    "HOTKEY_SETTINGS_MARK_OUT": "Markierung des Out-Points",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "In-Punkt anstreben",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "Suche nach Out-Point",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "Den Schieberegler zum nächsten Bearbeitungspunkt des Clips verschieben",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "Den Schieberegler zum vorherigen Bearbeitungspunkt des Clips verschieben",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "Meine Medien sichtbar umschalten",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "Editor-Einstellungen einblenden",
    "CLIP_SETTINGS": "Clip-Einstellungen",
    "MESSAGE_BOX_INCOMPATIBLE": "Die Dateien sind nicht kompatibel",
    "MESSAGE_BOX_REMOVE_EXISTING": "Die Dateien sind nicht kompatibel (Formatkonflikt)",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "Die Dateien sind nicht kompatibel (Auflösungskonflikt)",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "Die Dateien sind nicht kompatibel (Bildratekonflikt)",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "Die Dateien sind nicht kompatibel (Codec-Konflikte)",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "Die Dateien sind nicht kompatibel (DF/NDF-Timecode-Format stimmt nicht überein)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "Die Dateien sind nicht kompatibel (Farbraumkonflikt)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "Die Dateien sind nicht kompatibel (die Parameter der Videokodierer stimmen nicht überein)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "Datei ist inkompatibel (bitte den Offline-Clip löschen)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "Transkriptionsmodelle nicht gefunden. Möchten Sie sie (~882 MB) herunterladen und installieren?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "Modelle zur Sport-Highlights-Erkennung nicht gefunden. Möchten Sie sie (~3.9 GB) herunterladen und installieren?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "Für die Sport-Highlights-Erkennung wird eine NVIDIA GPU mit Rechenleistung >= 7.5 benötigt",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "Verhindern Sie, dass Videodateien mit unterschiedlichen Codecs, Auflösungen, Bildraten, DF/NDF-Timecode und Farbräumen zur selben Zeitleiste hinzugefügt werden",
    "MARKS_CONTEXT_MENU_MARK_IN": "Markierung In",
    "MARKS_CONTEXT_MENU_MARK_OUT": "Markierung Out",
    "MARKS_CONTEXT_MENU_CLEAR": "In-/Out-Punkte löschen",
    "MEDIA_ERROR_build_thumbnails_error": "Fehler beim Erstellen der Miniaturansichten",
    "MEDIA_ERROR_unsupported_media": "Nicht unterstützte Medien",
    "MEDIA_ERROR_exceeded_file_size": "Dateigröße überschritten",
    "MEDIA_ERROR_exceeded_per_user_size": "Größe pro Benutzer überschritten",
    "MEDIA_ERROR_low_disk_space": "Wenig Speicherplatz",
    "MEDIA_ERROR_internal_server_error": "Interner Serverfehler",
    "MEDIA_ERROR_network_error": "Netzwerkfehler",
    "MEDIA_ERROR_not_found": "Mediendatei nicht gefunden",
    "MEDIA_ERROR_unable_get_media_info": "Medieninformationen können nicht abgerufen werden",
    "MEDIA_ERROR_not_enough_tokens": "Nicht genügend Token",
  },
  es: {
    "ADD_FOLDER_BTN": "Añadir carpeta",
    "ADD_FOLDER_BTN_TOOLTIP": "Añadir carpeta",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "Añadir el primer archivo importado a la línea de tiempo en el código de tiempo de inicio de la fuente",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "Permitir cambios en la línea de tiempo/diseño multimedia",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "Bucket Name",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "ID de clave de acceso",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "Clave secreta",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "Importando",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "Error de importación",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "Importado con éxito",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "Importar medios desde AWS Bucket",
    "AMAZON_IMPORT_BTN_IMPORT": "Importar",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "Importar",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "Preguntar el nombre del proyecto en Nuevo proyecto",
    "AUDIO_CAPTION_AUDIO": "Audio",
    "AUDIO_TEXT_FOUND_ITEMS": "Elementos encontrados",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "No se han encontrado resultados",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "Parece que no podemos encontrar ningún resultado basado en tu búsqueda",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "Ajustes de audio",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "Sonido",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "Transición",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "Fundido de entrada (seg.)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "Fundido de salida (seg.)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "Género de búsqueda",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "Buscar música",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "Buscar efectos de sonido",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "Buscar en",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "Música por género",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "Efectos de sonido",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "Música por estado de ánimo",
    "AUDIO_MENU_ITEM_ALL": "Todos",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "Transiciones",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "Reproducir automáticamente el medio seleccionado",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "¿Quitar activo de la línea de tiempo?",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "Establece el formato del código de tiempo en función del soporte",
    "BATCH_IMPORT_FILES_HEAD": "Importar archivos",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "Análisis",
    "CAPTION_ADDED": "Añadido",
    "CAPTION_SKIPPED": "Omitido",
    "COLOR_PICKER_BTN_COLOR": "Seleccionar color",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "Seleccionar color",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "Color de fondo",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "Color de fondo",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "Descargando archivos multimedia",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "Importación de archivos multimedia",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "Cargando medios guardados",
    "COMMON_STATUS_TEXT_ABORTED": "Abortado",
    "COMMON_STATUS_TEXT_LOADING": "Cargando",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "La operación está en cola.",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "Preparar imágenes",
    "COMMON_STATUS_TEXT_RENDERING": "Rendering",
    "COMMON_STATUS_TEXT_CONVERT": "Convertir",
    "COMMON_YES": "Sí",
    "COMMON_NO": "No",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "Restablecer todos los cambios",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "Cancelar",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "Cancelar",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "Avatar de usuario",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "Puedes subir un archivo de avatar de usuario predeterminado",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "Avatar",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "Tema de color",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "Script JS personalizado",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "Texto personalizado",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "Puedes personalizar el texto del editor",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "Este script se ejecuta al cargar el editor. Puede utilizarse para integrar análisis, etc.",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "Editar script JS",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "Segundo color de acento",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "Selecciona el color del fondo principal",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "El color de acento principal para los controles. Seleccione aquí el color de su marca",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "Color adicional de los controles en pareja con el color principal de los botones",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "El archivo de audio en la línea de tiempo tiene su propio estilo",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "Puedes subir un archivo con tu Logotipo",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "El archivo de voz en off tiene su propio estilo",
    "CUSTOMIZATION_LABEL_DISPLAYED": "mostrado",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "Elige uno de los temas predefinidos o crea el tuyo propio. Puedes editar el archivo CSS para personalizar tu tema",
    "CUSTOMIZATION_TITLE_BASIC_BG": "Fondo básico",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "Botones primarios, enlaces",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "Editar archivo CSS para tema",
    "CUSTOMIZATION_TITLE_AUDIO": "Audio",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "Voz en off",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "Editar valores de texto",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "Editar valores de texto",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "Editar valores de texto",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "Descripción del formato",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "Descripción del formato",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "Restablecer todos los cambios",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "Restablecer todos los cambios",
    "CUSTOMIZATION_BTN_CANCEL": "Cancelar",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "Cancelar",
    "CUSTOMIZATION_BTN_SAVE": "Guardar",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "Guardar",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "Editar script JS",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "Editar script JS",
    "CUSTOMIZATION_BTN_EDIT_CSS": "Editar CSS",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "Editar CSS",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "Subir logotipo",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "Subir logotipo",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "Eliminar logotipo",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "Eliminar logotipo",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "Tema oscuro",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "Tema luminoso",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "Tema personalizado",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "Logotipo",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "Logotipo",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "Personalizar editor",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "Logotipo y nombre",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "Nombre de la empresa",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "Nombre del editor",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "Archivos aceptados:",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "Sin logotipo cargado",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "Ver ajustes",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "View Settings",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "Filtros",
    "DUMMY_HEADER_BTN_FILTERS": "Filtros",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Guardar proyecto como...",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "Panel de administración",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "Nuevo proyecto",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "Publicar",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "Personalizar editor",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Extensiones de Adobe CEP",
    "EDITOR_MENU_MAIN_LOGS": "Registros",
    "EDITOR_MENU_MAIN_SETTINGS": "Ajustes",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "Imposible publicar",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "Track is required",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "Ajustes de renderizado",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "Comportamiento",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "Ver",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "Guardar",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "Cancelar",
    "FILE_INPUT_BTN": "Entrada de archivo",
    "FILE_INPUT_BTN_TOOLTIP": "Entrada de archivo",
    "FORM_FIELD_LABEL_VOLUME": "Volumen",
    "folder_not_empty": "La carpeta no está vacía. Los archivos pueden utilizarse en los proyectos. Si continúa, el archivo no estará disponible en la línea de tiempo de los proyectos correspondientes.",
    "HEAD_CONTROL_IMPORT_TEXT": "Importar",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "Importar medios",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "Importar desde el teléfono",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "Importar carpeta con medios",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Amazon S3 Bucket",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Google Drive",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "URL input",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Guardar proyecto como...",
    "HEADER_MENU_LIST_ITEM_DELETE": "Borrar",
    "HEADER_MENU_LIST_ITEM_RENAME": "Renombrar",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "Añadir clave de licencia",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "Cerrar sesión",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "¿Quieres dejar el editor?",
    "HEADER_BTN_BACK_TO_MY_ACC": "Volver a mi cuenta",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "Volver a mi cuenta",
    "HEADER_BTN_HELP": "Ayuda",
    "HEADER_BTN_HELP_TOOLTIP": "Ayuda",
    "IMAGES_TEXT_NATIVE_IMAGES": "Imagen nativa",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "Images",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "Buscar en",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "Seleccionar colección",
    "IMAGES_TEXT_ALL_CATEGORIES": "Todas las colecciones",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "No se han encontrado resultados",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "Parece que no podemos encontrar ningún resultado basado en tu búsqueda",
    "IMAGES_TAB_AI_GENERATED": "Ai-Generated",
    "IMAGES_TAB_SEARCH": "Buscar",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "Importar medios desde URL",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "Haga clic aquí para enlazar a un archivo",
    "IMPORT_FROM_URL_BTN_IMPORT": "Importar",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "Importar",
    "IMPORT_TOKEN_INVALID": "El token de importación no es válido",
    "LAYER_CONTROL_BTN_MOVE_UP": "Mover hacia arriba",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "Mover hacia arriba",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "Arrastrar capa",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "Arrastrar capa",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "Mover hacia abajo",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "Mover hacia abajo",
    "LAYER_CONTROL_BTN_DELETE": "Borrar",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "Borrar",
    "LAYER_CONTROL_BTN_HIDE": "Ocultar",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "Ocultar",
    "LAYER_CONTROL_BTN_SHOW": "Mostrar",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "Mostrar",
    "LAYER_CONTROL_BTN_MUTE": "Silenciar",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "Silenciar",
    "LAYER_CONTROL_BTN_UNMUTE": "Unmute",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "Unmute",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "Mis medios",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "Mis medios",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "Medios del proyecto",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "Medios del proyecto",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "Transiciones",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "Transiciones",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "Imágenes",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "Imágenes",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "Texto",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "Texto",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "Diseño",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "Diseño",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "Filtros",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "Filtros",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "Filtros",
    "MEDIA_API_IS_NOT_AVAILABLE": "Error: Voiceover WebAPI requiere https",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "Ajustes de imagen",
    "MEDIA_FORM_CAPTION_POSITION": "Posición",
    "MEDIA_FORM_CAPTION_ROTATION": "Rotación",
    "MEDIA_FORM_CAPTION_SETTINGS": "Ajustes",
    "MEDIA_FORM_CAPTION_OUTLINE": "Esquema",
    "MEDIA_FORM_CAPTION_SHADOW": "Sombra",
    "MEDIA_FORM_CAPTION_SIZE": "Tamaño",
    "MEDIA_FORM_CAPTION_VIDEO": "Vídeo",
    "MEDIA_FORM_CAPTION_AUDIO": "Audio",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "Opacidad",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "Filtros",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "Filtros",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "Todos",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "Vídeo",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "Imagen",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "Audio",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "Carpeta",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "Locución",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "Ver ajustes",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "Ver ajustes",
    "MEDIA_UPLOADER_TEXT_OR": "o",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "Arrastra y suelta tus medios aquí",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "importar medios",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "Importar",
    "MEDIA_PREVIEW_TEXT_RENDERING": "Rendering",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "Resolución",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "Grados de rotación",
    "MEDIA_INFO_LIST_ITEM_CODEC": "Codecs",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "Espacio de color",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "Frecuencia de imagen",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - Estéreo",
    "MEDIA_INFO_LIST_ITEM_DURATION": "Duración",
    "MEDIA_INFO_LIST_ITEM_TYPE": "Tipo",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "Audio",
    "MEDIA_INFO_LIST_ITEM_SIZE": "Tamaño",
    "MEDIA_INFO_LIST_TASK_STATUS": "Estado de la tarea",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "Iniciar código de tiempo",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "Parámetros del codificador de vídeo",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "Mis medios",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "Medios del proyecto",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "Cargar más medios",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "Cargar más medios",
    "MEDIA_BTN_LOADING": "Cargando",
    "MEDIA_BTN_LOADING_TOOLTIP": "Cargando",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "Chroma Key",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "Posición",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "Sonido",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "TAMAÑO",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "Ajustes de medios",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "Restablecer todos los ajustes",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "Restablecer todos los ajustes",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARIDAD": "Similitud",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "Suavidad",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "Reducción de derrame de colores clave",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "Elige el color de la vista previa",
    "MEDIA_SORT_OPTION_DURATION": "Duración",
    "MEDIA_SORT_OPTION_DATE": "Date",
    "MEDIA_SORT_OPTION_SIZE": "Tamaño",
    "MEDIA_SORT_OPTION_NAME": "Nombre",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "Sort By",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "Order",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "Ver",
    "MEDIA_SORT_OPTION_ASCENDING": "Ascendente",
    "MEDIA_SORT_OPTION_DESCENDING": "Descendente",
    "MEDIA_SORT_OPTION_LIST": "Lista",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "Iconos grandes",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "Mis grabaciones",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "Mis grabaciones",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "Mis medios",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "Mis medios",
    "MEDIA_FILES_DELETE_FORM_TITLE": "Algunos archivos son utilizados por los proyectos y no se han eliminado",
    "MEDIA_FILES_DELETE_FORM_DESC": "Los archivos seleccionados se eliminarán de la mediateca y dejarán de estar disponibles en los proyectos",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "Archivos utilizados en los proyectos",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "Seleccionar todo",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "¿Está seguro de que desea eliminar los elementos seleccionados?",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "Buscar carpeta",
    "MEDIA_CONFIRM_BTN_DELETE": "Borrar",
    "MEDIA_CANCEL_BTN_DELETE": "Cancelar",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "Borrar",
    "MEDIA_CONFIRM_TITLE_DELETE": "Borrar",
    "MEDIA_TEXT_LOADING": "Cargando",
    "MEDIA_BTN_ADD": "Añadir",
    "MEDIA_BTN_ADD_TOOLTIP": "Añadir",
    "MEDIA_PROGRESS_TEXT_LOADING": "Cargando",
    "MEDIA_PROGRESS_TEXT_SAVING": "Guardando",
    "MEDIA_PROGRESS_TEXT_CONVERT": "Convertir",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "Transferencia",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "Análisis",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "Seleccionar carpeta",
    "MEDIA_MENU_ITEM_MEDIA": "Media",
    "MEDIA_MENU_ITEM_MOVE_TO": "Mover a",
    "MEDIA_MENU_ITEM_SETTINGS": "Settings",
    "MEDIA_MENU_ITEM_NABLET_HLD": "Detectar momentos destacados deportivos",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "Transcribir",
    "MEDIA_MENU_ITEM_DELETE": "Borrar",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "Borrar clips seleccionados",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "Examinar los medios",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "Copiar endereço do suporte",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "Añadir utilizando el código de tiempo de inicio",
    "MEDIA_MENU_LABEL_MOVE_TO": "Mover a",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "Editor de vídeo HTML5",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "Las tabletas y los móviles aún no son compatibles :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "El editor de vídeo funciona bien en el ordenador",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "Volver al sitio web",
    "MOBILE_UPLOAD_TITLE": "Subir archivos al «Almacenamiento del usuario»",
    "MOBILE_UPLOAD_SUBTITLE": "Formatos compatibles: vídeo, audio y fotos. Tus archivos se guardarán en el «Almacenamiento del usuario»",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "Para cambiar de idioma, necesita reiniciar la aplicación",
    "MODAL_WINDOW_LOGS_TITLE": "Para activar/desactivar los registros, es necesario reiniciar la aplicación",
    "MODAL_WINDOW_INSTALL_COMPONENT_TITLE": "El componente solicitado ha sido instalado. Es necesario reiniciar la aplicación",
    "MESSAGE_BOX_INSTALL_RUNNING": "Ya hay otra instalación en curso.\nEspere a que se complete.",
    "MESSAGE_BOX_INSTALL_FAILED": "No se pudo ejecutar la instalación. Consulte los registros para más detalles",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "Seleccionar un fichero de referencia",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "Añade archivos con diferentes FPS/resolución/codec. Seleccione el archivo cuyas propiedades se aplicarán al proyecto",
    "MODAL_WINDOW_BUTTON_RESTART": "Reinicie",
    "MUTE_AUDIO_AT_CREATED_LAYERS": 'Silenciar el audio en las capas creadas',
    "NAVIGATION_TAB_EDITOR": "Editor",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "Editor",
    "NAVIGATION_TAB_PROJECTS": "Proyectos",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "Projects",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "Sin conexión de red",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "Último guardado",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "hace un minuto",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "ahora",
    "PROJECTS_BTN_NEW_PROJECTS": "Nuevo proyecto",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "Nuevo proyecto",
    "PROJECTS_BTN_NEW_PROJECT": "Nuevo proyecto",
    "PROJECTS_BTN_IMPORT": "Importar",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "Importar",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "Yes",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "Cancelar",
    "PROJECTS_TITLE_TEXT_COPY": "Copia",
    "PROJECTS_BTN_SAVE": "Guardar",
    "PROJECTS_BTN_SAVE_TOOLTIP": "Guardar",
    "PROJECTS_BTN_CREATE": "Crear",
    "PROJECTS_BTN_CREATE_TOOLTIP": "Crear",
    "PROJECTS_TITLE_TEXT_RENAME": "Renombrar",
    "PROJECTS_TITLE_TEXT_DELETE": "Eliminar",
    "PROJECTS_TITLE_TEXT_EXPORT": "Exportar",
    "PROJECTS_CONFIRM_BTN_DELETE": "Eliminar",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "Editado %d hace horas",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "Editado ahora mismo",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "Editado %d hace minutos",
    "PROJECTS_PROGRESS_TEXT_LOADING": "Cargando",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "Searching",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "¿Desea detener la importación?",
    "PROJECTS_TEXT_NOTHING_FOUND": "Nada encontrado",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "Crea un nuevo y bonito proyecto",
    "PROJECTS_TEXT_CAPTION": "Proyectos",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "Nombre del proyecto",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "Haga clic para cargar o, arrastre y suelte un archivo de proyecto aquí",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "Solo puedes subir un archivo a la vez",
    "PROJECTS_PREFIX_TEXT_EDITED": "Editado",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "¿Está seguro de que desea eliminar?",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "Este proyecto se eliminará inmediatamente. No se puede deshacer esta acción",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "Proyecto",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "Sólo se puede subir un archivo",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "Extensión de archivo no válida. Debería ser *.edl.zip",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "Introduce tu valor",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "Crear una carpeta para este proyecto en Media",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "Abrir Editor",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "Inténtalo de nuevo",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "Seleccionar velocidad de fotogramas para el proyecto",
    "PROJECTS_EXPORT_TITLE": "Exportar proyecto",
    "PROJECTS_EXPORT_INPROGRESS": "Exportación en progreso...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "Incluir medios",
    "PROJECTS_EXPORT_COMPLETE": "Exportación del proyecto completada",
    "PROJECTS_EXPORT_BTN_BROWSE": "Explorar",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "Descargar",
    "PROJECTS_EXPORT_BTN_COPY": "Copiar",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "Los archivos de los medios se reproducen aquí",
    "PREVIEW_BTN_PREV_TOOLTIP": "Anterior",
    "PREVIEW_BTN_PREV": "Anterior",
    "PREVIEW_BTN_PLAY_TOOLTIP": "Reproducir",
    "PREVIEW_BTN_PLAY": "Reproducir",
    "PREVIEW_BTN_STOP_TOOLTIP": "Stop",
    "PREVIEW_BTN_STOP": "Stop",
    "PREVIEW_BTN_NEXT_TOOLTIP": "Siguiente",
    "PREVIEW_BTN_NEXT": "Siguiente",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "Volumen",
    "PREVIEW_BTN_VOLUME": "Volumen",
    "PREVIEW_BTN_FRAME_CAPTURE": "Fotograma de captura",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "Fotograma de captura",
    "PREVIEW_BTN_FULL_SCREEN": "Pantalla completa",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "Pantalla completa",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "Marcar en",
    "PREVIEW_BTN_MARK_IN": "Marcar en",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "Marcar",
    "PREVIEW_BTN_MARK_OUT": "Marcar",
    "PREVIEW_HEADER_TITLE_SOURCE": "Fuente",
    "PREVIEW_HEADER_TITLE_TIMELINE": "Cronología",
    "PREVIEW_MODE_AUTO": "Automático",
    "PREVIEW_MODE_SOURCE": "Fuente",
    "PREVIEW_MODE_TIMELINE": "Cronología",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "salida",
    "PUBLISH_SETTINGS_TITLE": "Título",
    "QR_CODE_DIALOG_TITLE": "Escanea el código QR (válido durante 24 horas)",
    "QR_CODE_LOAD_ERROR": "¡Error! No se ha podido generar el código QR",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "Evita añadir archivos de vídeo con parámetros de codificación diferentes a la misma línea de tiempo",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "Ignorar discrepancia entre los parámetros de cuantización y los parámetros de vídeo",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "Empezar a renderizar desde el primer clip",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "Preguntar el nombre del archivo de salida",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "Cerrar ajustes de publicación al cancelar",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "Duración",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "Codec",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "Frecuencia de imagen",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - Estéreo",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "Resolución",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "Audio",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "Tamaño (aproximado)",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "Se perderá el enlace al archivo de transcodificación",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "Ajustes de publicación",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "Renderización de vídeo completada",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "Introducir nombre",
    "SAVE_SETTINGS_BTN_RENDER_START": "Start",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "Inicio",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "Volver a mi cuenta",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "Volver a mi cuenta",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "Cancelar",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "Cancelar",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "Descargar",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "Descargar",
    "SAVE_SETTINGS_BTN_BROWSE": "Explorar",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "Explorar",
    "SAVE_SETTINGS_BTN_COPY": "Copiar",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "Copiar",
    "SAVE_SETTINGS_TEXT_TITLE": "Título",
    "SAVE_SETTINGS_TEXT_LOADING": "Cargando",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "Preparar imágenes",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "Este vídeo se ha enviado a tu cuenta y debería estar disponible en breve",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "Todos",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "Búsqueda",
    "SHOW_MY_MEDIA_POOL": "Mostrar mi biblioteca multimedia",
    "SHOW_PROJECT_MEDIA_POOL": "Mostrar proyecto: biblioteca multimedia",
    "SHOW_EDITOR_HEADER": "Mostrar encabezado del editor",
    "SHOW_MENU_TABS": "Mostrar pestañas del menú",
    "SHOW_PREVIEW_SPLIT_BUTTON": "Mostrar botón de división de vista previa",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "Mostrar botones de cambio de vista previa",
    "SHOW_INOUT_POINTS_TIMELINE": "Mostrar puntos de entrada/salida de la línea de tiempo",
    "SHOW_INOUT_POINTS_SOURCE": "Mostrar puntos de entrada/salida del origen",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "Mostrar marcador de importación en la línea de tiempo vacía",
    "VIEW_SETTINGS_LANG": "Idioma",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "Descripción",
    "SETTINGS_HEAD_BTN_DELETE": "Borrar",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "Borrar",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "Seleccionar el mismo",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "Seleccionar el mismo",
    "SETTINGS_HEAD_BTN_CLOSE": "Cerrar",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "Cerrar",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "Ancho",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "Altura",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "Mantener la relación de aspecto",
    "SETTINGS_BTN_FIT_TO_FRAME": "Ajustar al marco",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "Ajustar al marco",
    "SETTINGS_BTN_FILL_FRAME": "Rellenar marco",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "Rellenar marco",
    "SETTINGS_TEXT_AUTO": "auto",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "Transformación de texto none",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "Transformación de texto none",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "Transformación texto mayúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "Transformación de texto en mayúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "Transformación de texto en minúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "Transformación de texto en minúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "Transformación de texto mayúsculas",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "Transformación de texto mayúsculas",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "Familia de fuentes",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "Familia de fuentes",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "Tamaño de fuente",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "Tamaño de fuente",
    "SETTINGS_TEXT_BTN_BOLD": "Negrita",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "Negrita",
    "SETTINGS_TEXT_BTN_ITALIC": "Italic",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "Italic",
    "SETTINGS_TEXT_BTN_UNDERLINE": "Subrayado",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "Subrayado",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "Izquierda",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "Izquierda",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "Derecha",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "Derecha",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "Centro",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "Centro",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "Justificar",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "Justificar",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "Arriba",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "Arriba",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "Arriba a la izquierda",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "Arriba a la izquierda",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "Arriba a la derecha",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "Arriba a la derecha",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "Izquierda",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "Izquierda",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "Centro medio",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "Centro medio",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "Derecha",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "Derecha",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "Parte inferior izquierda",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "Parte inferior izquierda",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "Abajo",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "Abajo",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "Abajo derecha",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "Abajo derecha",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "Horizontal",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "Vertical",
    "SETTINGS_ROTATION_TEXT_ROTATE": "Gire",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "Introducir texto",
    "NABLET_HLD_PROJECT_POSTFIX": "momentos destacados",
    "NABLET_HLD_CAPTION": "Detectar momentos destacados",
    "NABLET_HLD_DETECTED_BTN_START": "Iniciar",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "Crear proyecto(s)",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "Cancelar",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "Conteo de intervalos detectados:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "¿Está seguro de que desea terminar la tarea?",
    "NABLET_HLD_DETECTED_BTN_NO": "No",
    "NABLET_HLD_DETECTED_BTN_YES": "Sí",
    "NB_HLD_STATUS_TEXT_DETECTING": "Detectando",
    "NABLET_HLD_TARGET_DURATION_SEC": "Duración objetivo en segundos",
    "AI_MODEL": "Modelo de IA",
    "TRANSCRIBE_CAPTION": "Transcribir contenido multimedia",
    "TRANSCRIBE_PROJECT_POSTFIX": "transcrito",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "Transcribiendo",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "Cantidad de elementos de texto:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "Crear proyecto",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "Esta sección está en desarrollo",
    "TEXT_FORM_CAPTION_SIZE": "Tamaño",
    "TEXT_FORM_CAPTION_OUTLINE": "Esquema",
    "TEXT_FORM_CAPTION_FONT": "Fuente",
    "TEXT_FORM_CAPTION_SHADOW": "Sombra",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "Ajustes de texto",
    "TEXT_FORM_TEXT_OFFSET": "Desplazamiento",
    "TEXT_FORM_TEXT_BLUR": "Desenfoque",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "Text",
    "TIMELINE_TEXT_DRAG_N_DROP": "Arrastrar y soltar",
    "TIMELINE_TEXT_ADD_LAYER": "+ Añadir capa",
    "TIMELINE_TOOLBAR_BTN_UNDO": "Deshacer",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "Deshacer",
    "TIMELINE_TOOLBAR_BTN_REDO": "Rehacer",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "Rehacer",
    "TIMELINE_TOOLBAR_BTN_DELETE": "Borrar",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "Borrar",
    "TIMELINE_TOOLBAR_BTN_COPY": "Copiar clip",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "Copiar clip",
    "TIMELINE_TOOLBAR_BTN_CUT": "Cortar clip(s)",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "Cortar clip(s)",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "Añadir marcador",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "Añadir marcador",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "Pegar",
    "TIMELINE_TOOLBAR_BTN_PASTE": "Pegar",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "Ajustes",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "Ajustes",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "Locución",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "Locución",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "Cámara web",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "Cámara web",
    "TIMELINE_TOOLBAR_BTN_LIVE": "Transmisión en vivo",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "Transmisión en vivo",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "Haz clic para cancelar",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "Haga clic para cancelar",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "Arrastrar y soltar",
    "TIMELINE_FOOTER_TEXT_DURATION": "Duración",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "Imposible publicar proyecto",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "Se requiere pista de vídeo",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "Guardar",
    "TIMELINE_FOOTER_BTN_SAVE": "Guardar",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "Guardar",
    "TIMELINE_FOOTER_BTN_PUBLISH": "Publicar",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "Publicar",
    "TIMELINE_SLIDER_POINTER": "Puntero deslizante",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "Puntero del deslizador",
    "TRANSITION_NAME_DISSOLVE": "Disolución",
    "TRANSITION_NAME_FADE_IN": "Fundido de entrada",
    "TRANSITION_NAME_FADE_OUT": "Fundido de salida",
    "TRANSITION_NAME_DIP_TO_BLACK": "Fundido a negro",
    "TRANSITION_NAME_DIP_TO_WHITE": "Fundido a blanco",
    "TRANSITION_NAME_BLUR": "Desenfoque",
    "TRANSITION_NAME_WIPE_RIGHT": "Barrido a la derecha",
    "TRANSITION_NAME_WIPE_LEFT": "Barrido a la izquierda",
    "TRANSITION_NAME_WIPE_UP": "Barrido hacia arriba",
    "TRANSITION_NAME_WIPE_DOWN": "Barrido hacia abajo",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "Ajustes de transición",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "Aplicar a todas las transiciones de la línea de tiempo",
    "TRANSITION_FORM_SELECTED": "seleccionado:",
    "TRANSITION_FORM_LABEL_TYPE": "Tipo",
    "TRANSITION_FORM_LABEL_DURATION": "Duración (segundos)",
    "TRANSITION_LIST_CAPTION_TRANSITION": "Transición",
    "used_in_projects": "El archivo multimedia no se ha eliminado porque está en uso en uno o más proyectos. Si continúa, el archivo no estará disponible en la línea de tiempo de los proyectos correspondientes y se eliminará de su cuenta.",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "Utilizar cuadro de diálogo modal para importar archivos locales",
    "VOICE_OVER_TITLE_LAST_RECORDING": "Última grabación",
    "VOICE_OVER_BTN_RETAKE": "Retake",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "Retomar",
    "VOICE_OVER_BTN_DELETE_FILE": "Eliminar archivo",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "Eliminar archivo",
    "VOICE_OVER_BTN_START_RECORDING": "Iniciar grabación",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "Iniciar grabación",
    "VOICE_OVER_BTN_CONNECTION": "Conexión...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "Conexión...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "El archivo se eliminará de la línea de tiempo y de los medios",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "¿Estás seguro?",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "Narración de voz",
    "VOICE_OVER_TEXT_MIC": "Micrófono",
    "VOICE_OVER_LABEL_SELECT_MIC": "Seleccionar micrófono",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "Sin audio",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "Silenciar a linha de tempo durante a gravação",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "Deslizador de rebobinado al inicio tras la grabación",
    "VOICE_OVER_TEXT_COUNTDOWN": "Cuenta atrás",
    "VOICE_OVER_BTN_TEST_MIC": "Micrófono de prueba",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "Micrófono de prueba",
    "VOICE_OVER_BTN_RECORDING": "Grabando...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "Grabando...",
    "VOICE_OVER_BTN_PLAYING": "Reproduciendo...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "Reproduciendo...",
    "VOICE_OVER_BTN_YES": "Sí",
    "VOICE_OVER_BTN_YES_TOOLTIP": "Sí",
    "VOICE_OVER_BTN_NO": "No",
    "VOICE_OVER_BTN_NO_TOOLTIP": "No",
    "VOICE_OVER_BTN_STOP": "Stop",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "Stop",
    "VOICE_OVER_BTN_DELETE": "Borrar",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "Borrar",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "Ajuste automático",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "Otros ajustes",
    "WEBCAM_TEXT_RECORD_VIDEO": "Grabar vídeo",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "Grabar transmisión en vivo",
    "LIVE_STREAM_URL_INPUT_LABEL": "URL de la transmisión en vivo",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "Haz clic aquí para acceder a una transmisión en vivo",
    "LIVE_STREAM_BTN_CONNECTING": "Konektante...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "Konektante...",
    "LIVE_STREAM_BTN_CAPTURE": "Iniciar captura",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "Iniciar captura",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "Detener captura",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "Detener captura",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "Disminuir zoom",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "Disminuir zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "Aumentar zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "Aumentar zoom",
    "SETTINGS_HOTKEYS": "Configuración de teclas de acceso rápido",
    "PRESET": "Preestablecido",
    "DEFAULT": "Por defecto",
    "ADD_NEW": "Añadir Nuevo",
    "SEARCH_COMMAND": "Comando de búsqueda",
    "COMMAND": "Mando",
    "SHORTCUTS": "Atajos",
    "ALL": "Todos",
    "TIMELINE": "Timeline",
    "TOOLS": "HERRAMIENTAS",
    "PREVIEW": "Vista previa",
    "KEYBOARD_MAPPING_PRESET": "Ajuste preestablecido de asignación de teclado",
    "ENTER_PRESET_NAME": "Introducir nombre de preselección",
    "THIS_PRESET_WILL_BE_DELETED": "Este preajuste se eliminará inmediatamente. No se puede deshacer esta acción",
    "RESET_ALL_TO_DEFAULTS": "Restablecer todo a los valores predeterminados",
    "HOTKEY_SETTINGS_UNDO": "Deshacer",
    "HOTKEY_SETTINGS_REDO": "Rehacer",
    "HOTKEY_SETTINGS_ZOOM_IN": "Acercar",
    "HOTKEY_SETTINGS_ZOOM_OUT": "Zoom out",
    "HOTKEY_SETTINGS_PREV_FRAME": "Fotograma anterior",
    "HOTKEY_SETTINGS_NEXT_FRAME": "Fotograma siguiente",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "Añadir a línea de tiempo",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "Aumentar volumen de clip",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "Disminuir volumen de clip",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "Ripple delete",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "Ripple trim previous",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "Ripple trim next",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "Seleccionar clips en la posición actual",
    "HOTKEY_SETTINGS_CUT_CLIPS": "Cortar clip(s)",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "Reproducir/Pausa",
    "HOTKEY_SETTINGS_DELETE": "Borrar",
    "HOTKEY_SETTINGS_COPY": "Copiar",
    "HOTKEY_SETTINGS_PASTE": "Pegar",
    "HOTKEY_SETTINGS_PLAY": "Reproducir",
    "HOTKEY_SETTINGS_PAUSE": "Pausa",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "Reproducir el intervalo resaltado",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "Puntos de entrada y salida claros",
    "HOTKEY_SETTINGS_MARK_IN": "Marcar punto de entrada",
    "HOTKEY_SETTINGS_MARK_OUT": "Marcar punto de salida",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "Buscar el punto de entrada",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "Buscar el punto de salida",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "Mover el control deslizante al siguiente punto de edición del clip",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "Mover el control deslizante al punto de edición anterior del clip",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "Alternar la visibilidad de mis medios",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "Alternar la configuración del editor visible",
    "CLIP_SETTINGS": "Ajustes del clip",
    "MESSAGE_BOX_INCOMPATIBLE": "Los archivos no son compatibles",
    "MESSAGE_BOX_REMOVE_EXISTING": "Los archivos no son compatibles (No coincide el formato)",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "Los archivos no son compatibles (No coincide la resolución)",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "Los archivos no son compatibles (No coincide la velocidad de fotogramas)",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "Los archivos no son compatibles (No coincide el códec)",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "Los archivos no son compatibles (discrepancia en el formato de código de tiempo DF/NDF)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "Los archivos no son compatibles (discrepancia en el espacio de color)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "Los archivos no son compatibles (los parámetros del codificador de vídeo no coinciden)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "El archivo es incompatible (elimine el clip sin conexión)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "No se encontraron modelos de transcripción. ¿Desea descargarlos (~882 MB) e instalarlos?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "No se encontraron modelos de detección de momentos destacados deportivos. ¿Desea descargarlos (~3.9 GB) e instalarlos?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "La detección de momentos destacados deportivos requiere NVIDIA GPU con capacidad de cómputo >= 7.5",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "Evita añadir archivos de vídeo con diferentes códecs, resoluciones, FPS, código de tiempo DF/NDF o espacios de color a la misma línea de tiempo",
    "MARKS_CONTEXT_MENU_MARK_IN": "Marcar entrada",
    "MARKS_CONTEXT_MENU_MARK_OUT": "Marcar salida",
    "MARKS_CONTEXT_MENU_CLEAR": "Borrar puntos de entrada/salida",
    "MEDIA_ERROR_build_thumbnails_error": "Error al crear miniaturas",
    "MEDIA_ERROR_unsupported_media": "Medios no compatibles",
    "MEDIA_ERROR_exceeded_file_size": "Tamaño de archivo excedido",
    "MEDIA_ERROR_exceeded_per_user_size": "Tamaño por usuario excedido",
    "MEDIA_ERROR_low_disk_space": "Poco espacio en disco",
    "MEDIA_ERROR_internal_server_error": "Error interno del servidor",
    "MEDIA_ERROR_network_error": "Error de red",
    "MEDIA_ERROR_not_found": "Archivo multimedia no encontrado",
    "MEDIA_ERROR_unable_get_media_info": "No se puede obtener información sobre el archivo multimedia",
    "MEDIA_ERROR_not_enough_tokens": "No hay suficientes tokens",
  },
  ko: {
    "ADD_FOLDER_BTN": "폴더 추가",
    "ADD_FOLDER_BTN_TOOLTIP": "폴더 추가",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "첫 번째로 가져온 파일을 소스 시작 타임코드로 타임라인에 추가",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "타임라인/미디어 레이아웃 변경 허용",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "버킷 이름",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "액세스 키 ID",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "비밀 키",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "가져오기 중",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "가져오기 오류",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "성공적으로 가져왔습니다",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "AWS 버킷에서 미디어 가져오기",
    "AMAZON_IMPORT_BTN_IMPORT": "가져오기",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "가져오기",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "새 프로젝트에서 프로젝트 이름 묻기",
    "AUDIO_CAPTION_AUDIO": "오디오",
    "AUDIO_TEXT_FOUND_ITEMS": "항목을 찾았습니다",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "결과를 찾을 수 없습니다",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "검색 결과를 찾을 수 없는 것 같습니다.",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "오디오 설정",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "소리",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "전환",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "페이드인(초)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "페이드아웃(초)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "검색 장르",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "음악 검색",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "음향 효과 검색",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "검색",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "장르별 음악",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "음향 효과",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "기분별 음악",
    "AUDIO_MENU_ITEM_ALL": "모두",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "전환",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "선택한 미디어 자동 재생",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "타임라인에서 자산을 제거하시겠습니까?",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "미디어에 따라 타임코드 형식 설정",
    "BATCH_IMPORT_FILES_HEAD": "파일 가져오기",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "분석",
    "CAPTION_ADDED": "추가됨",
    "CAPTION_SKIPPED": "건너뛰기",
    "COLOR_PICKER_BTN_COLOR": "색상 선택",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "색상 선택",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "배경색",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "배경색",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "미디어 파일 다운로드 중",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "미디어 파일 가져오기",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "저장된 미디어 업로드 중",
    "COMMON_STATUS_TEXT_ABORTED": "중단됨",
    "COMMON_STATUS_TEXT_LOADING": "로드 중",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "작업이 대기열에 등록되었습니다",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "이미지를 준비하세요",
    "COMMON_STATUS_TEXT_RENDERING": "렌더링",
    "COMMON_STATUS_TEXT_CONVERT": "변환",
    "COMMON_YES": "예",
    "COMMON_NO": "아니오",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "모든 변경 사항 재설정",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "취소",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "취소",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "사용자 아바타",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "기본 사용자 아바타 파일을 업로드할 수 있습니다.",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "아바타",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "색상 테마",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "사용자 지정 JS 스크립트",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "사용자 지정 텍스트",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "편집기의 텍스트를 사용자 지정할 수 있습니다",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "이 스크립트는 편집기가 로딩될 때 실행됩니다. 애널리틱스 등을 통합하는 데 사용할 수 있습니다.",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "JS 스크립트 편집",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "두 번째 강조 색상",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "기본 배경의 색상을 선택하세요.",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "컨트롤의 기본 강조 색상입니다. 여기에서 브랜드 색상을 선택하세요.",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "버튼의 기본 색상과 쌍을 이루는 컨트롤의 추가 색상.",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "타임라인의 오디오 파일에는 고유한 스타일이 있습니다.",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "로고 파일을 업로드할 수 있습니다.",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "보이스오버 파일에는 고유한 스타일이 있습니다.",
    "CUSTOMIZATION_LABEL_DISPLAYED": "표시됨",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "미리 정의된 테마 중 하나를 선택하거나 나만의 테마를 만드세요. CSS 파일을 편집하여 테마를 사용자 지정할 수 있습니다.",
    "CUSTOMIZATION_TITLE_BASIC_BG": "기본 배경",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "기본 버튼 링크",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "테마에 대한 CSS 파일 편집",
    "CUSTOMIZATION_TITLE_AUDIO": "오디오",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "보이스오버",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "텍스트 값 편집",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "텍스트 값 편집",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "텍스트 값 편집",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "형식 설명",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "형식 설명",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "모든 변경 사항 재설정",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "모든 변경 사항 재설정",
    "CUSTOMIZATION_BTN_CANCEL": "취소",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "취소",
    "CUSTOMIZATION_BTN_SAVE": "저장",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "저장",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "JS 스크립트 편집",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "JS 스크립트 편집",
    "CUSTOMIZATION_BTN_EDIT_CSS": "CSS 편집",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "CSS 편집",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "로고 업로드",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "로고 업로드",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "로고 삭제",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "로고 삭제",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "어두운 테마",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "라이트 테마",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "사용자 지정 테마",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "로고",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "로고",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "편집기 사용자 지정",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "로고 및 이름",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "회사 이름",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "편집자 이름",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "허용된 파일: ",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "업로드된 로고 없음",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "보기 설정",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "보기 설정",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "필터",
    "DUMMY_HEADER_BTN_FILTERS": "필터",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "프로젝트를 다른 이름으로 저장...",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "관리자 패널",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "새 프로젝트",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "게시",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "편집기 사용자 지정",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Adobe CEP 확장 기능",
    "EDITOR_MENU_MAIN_LOGS": "로그",
    "EDITOR_MENU_MAIN_SETTINGS": "설정",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "게시할 수 없습니다",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "트랙이 필요합니다",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "렌더링 설정",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "행동",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "보기",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "저장",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "취소",
    "FILE_INPUT_BTN": "파일 입력",
    "FILE_INPUT_BTN_TOOLTIP": "파일 입력",
    "FORM_FIELD_LABEL_VOLUME": "볼륨",
    "folder_not_empty": "폴더가 비어 있지 않습니다. 파일은 프로젝트에서 사용할 수 있습니다. 계속 진행하면 해당 프로젝트의 타임라인에서 파일을 사용할 수 없습니다.",
    "HEAD_CONTROL_IMPORT_TEXT": "가져오기",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "미디어 가져오기",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "휴대폰에서 가져오기",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "미디어가 있는 폴더 가져오기",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Amazon S3 버킷",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "구글 드라이브",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "URL 입력",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "프로젝트를 다른 이름으로 저장...",
    "HEADER_MENU_LIST_ITEM_DELETE": "삭제",
    "HEADER_MENU_LIST_ITEM_RENAME": "이름 바꾸기",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "라이선스 키 추가",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "로그아웃",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "편집기에서 나가시겠습니까?",
    "HEADER_BTN_BACK_TO_MY_ACC": "내 계정으로 돌아가기",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "내 계정으로 돌아가기",
    "HEADER_BTN_HELP": "도움말",
    "HEADER_BTN_HELP_TOOLTIP": "도움말",
    "IMAGES_TEXT_NATIVE_IMAGES": "네이티브 이미지",
    "IMAGES_TEXT_PEXELS": "펙셀",
    "IMAGES_TEXT_UNSPLASH": "언스플래시",
    "IMAGES_HEADER_CAPTION": "이미지",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "검색",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "컬렉션 선택",
    "IMAGES_TEXT_ALL_CATEGORIES": "모든 컬렉션",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "결과를 찾을 수 없습니다",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "검색 결과를 찾을 수 없는 것 같습니다.",
    "IMAGES_TAB_AI_GENERATED": "인공지능 생성",
    "IMAGES_TAB_SEARCH": "검색",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "URL에서 미디어 가져오기",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "파일로 연결하려면 여기를 클릭하세요",
    "IMPORT_FROM_URL_BTN_IMPORT": "가져오기",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "가져오기",
    "IMPORT_TOKEN_INVALID": "가져온 토큰이 유효하지 않습니다.",
    "LAYER_CONTROL_BTN_MOVE_UP": "위로 이동",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "위로 이동",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "레이어 드래그",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "레이어 드래그",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "아래로 이동",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "아래로 이동",
    "LAYER_CONTROL_BTN_DELETE": "삭제",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "삭제",
    "LAYER_CONTROL_BTN_HIDE": "숨기기",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "숨기기",
    "LAYER_CONTROL_BTN_SHOW": "표시",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "표시",
    "LAYER_CONTROL_BTN_MUTE": "음소거",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "음소거",
    "LAYER_CONTROL_BTN_UNMUTE": "음소거 해제",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "음소거 해제",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "내 미디어",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "내 미디어",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "프로젝트 미디어",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "프로젝트 미디어",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "전환",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "전환",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "이미지",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "이미지",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "오디오",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "오디오",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "텍스트",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "텍스트",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "디자인",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "디자인",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "필터",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "필터",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "필터",
    "MEDIA_API_IS_NOT_AVAILABLE": "오류: Voiceover WebAPI는 https가 필요합니다.",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "이미지 설정",
    "MEDIA_FORM_CAPTION_POSITION": "위치",
    "MEDIA_FORM_CAPTION_ROTATION": "회전",
    "MEDIA_FORM_CAPTION_SETTINGS": "설정",
    "MEDIA_FORM_CAPTION_OUTLINE": "개요",
    "MEDIA_FORM_CAPTION_SHADOW": "그림자",
    "MEDIA_FORM_CAPTION_SIZE": "크기",
    "MEDIA_FORM_CAPTION_VIDEO": "비디오",
    "MEDIA_FORM_CAPTION_AUDIO": "오디오",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "불투명도",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "필터",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "필터",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "모두",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "비디오",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "이미지",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "오디오",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "폴더",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "음성 해설",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "보기 설정",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "보기 설정",
    "MEDIA_UPLOADER_TEXT_OR": "또는",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "미디어를 여기로 드래그 앤 드롭하세요",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "미디어 가져오기",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "가져오기",
    "MEDIA_PREVIEW_TEXT_RENDERING": "렌더링",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "해상도",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "회전 각도",
    "MEDIA_INFO_LIST_ITEM_CODEC": "코덱",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "색 공간",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "프레임 속도",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - 스테레오",
    "MEDIA_INFO_LIST_ITEM_DURATION": "기간",
    "MEDIA_INFO_LIST_ITEM_TYPE": "유형",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "오디오",
    "MEDIA_INFO_LIST_ITEM_SIZE": "크기",
    "MEDIA_INFO_LIST_TASK_STATUS": "작업 상태",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "타임코드 시작",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "비디오 인코더 매개변수",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "나의 미디어",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "프로젝트 미디어",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "미디어 추가 로드",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "미디어 추가 로드",
    "MEDIA_BTN_LOADING": "로딩 중:",
    "MEDIA_BTN_LOADING_TOOLTIP": "로딩 중",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "크로마 키",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "위치",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "사운드",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "크기",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "미디어 설정",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "모든 설정 재설정",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "모든 설정 재설정",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "유사도",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "부드러움",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "키 색상 유출 감소",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "미리보기에서 색상 선택",
    "MEDIA_SORT_OPTION_DURATION": "기간",
    "MEDIA_SORT_OPTION_DATE": "날짜",
    "MEDIA_SORT_OPTION_SIZE": "크기",
    "MEDIA_SORT_OPTION_NAME": "이름",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "정렬 기준",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "주문",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "보기",
    "MEDIA_SORT_OPTION_ASCENDING": "오름차순",
    "MEDIA_SORT_OPTION_DESCENDING": "내림차순",
    "MEDIA_SORT_OPTION_LIST": "목록",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "큰 아이콘",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "내 녹화물",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "내 녹화물",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "내 미디어",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "내 미디어",
    "MEDIA_FILES_DELETE_FORM_TITLE": "일부 파일은 프로젝트에서 사용되며 제거되지 않았습니다.",
    "MEDIA_FILES_DELETE_FORM_DESC": "선택한 파일은 미디어 라이브러리에서 삭제되며 프로젝트에서 더 이상 사용할 수 없습니다.",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "프로젝트에 사용된 파일",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "모두 선택",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "선택한 항목을 제거하시겠습니까?",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "폴더 찾아보기",
    "MEDIA_CONFIRM_BTN_DELETE": "삭제",
    "MEDIA_CANCEL_BTN_DELETE": "취소",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "삭제",
    "MEDIA_CONFIRM_TITLE_DELETE": "삭제",
    "MEDIA_TEXT_LOADING": "로드 중",
    "MEDIA_BTN_ADD": "추가",
    "MEDIA_BTN_ADD_TOOLTIP": "추가",
    "MEDIA_PROGRESS_TEXT_LOADING": "로딩 중",
    "MEDIA_PROGRESS_TEXT_SAVING": "저장 중",
    "MEDIA_PROGRESS_TEXT_CONVERT": "변환",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "전송",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "분석",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "폴더 선택",
    "MEDIA_MENU_ITEM_MEDIA": "미디어",
    "MEDIA_MENU_ITEM_MOVE_TO": "이동",
    "MEDIA_MENU_ITEM_SETTINGS": "설정",
    "MEDIA_MENU_ITEM_NABLET_HLD": "스포츠 하이라이트 감지",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "음성 변환",
    "MEDIA_MENU_ITEM_DELETE": "삭제",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "선택한 클립 삭제",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "미디어 찾아보기",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "미디어 주소 복사",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "시작 타임코드를 사용하여 추가",
    "MEDIA_MENU_LABEL_MOVE_TO": "이동",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "HTML5 동영상 편집기",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "태블릿과 모바일은 아직 지원되지 않습니다 :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "동영상 편집기가 컴퓨터에서 잘 작동합니다",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "웹사이트로 돌아가기",
    "MOBILE_UPLOAD_TITLE": "사용자의 저장소에 파일 업로드",
    "MOBILE_UPLOAD_SUBTITLE": "지원 형식: 동영상, 오디오, 사진. 파일은 사용자의 저장소에 저장됩니다.",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "언어를 전환하려면 애플리케이션을 다시 시작해야 합니다",
    "MODAL_WINDOW_LOGS_TITLE": "로그를 켜거나 끄려면 애플리케이션을 다시 시작해야 합니다",
    "MODAL_WINDOW_INSTALL_COMPONENT_TITLE": "요청한 구성 요소가 설치되었습니다. 애플리케이션을 다시 시작해야 합니다",
    "MESSAGE_BOX_INSTALL_RUNNING": "다른 설치가 진행 중입니다.\n완료될 때까지 기다려 주세요.",
    "MESSAGE_BOX_INSTALL_FAILED": "설치를 실행하지 못했습니다. 자세한 내용은 로그를 확인하세요",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "참조 파일 선택",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "FPS/해상도/코덱이 다른 파일을 추가합니다. 프로젝트에 속성을 적용할 파일을 선택합니다.",
    "MODAL_WINDOW_BUTTON_RESTART": "다시 시작",
    "MUTE_AUDIO_AT_CREATED_LAYERS": '생성된 레이어에서 오디오 음소거',
    "NAVIGATION_TAB_EDITOR": "편집기",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "편집기",
    "NAVIGATION_TAB_PROJECTS": "프로젝트",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "프로젝트",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "네트워크 연결 없음",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "마지막으로 저장된",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "분 전",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "바로 지금",
    "PROJECTS_BTN_NEW_PROJECTS": "새 프로젝트",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "새 프로젝트",
    "PROJECTS_BTN_NEW_PROJECT": "새 프로젝트",
    "PROJECTS_BTN_IMPORT": "가져오기",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "가져오기",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "예",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "취소",
    "PROJECTS_TITLE_TEXT_COPY": "복사",
    "PROJECTS_BTN_SAVE": "저장",
    "PROJECTS_BTN_SAVE_TOOLTIP": "저장",
    "PROJECTS_BTN_CREATE": "만들기",
    "PROJECTS_BTN_CREATE_TOOLTIP": "만들기",
    "PROJECTS_TITLE_TEXT_RENAME": "이름 바꾸기",
    "PROJECTS_TITLE_TEXT_DELETE": "삭제",
    "PROJECTS_TITLE_TEXT_EXPORT": "내보내기",
    "PROJECTS_CONFIRM_BTN_DELETE": "삭제",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "편집됨 %d 몇 시간 전",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "편집됨 방금",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "편집됨 %d 몇 분 전",
    "PROJECTS_PROGRESS_TEXT_LOADING": "로드 중",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "검색 중",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "가져오기를 중지하시겠습니까?",
    "PROJECTS_TEXT_NOTHING_FOUND": "아무것도 찾을 수 없음",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "아름다운 새 프로젝트 만들기",
    "PROJECTS_TEXT_CAPTION": "프로젝트",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "프로젝트 이름",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "업로드하려면 클릭하거나 프로젝트 파일을 여기로 끌어다 놓으세요",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "한 번에 하나의 파일만 업로드할 수 있습니다",
    "PROJECTS_PREFIX_TEXT_EDITED": "편집됨",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "정말 삭제하시겠습니까",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "이 프로젝트는 즉시 삭제됩니다. 이 작업은 취소할 수 없습니다.",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "프로젝트",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "하나의 파일만 업로드할 수 있습니다",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "잘못된 파일 확장자입니다. .edl.zip이어야 합니다.",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "값을 입력하세요",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "미디어에 이 프로젝트의 폴더를 만듭니다",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "편집기 열기",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "다시 시도",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "프로젝트의 프레임 속도 선택",
    "PROJECTS_EXPORT_TITLE": "프로젝트 내보내기",
    "PROJECTS_EXPORT_INPROGRESS": "진행 중인 내보내기...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "미디어 포함",
    "PROJECTS_EXPORT_COMPLETE": "프로젝트 내보내기가 완료되었습니다",
    "PROJECTS_EXPORT_BTN_BROWSE": "찾아보기",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "다운로드",
    "PROJECTS_EXPORT_BTN_COPY": "복사",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "미디어의 파일이 여기에서 재생됩니다",
    "PREVIEW_BTN_PREV_TOOLTIP": "이전",
    "PREVIEW_BTN_PREV": "이전",
    "PREVIEW_BTN_PLAY_TOOLTIP": "플레이",
    "PREVIEW_BTN_PLAY": "플레이",
    "PREVIEW_BTN_STOP_TOOLTIP": "중지",
    "PREVIEW_BTN_STOP": "중지",
    "PREVIEW_BTN_NEXT_TOOLTIP": "다음",
    "PREVIEW_BTN_NEXT": "다음",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "볼륨",
    "PREVIEW_BTN_VOLUME": "볼륨",
    "PREVIEW_BTN_FRAME_CAPTURE": "프레임 캡처",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "프레임 캡처",
    "PREVIEW_BTN_FULL_SCREEN": "전체 화면",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "전체 화면",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "마크인",
    "PREVIEW_BTN_MARK_IN": "마크인",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "마크 아웃",
    "PREVIEW_BTN_MARK_OUT": "마크 아웃",
    "PREVIEW_HEADER_TITLE_SOURCE": "출처",
    "PREVIEW_HEADER_TITLE_TIMELINE": "타임라인",
    "PREVIEW_MODE_AUTO": "자동",
    "PREVIEW_MODE_SOURCE": "출처",
    "PREVIEW_MODE_TIMELINE": "타임라인",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "출력",
    "PUBLISH_SETTINGS_TITLE": "제목",
    "QR_CODE_DIALOG_TITLE": "QR 코드를 스캔하세요 (유효 기간 24시간)",
    "QR_CODE_LOAD_ERROR": "오류! QR 코드를 생성할 수 없습니다.",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "동일한 타임라인에 서로 다른 비디오 인코더 매개변수를 가진 비디오 파일을 추가하지 않도록 방지",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "양자화 매개변수와 비디오 매개변수 간 불일치 무시",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "첫 번째 클립부터 렌더링 시작",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "출력 이름 묻기",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "취소 시 게시 설정 닫기",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "기간",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "코덱",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "프레임 속도",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - 스테레오",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "해상도",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "오디오",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "크기(대략적인)",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "트랜스코딩 파일에 대한 링크가 손실됩니다.",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "설정 게시",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "비디오 렌더링 완료",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "이름 입력",
    "SAVE_SETTINGS_BTN_RENDER_START": "시작",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "시작",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "내 계정으로 돌아가기",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "내 계정으로 돌아가기",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "취소",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "취소",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "다운로드",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "다운로드",
    "SAVE_SETTINGS_BTN_BROWSE": "찾아보기",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "찾아보기",
    "SAVE_SETTINGS_BTN_COPY": "복사",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "복사",
    "SAVE_SETTINGS_TEXT_TITLE": "제목",
    "SAVE_SETTINGS_TEXT_LOADING": "로드 중",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "이미지 준비",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "이 동영상이 계정에 제출되었으며 곧 사용할 수 있습니다.",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "모두",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "검색",
    "SHOW_MY_MEDIA_POOL": "내 미디어 풀 표시",
    "SHOW_PROJECT_MEDIA_POOL": "프로젝트 미디어 풀 표시",
    "SHOW_EDITOR_HEADER": "에디터 헤더 표시",
    "SHOW_MENU_TABS": "메뉴 탭 표시",
    "SHOW_PREVIEW_SPLIT_BUTTON": "미리보기 분할 버튼 표시",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "미리보기 전환 버튼 표시",
    "SHOW_INOUT_POINTS_TIMELINE": "타임라인 인/아웃 포인트 표시",
    "SHOW_INOUT_POINTS_SOURCE": "소스 인/아웃 포인트 표시",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "빈 타임라인에 가져오기 자리 표시자 표시",
    "VIEW_SETTINGS_LANG": "언어",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "설명",
    "SETTINGS_HEAD_BTN_DELETE": "삭제",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "삭제",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "동일 선택",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "동일 선택",
    "SETTINGS_HEAD_BTN_CLOSE": "닫기",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "닫기",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "너비",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "높이",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "종횡비 유지",
    "SETTINGS_BTN_FIT_TO_FRAME": "프레임에 맞춤",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "프레임에 맞춤",
    "SETTINGS_BTN_FILL_FRAME": "프레임 채우기",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "프레임 채우기",
    "SETTINGS_TEXT_AUTO": "자동",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "텍스트 변형 없음",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "텍스트 변형 없음",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "텍스트 변환 대문자",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "텍스트 변환 대문자",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "텍스트 변환 소문자",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "텍스트 변환 소문자",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "텍스트 변환 대문자",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "텍스트 변형 대문자",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "폰트 패밀리",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "글꼴 패밀리",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "글꼴 크기 ",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "글꼴 크기",
    "SETTINGS_TEXT_BTN_BOLD": "굵게",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "굵게",
    "SETTINGS_TEXT_BTN_ITALIC": "이탤릭체",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "이탤릭체",
    "SETTINGS_TEXT_BTN_UNDERLINE": "밑줄",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "밑줄",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "왼쪽",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "왼쪽",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "오른쪽",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "오른쪽",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "가운데",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "가운데",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "맞춤",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "맞춤",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "상단",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "상단",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "왼쪽 상단",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "왼쪽 상단",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "오른쪽 상단",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "오른쪽 상단",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "왼쪽",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "왼쪽",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "가운데 가운데",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "가운데 가운데",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "오른쪽",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "오른쪽",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "왼쪽 하단",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "왼쪽 하단",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "하단",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "하단",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "하단",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "오른쪽 하단",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "가로",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "세로",
    "SETTINGS_ROTATION_TEXT_ROTATE": "회전",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "텍스트 입력",
    "NABLET_HLD_PROJECT_POSTFIX": "하이라이트",
    "NABLET_HLD_CAPTION": "하이라이트 감지",
    "NABLET_HLD_DETECTED_BTN_START": "시작",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "프로젝트 생성",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "취소",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "감지된 간격 수:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "작업을 종료하시겠습니까?",
    "NABLET_HLD_DETECTED_BTN_NO": "아니오",
    "NABLET_HLD_DETECTED_BTN_YES": "예",
    "NB_HLD_STATUS_TEXT_DETECTING": "감지 중",
    "NABLET_HLD_TARGET_DURATION_SEC": "목표 지속 시간(초)",
    "AI_MODEL": "AI 모델",
    "TRANSCRIBE_CAPTION": "미디어 음성 변환",
    "TRANSCRIBE_PROJECT_POSTFIX": "전사됨",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "음성 변환 중",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "텍스트 항목 수:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "프로젝트 생성",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "이 섹션은 개발 중입니다.",
    "TEXT_FORM_CAPTION_SIZE": "크기",
    "TEXT_FORM_CAPTION_OUTLINE": "개요",
    "TEXT_FORM_CAPTION_FONT": "폰트",
    "TEXT_FORM_CAPTION_SHADOW": "그림자",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "텍스트 설정",
    "TEXT_FORM_TEXT_OFFSET": "오프셋",
    "TEXT_FORM_TEXT_BLUR": "흐리게",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "텍스트",
    "TIMELINE_TEXT_DRAG_N_DROP": "드래그 앤 드롭",
    "TIMELINE_TEXT_ADD_LAYER": "+ 레이어 추가",
    "TIMELINE_TOOLBAR_BTN_UNDO": "실행 취소",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "실행 취소",
    "TIMELINE_TOOLBAR_BTN_REDO": "다시 실행",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "재실행",
    "TIMELINE_TOOLBAR_BTN_DELETE": "삭제",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "삭제",
    "TIMELINE_TOOLBAR_BTN_COPY": "클립 복사",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "클립 복사",
    "TIMELINE_TOOLBAR_BTN_CUT": "클립 잘라내기",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "클립 잘라내기",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "마커 추가",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "마커 추가",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "붙여넣기",
    "TIMELINE_TOOLBAR_BTN_PASTE": "붙여넣기",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "설정",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "설정",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "보이스 오버",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "보이스 오버",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "웹 카메라",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "웹 카메라",
    "TIMELINE_TOOLBAR_BTN_LIVE": "라이브 스트리밍",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "라이브 스트리밍",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "취소하려면 클릭",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "취소하려면 클릭",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "드래그 앤 드롭",
    "TIMELINE_FOOTER_TEXT_DURATION": "기간",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "프로젝트를 게시할 수 없습니다",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "비디오 트랙이 필요합니다",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "저장",
    "TIMELINE_FOOTER_BTN_SAVE": "저장",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "저장",
    "TIMELINE_FOOTER_BTN_PUBLISH": "게시",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "게시",
    "TIMELINE_SLIDER_POINTER": "슬라이더 포인터",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "슬라이더 포인터",
    "TRANSITION_NAME_DISSOLVE": "해체",
    "TRANSITION_NAME_FADE_IN": "점차적으로 나타나기",
    "TRANSITION_NAME_FADE_OUT": "점차적으로 사라지기",
    "TRANSITION_NAME_DIP_TO_BLACK": "검은색으로 전환",
    "TRANSITION_NAME_DIP_TO_WHITE": "흰색으로 전환",
    "TRANSITION_NAME_BLUR": "흐림",
    "TRANSITION_NAME_WIPE_RIGHT": "오른쪽으로 닦기",
    "TRANSITION_NAME_WIPE_LEFT": "왼쪽으로 닦기",
    "TRANSITION_NAME_WIPE_UP": "위쪽으로 닦기",
    "TRANSITION_NAME_WIPE_DOWN": "아래쪽으로 닦기",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "전환 설정",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "타임라인의 모든 전환에 적용",
    "TRANSITION_FORM_SELECTED": "선택된:",
    "TRANSITION_FORM_LABEL_TYPE": "유형",
    "TRANSITION_FORM_LABEL_DURATION": "지속 시간(초)",
    "TRANSITION_LIST_CAPTION_TRANSITION": "전환",
    "used_in_projects": "미디어 파일이 하나 이상의 프로젝트에서 사용 중이기 때문에 삭제되지 않았습니다. 계속 진행하면 해당 프로젝트의 타임라인에서 파일을 사용할 수 없으며 계정에서 삭제됩니다.",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "로컬 파일 가져오기 시 모달 대화 상자 사용",
    "VOICE_OVER_TITLE_LAST_RECORDING": "마지막 녹음",
    "VOICE_OVER_BTN_RETAKE": "재촬영",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "재촬영",
    "VOICE_OVER_BTN_DELETE_FILE": "파일 삭제:",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "파일 삭제",
    "VOICE_OVER_BTN_START_RECORDING": "녹음 시작",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "녹음 시작",
    "VOICE_OVER_BTN_CONNECTION": "연결...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "연결...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "파일이 타임라인과 미디어에서 삭제됩니다.",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "확실해요?",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "음성 내레이션",
    "VOICE_OVER_TEXT_MIC": "마이크",
    "VOICE_OVER_LABEL_SELECT_MIC": "마이크 선택",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "오디오 없음",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "녹화 중 타임라인 음소거",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "녹화 후 시작 시 슬라이더 되감기",
    "VOICE_OVER_TEXT_COUNTDOWN": "카운트다운",
    "VOICE_OVER_BTN_TEST_MIC": "테스트 마이크",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "테스트 마이크",
    "VOICE_OVER_BTN_RECORDING": "녹음 중...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "녹음 중...",
    "VOICE_OVER_BTN_PLAYING": "재생 중...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "재생 중...",
    "VOICE_OVER_BTN_YES": "예",
    "VOICE_OVER_BTN_YES_TOOLTIP": "예",
    "VOICE_OVER_BTN_NO": "아니오",
    "VOICE_OVER_BTN_NO_TOOLTIP": "아니오",
    "VOICE_OVER_BTN_STOP": "중지",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "중지",
    "VOICE_OVER_BTN_DELETE": "삭제",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "삭제",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "자동 조정",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "기타 설정",
    "WEBCAM_TEXT_RECORD_VIDEO": "비디오 녹화",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "라이브 스트리밍 URL",
    "LIVE_STREAM_URL_INPUT_LABEL": "실시간 스트리밍 URL",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "여기를 클릭하여 라이브 스트리밍에 연결하세요",
    "LIVE_STREAM_BTN_CONNECTING": "연결 중...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "연결 중...",
    "LIVE_STREAM_BTN_CAPTURE": "캡처 시작",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "캡처 시작",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "캡처 중지",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "캡처 중지",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "줌 감소",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "줌 감소",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "확대/축소 증가",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "확대/축소 증가",
    "SETTINGS_HOTKEYS": "단축키 설정",
    "PRESET": "프리셋",
    "DEFAULT": "기본값",
    "ADD_NEW": "새로 추가",
    "SEARCH_COMMAND": "검색 명령",
    "COMMAND": "명령",
    "SHORTCUTS": "바로 가기",
    "ALL": "모두",
    "TIMELINE": "타임라인",
    "TOOLS": "도구",
    "PREVIEW": "미리보기",
    "KEYBOARD_MAPPING_PRESET": "키보드 매핑 프리셋",
    "ENTER_PRESET_NAME": "사전 설정 이름 입력",
    "THIS_PRESET_WILL_BE_DELETED": "이 프리셋은 즉시 삭제됩니다. 이 작업은 실행 취소할 수 없습니다.",
    "RESET_ALL_TO_DEFAULTS": "모두 기본값으로 재설정",
    "HOTKEY_SETTINGS_UNDO": "실행 취소",
    "HOTKEY_SETTINGS_REDO": "재실행",
    "HOTKEY_SETTINGS_ZOOM_IN": "확대",
    "HOTKEY_SETTINGS_ZOOM_OUT": "줌아웃",
    "HOTKEY_SETTINGS_PREV_FRAME": "이전 프레임",
    "HOTKEY_SETTINGS_NEXT_FRAME": "다음 프레임",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "타임라인에 추가",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "클립 볼륨 높이기",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "클립 볼륨 줄이기",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "리플 삭제",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "리플 트림 이전",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "다음 리플 트림",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "현재 위치에서 클립 선택",
    "HOTKEY_SETTINGS_CUT_CLIPS": "클립 잘라내기",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "재생/일시정지",
    "HOTKEY_SETTINGS_DELETE": "삭제",
    "HOTKEY_SETTINGS_COPY": "복사",
    "HOTKEY_SETTINGS_PASTE": "붙여넣기",
    "HOTKEY_SETTINGS_PLAY": "플레이",
    "HOTKEY_SETTINGS_PAUSE": "일시 중지",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "강조 표시된 구간 재생",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "포인트 클리어 인 아웃",
    "HOTKEY_SETTINGS_MARK_IN": "포인트에 표시",
    "HOTKEY_SETTINGS_MARK_OUT": "마크 아웃 포인트",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "포인트 찾기",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "아웃 포인트 찾기",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "슬라이더를 다음 클립 편집 지점으로 이동",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "슬라이더를 이전 클립 편집 지점으로 이동",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "내 미디어 표시 상태 전환",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "편집기 설정 표시/숨기기",
    "CLIP_SETTINGS": "클립 설정",
    "MESSAGE_BOX_INCOMPATIBLE": "파일이 호환되지 않습니다",
    "MESSAGE_BOX_REMOVE_EXISTING": "파일이 호환되지 않습니다(형식 불일치)",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "파일이 호환되지 않습니다(해상도 불일치)",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "파일이 호환되지 않습니다(프레임 속도 불일치)",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "파일이 호환되지 않습니다(코덱 불일치)",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "파일들이 호환되지 않습니다 (DF/NDF 타임코드 형식 불일치)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "파일 간 호환되지 않습니다 (색 공간 불일치)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "파일 간 호환되지 않습니다 (비디오 인코더 매개변수 불일치)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "파일이 호환되지 않습니다(오프라인 클립을 삭제해 주세요)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "전사 모델을 찾을 수 없습니다. 다운로드(~882 MB) 후 설치하시겠습니까?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "스포츠 하이라이트 감지 모델을 찾을 수 없습니다. 다운로드(~3.9 GB) 후 설치하시겠습니까?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "스포츠 하이라이트 감지에는 연산 능력이 7.5 이상인 NVIDIA GPU가 필요합니다",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "동일한 타임라인에 코덱, 해상도, FPS, DF/NDF 타임코드, 색 공간이 서로 다른 비디오 파일을 추가하지 않도록 방지합니다",
    "MARKS_CONTEXT_MENU_MARK_IN": "마크 인",
    "MARKS_CONTEXT_MENU_MARK_OUT": "마크 아웃",
    "MARKS_CONTEXT_MENU_CLEAR": "클리어 인/아웃 포인트",
    "MEDIA_ERROR_build_thumbnails_error": "축소판 오류 빌드",
    "MEDIA_ERROR_unsupported_media": "지원되지 않는 미디어",
    "MEDIA_ERROR_exceeded_file_size": "파일 크기 초과",
    "MEDIA_ERROR_exceeded_per_user_size": "사용자당 크기 초과",
    "MEDIA_ERROR_low_disk_space": "디스크 공간 부족",
    "MEDIA_ERROR_internal_server_error": "내부 서버 오류",
    "MEDIA_ERROR_network_error": "네트워크 오류",
    "MEDIA_ERROR_not_found": "미디어 파일을 찾을 수 없음",
    "MEDIA_ERROR_unable_get_media_info": "미디어 정보를 가져올 수 없습니다",
    "MEDIA_ERROR_not_enough_tokens": "토큰이 부족합니다",
  },
  ru: {
    "ADD_FOLDER_BTN": "Добавить папку",
    "ADD_FOLDER_BTN_TOOLTIP": "Добавить папку",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "Добавлять первый импортированный файл на временную шкалу используя тайм-код",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "Разрешить изменение макета временной шкалы/мультимедиа",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "Bucket Name",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "ID ключа доступа",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "Секретный ключ",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "Импортирование",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "Ошибка импорта",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "Импортировано успешно",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "Импортировать медиа из AWS Bucket",
    "AMAZON_IMPORT_BTN_IMPORT": "Импорт",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "Импорт",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "Запрашивать название проекта при создании",
    "AUDIO_CAPTION_AUDIO": "Аудио",
    "AUDIO_TEXT_FOUND_ITEMS": "Найденные элементы",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "Результаты не найдены",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "Ничего не найдено по вашему запросу",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "Настройки аудио",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "Звук",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "Переход",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "Проявление (сек.)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "Затухание (сек.)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "Поиск по жанру",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "Поиск музыки",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "Поиск звуковых эффектов",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "Искать в",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "Музыка по жанрам",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "Звуковые эффекты",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "Музыка по настроению",
    "AUDIO_MENU_ITEM_ALL": "Все",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "Переходы",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "Автовоспроизведение выбранного медиа",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "Удалить элемент с временной шкалы?",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "Установить формата таймкода в зависимости от носителя",
    "BATCH_IMPORT_FILES_HEAD": "Импорт файлов",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "Анализ",
    "CAPTION_ADDED": "Добавлено",
    "CAPTION_SKIPPED": "Пропущено",
    "COLOR_PICKER_BTN_COLOR": "Выберите цвет",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "Выберите цвет",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "Цвет фона",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "Цвет фона",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "Загрузка медиафайлов",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "Импортирование медиа файлов",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "Загрузка сохраненных медиа",
    "COMMON_STATUS_TEXT_ABORTED": "Прервано",
    "COMMON_STATUS_TEXT_LOADING": "Загрузка",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "Задача поставлена в очередь",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "Подготовка изображений",
    "COMMON_STATUS_TEXT_RENDERING": "Рендеринг",
    "COMMON_STATUS_TEXT_CONVERT": "Конвертирование",
    "COMMON_YES": "Да",
    "COMMON_NO": "Нет",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "Сбросить все изменения",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "Отмена",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "Отмена",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "Аватар пользователя",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "Вы можете загрузить файл с аватаром пользователя по умолчанию.",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "Аватар",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "Цветовая тема",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "Пользовательский JS-скрипт",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "Пользовательский текст",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "Вы можете настроить текст редактора",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "Этот скрипт запускается при загрузке редактора. Его можно использовать для интеграции аналитики и т. д.",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "Редактировать JS-скрипт",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "Второй акцентный цвет",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "Выберите цвет основного фона",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "Основной акцентный цвет для элементов управления. Укажите здесь свой фирменный цвет.",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "Дополнительный цвет элементов управления в паре с основным цветом кнопок.",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "Аудиофайл на временной шкале имеет свой собственный стиль",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "Вы можете загрузить файл с вашим логотипом",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "Файл озвучки имеет свой собственный стиль",
    "CUSTOMIZATION_LABEL_DISPLAYED": "отображается",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "Выберите одну из предопределенных тем или создайте свою собственную. Вы можете отредактировать CSS-файл, чтобы настроить свою тему.",
    "CUSTOMIZATION_TITLE_BASIC_BG": "Основной фон",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "Основные кнопки, ссылки",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "Редактировать CSS-файл для темы",
    "CUSTOMIZATION_TITLE_AUDIO": "Аудио",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "Озвучка",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "Изменить текстовые значения",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "Изменить текстовые значения",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "Изменить текстовые значения",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "Описание формата",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "Описание формата",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "Сбросить все изменения",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "Сбросить все изменения",
    "CUSTOMIZATION_BTN_CANCEL": "Отмена",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "Отмена",
    "CUSTOMIZATION_BTN_SAVE": "Сохранить",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "Сохранить",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "Редактировать JS-скрипт",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "Редактировать JS-скрипт",
    "CUSTOMIZATION_BTN_EDIT_CSS": "Редактировать CSS",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "Редактировать CSS",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "Загрузить логотип",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "Загрузить логотип",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "Удалить логотип",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "Удалить логотип",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "Темная тема",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "Светлая тема",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "Пользовательская тема",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "Логотип",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "Логотип",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "Настроить редактор",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "Логотип и название",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "Название компании",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "Название редактора",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "Принятые файлы:",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "Нет загруженного логотипа",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "Просмотр настроек",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "Просмотр настроек",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "Фильтры",
    "DUMMY_HEADER_BTN_FILTERS": "Фильтры",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Сохранить проект как...",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "Панель администратора",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "Новый проект",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "Опубликовать",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "Настроить редактор",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Расширения Adobe CEP",
    "EDITOR_MENU_MAIN_LOGS": "Логирование",
    "EDITOR_MENU_MAIN_SETTINGS": "Настройки",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "Невозможно опубликовать",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "Треки обязательны",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "Настройки рендеринга",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "Поведение",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "Просмотр",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "Сохранить",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "Отмена",
    "FILE_INPUT_BTN": "Ввод файла",
    "FILE_INPUT_BTN_TOOLTIP": "Ввод файла",
    "FORM_FIELD_LABEL_VOLUME": "Громкость",
    "folder_not_empty": "Папка не пуста. Файлы могут использоваться в проектах. Если вы продолжите, файлы на временной шкале в соответствующих проектах станут недоступны.",
    "HEAD_CONTROL_IMPORT_TEXT": "Импорт",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "Импорт медиа",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "Импорт с телефона",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "Импортировать папку с медиа",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Amazon S3 Bucket",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Google Drive",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "Ввод URL",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Сохранить проект как...",
    "HEADER_MENU_LIST_ITEM_DELETE": "Удалить",
    "HEADER_MENU_LIST_ITEM_RENAME": "Переименовать",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "Добавить лицензионный ключ",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "Выйти из системы",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "Вы хотите покинуть редактор?",
    "HEADER_BTN_BACK_TO_MY_ACC": "Вернуться в мой аккаунт",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "Вернуться в мой аккаунт",
    "HEADER_BTN_HELP": "Помощь",
    "HEADER_BTN_HELP_TOOLTIP": "Помощь",
    "IMAGES_TEXT_NATIVE_IMAGES": "Встроенные изображения",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "Изображения",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "Искать в",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "Выберите коллекцию",
    "IMAGES_TEXT_ALL_CATEGORIES": "Все коллекции",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "Ничего не найдено",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "Ничего не найдено по вашему запросу.",
    "IMAGES_TAB_AI_GENERATED": "Сгенерировано ИИ",
    "IMAGES_TAB_SEARCH": "Поиск",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "Импортировать медиа из URL",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "Введите ссылку на файл здесь",
    "IMPORT_FROM_URL_BTN_IMPORT": "Импорт",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "Импорт",
    "IMPORT_TOKEN_INVALID": "Невалидный токен импорта",
    "LAYER_CONTROL_BTN_MOVE_UP": "Передвинуть вверх",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "Передвинуть вверх",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "Передвинуть слой",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "Передвинуть слой",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "Передвинуть вниз",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "Передвинуть вниз",
    "LAYER_CONTROL_BTN_DELETE": "Удалить",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "Удалить",
    "LAYER_CONTROL_BTN_HIDE": "Скрыть",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "Скрыть",
    "LAYER_CONTROL_BTN_SHOW": "Показать",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "Показать",
    "LAYER_CONTROL_BTN_MUTE": "Выкл. звук",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "Выкл. звук",
    "LAYER_CONTROL_BTN_UNMUTE": "Вкл. звук",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "Вкл. звук",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "Мои медиа",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "Мои медиа",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "Медиа проекта",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "Медиа проекта",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "Переходы",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "Переходы",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "Изображения",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "Изображения",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "Аудио",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "Аудио",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "Текст",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "Текст",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "Дизайн",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "Дизайн",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "Фильтры",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "Фильтры",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "Фильтры",
    "MEDIA_API_IS_NOT_AVAILABLE": "Ошибка: Для работы Voiceover WebAPI требуется https",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "Настройки изображения",
    "MEDIA_FORM_CAPTION_POSITION": "Положение",
    "MEDIA_FORM_CAPTION_ROTATION": "Поворот",
    "MEDIA_FORM_CAPTION_SETTINGS": "Настройки",
    "MEDIA_FORM_CAPTION_OUTLINE": "Обводка",
    "MEDIA_FORM_CAPTION_SHADOW": "Тень",
    "MEDIA_FORM_CAPTION_SIZE": "Размер",
    "MEDIA_FORM_CAPTION_VIDEO": "Видео",
    "MEDIA_FORM_CAPTION_AUDIO": "Аудио",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "Непрозрачность",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "Фильтр",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "Фильтр",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "Все",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "Видео",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "Изображение",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "Аудио",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "Папка",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "Озвучка",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "Настройки просмотра",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "Настройки просмотра",
    "MEDIA_UPLOADER_TEXT_OR": "или",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "Перетащите сюда ваши медиафайлы",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "импортировать медиа",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "Импортирование",
    "MEDIA_PREVIEW_TEXT_RENDERING": "Рендеринг",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "Разрешение",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "Градусы поворота",
    "MEDIA_INFO_LIST_ITEM_CODEC": "Кодеки",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "Цветовое пространство",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "Частота кадров",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - Stereo",
    "MEDIA_INFO_LIST_ITEM_DURATION": "Длительность",
    "MEDIA_INFO_LIST_ITEM_TYPE": "Тип",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "Аудио",
    "MEDIA_INFO_LIST_ITEM_SIZE": "Размер",
    "MEDIA_INFO_LIST_TASK_STATUS": "Статус задачи",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "Старт таймкод",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "Параметры видеокодера",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "Мои медиа",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "Медиа проекта",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "Загрузить больше медиа",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "Загрузить больше медиа",
    "MEDIA_BTN_LOADING": "Загрузка",
    "MEDIA_BTN_LOADING_TOOLTIP": "Загрузка",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "Хромакей",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "Положение",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "Звук",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "РАЗМЕР",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "Настройки медиа",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "Сбросить все настройки",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "Сбросить все настройки",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "Сходство",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "Плавность",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "Уменьшение переливов ключевых цветов",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "Выберите цвет из превью",
    "MEDIA_SORT_OPTION_DURATION": "Длительность",
    "MEDIA_SORT_OPTION_DATE": "Дата",
    "MEDIA_SORT_OPTION_SIZE": "Размер",
    "MEDIA_SORT_OPTION_NAME": "Имя",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "Сортировать по",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "Порядок",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "Вид",
    "MEDIA_SORT_OPTION_ASCENDING": "По возрастанию",
    "MEDIA_SORT_OPTION_DESCENDING": "По убыванию",
    "MEDIA_SORT_OPTION_LIST": "Список",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "Большие иконки",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "Мои записи",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "Мои записи",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "Мои медиа",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "Мои медиа",
    "MEDIA_FILES_DELETE_FORM_TITLE": "Некоторые файлы используются в проектах и не были удалены",
    "MEDIA_FILES_DELETE_FORM_DESC": "Выбранные файлы будут удалены из медиатеки и больше не будут доступны в проектах",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "Файлы, используемые в проектах",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "Выбрать все",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "Вы уверены, что хотите удалить выбранные элементы?",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "Просмотр папки",
    "MEDIA_CONFIRM_BTN_DELETE": "Удалить",
    "MEDIA_CANCEL_BTN_DELETE": "Отмена",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "Удалить",
    "MEDIA_CONFIRM_TITLE_DELETE": "Удалить",
    "MEDIA_TEXT_LOADING": "Загрузка",
    "MEDIA_BTN_ADD": "Добавить",
    "MEDIA_BTN_ADD_TOOLTIP": "Добавить",
    "MEDIA_PROGRESS_TEXT_LOADING": "Загрузка",
    "MEDIA_PROGRESS_TEXT_SAVING": "Сохранение",
    "MEDIA_PROGRESS_TEXT_CONVERT": "Конвертировать",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "Передача",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "Анализ",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "Выбрать папку",
    "MEDIA_MENU_ITEM_MEDIA": "Медиа",
    "MEDIA_MENU_ITEM_MOVE_TO": "Переместить в",
    "MEDIA_MENU_ITEM_SETTINGS": "Настройки",
    "MEDIA_MENU_ITEM_NABLET_HLD": "Обнаружить спортивные моменты",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "Транскрибировать",
    "MEDIA_MENU_ITEM_DELETE": "Удалить",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "Удалить выделенные медиа файлы",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "Открыть папку медиа файла",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "Копировать адрес ссылки",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "Добавить клип используя тайм-код",
    "MEDIA_MENU_LABEL_MOVE_TO": "Переместить в",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "HTML5 Video Editor",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "Планшеты и мобильные устройства пока не поддерживаются :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "Видеоредактор хорошо работает на компьютере",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "Вернуться на сайт",
    "MOBILE_UPLOAD_TITLE": "Загрузить файлы в «Хранилище пользователя»",
    "MOBILE_UPLOAD_SUBTITLE": "Поддерживаемые форматы: видео, аудио, фотографии. Ваши файлы будут сохранены в «Хранилище пользователя»",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "Чтобы сменить язык, необходимо перезапустить приложение",
    "MODAL_WINDOW_LOGS_TITLE": "Чтобы включить или выключить логи, необходимо перезапустить приложение",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "Выберите референсный файл",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "Вы добавляете файлы с разными FPS/разрешением/кодеком. Выберите файл, свойства которого будут применены к проекту",
    "MODAL_WINDOW_BUTTON_RESTART": "Перезапустить",
    "MUTE_AUDIO_AT_CREATED_LAYERS": 'Отключение звука на созданных слоях',
    "NAVIGATION_TAB_EDITOR": "Редактор",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "Редактор",
    "NAVIGATION_TAB_PROJECTS": "Проекты",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "Проекты",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "Нет подключения к сети",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "Последнее сохранение",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "мин. назад",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "только что",
    "PROJECTS_BTN_NEW_PROJECTS": "Новый проект",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "Новый проект",
    "PROJECTS_BTN_NEW_PROJECT": "Новый проект",
    "PROJECTS_BTN_IMPORT": "Импорт",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "Импорт",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "Да",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "Отмена",
    "PROJECTS_TITLE_TEXT_COPY": "Копировать",
    "PROJECTS_BTN_SAVE": "Сохранить",
    "PROJECTS_BTN_SAVE_TOOLTIP": "Сохранить",
    "PROJECTS_BTN_CREATE": "Создать",
    "PROJECTS_BTN_CREATE_TOOLTIP": "Создать",
    "PROJECTS_TITLE_TEXT_RENAME": "Переименовать",
    "PROJECTS_TITLE_TEXT_DELETE": "Удалить",
    "PROJECTS_TITLE_TEXT_EXPORT": "Экспорт",
    "PROJECTS_CONFIRM_BTN_DELETE": "Удалить",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "Отредактировано %d ч. назад",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "Отредактировано сейчас",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "Отредактировано %d мин. назад",
    "PROJECTS_PROGRESS_TEXT_LOADING": "Загрузка",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "Поиск",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "Вы хотите прекратить импорт?",
    "PROJECTS_TEXT_NOTHING_FOUND": "Ничего не найдено",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "Создать новый красивый проект",
    "PROJECTS_TEXT_CAPTION": "Проекты",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "Название проекта",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "Нажмите, чтобы загрузить, или перетащите сюда файл проекта",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "Вы можете загружать только один файл за раз",
    "PROJECTS_PREFIX_TEXT_EDITED": "Отредактировано",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "Вы уверены, что хотите удалить",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "Этот проект будет удален немедленно. Вы не сможете отменить это действие.",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "Проект",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "Можно загрузить только один файл",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "Неверное расширение файла. Должно быть *.edl.zip",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "Введите ваше значение",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "Создать папку для этого проекта в Мои Media",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "Открыть редактор",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "Попробуйте еще раз",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "Выберите частоту кадров для проекта",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "Файлы из медиа воспроизводятся здесь",
    "PROJECTS_EXPORT_TITLE": "Экспорт проекта",
    "PROJECTS_EXPORT_INPROGRESS": "Экспорт в процессе...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "Включить медиа",
    "PROJECTS_EXPORT_COMPLETE": "Экспорт проекта завершён",
    "PROJECTS_EXPORT_BTN_BROWSE": "Обзор",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "Скачать",
    "PROJECTS_EXPORT_BTN_COPY": "Копировать",
    "PREVIEW_BTN_PREV_TOOLTIP": "Предыдущий",
    "PREVIEW_BTN_PREV": "Предыдущий",
    "PREVIEW_BTN_PLAY_TOOLTIP": "Воспроизвести",
    "PREVIEW_BTN_PLAY": "Воспроизвести",
    "PREVIEW_BTN_STOP_TOOLTIP": "Стоп",
    "PREVIEW_BTN_STOP": "Стоп",
    "PREVIEW_BTN_NEXT_TOOLTIP": "Следующий",
    "PREVIEW_BTN_NEXT": "Следующий",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "Громкость",
    "PREVIEW_BTN_VOLUME": "Громкость",
    "PREVIEW_BTN_FRAME_CAPTURE": "Захватить кадр",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "Захватить кадр",
    "PREVIEW_BTN_FULL_SCREEN": "Полный экран",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "Полный экран",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "Отметить вход",
    "PREVIEW_BTN_MARK_IN": "Отметить вход",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "Отметить выход",
    "PREVIEW_BTN_MARK_OUT": "Отметить выход",
    "PREVIEW_HEADER_TITLE_SOURCE": "Исходный файл",
    "PREVIEW_HEADER_TITLE_TIMELINE": "Элемент временной шкалы",
    "PREVIEW_MODE_AUTO": "Авто",
    "PREVIEW_MODE_SOURCE": "Исходный файл",
    "PREVIEW_MODE_TIMELINE": "Таймлайн",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "результат",
    "PUBLISH_SETTINGS_TITLE": "Название",
    "QR_CODE_DIALOG_TITLE": "Отсканируйте QR-код (срок действия — 24 часа)",
    "QR_CODE_LOAD_ERROR": "Ошибка! Не удалось создать QR код",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "Предотвратить добавление видеофайлов с различными параметрами видеокодера на одну и ту же временную шкалу",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "Игнорировать несоответствие параметров квантования и параметров видео",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "Начать рендеринг с первого клипа",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "Спрашивать имя выходного файла",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "Закрывать окно публикации при отмене",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "Длительность",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "Кодек",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "Частота кадров",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - Stereo",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "Разрешение",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "Аудио",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "Размер (приблизительно)",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "Ссылка на файл транскодирования будет потеряна",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "Настройки публикации",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "Рендеринг видео завершен",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "Введите имя",
    "SAVE_SETTINGS_BTN_RENDER_START": "Старт",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "Старт",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "Вернуться в мой аккаунт",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "Вернуться в мой аккаунт",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "Отмена",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "Отмена",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "Загрузить",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "Загрузить",
    "SAVE_SETTINGS_BTN_BROWSE": "Обзор",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "Обзор",
    "SAVE_SETTINGS_BTN_COPY": "Копировать",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "Копировать",
    "SAVE_SETTINGS_TEXT_TITLE": "Название",
    "SAVE_SETTINGS_TEXT_LOADING": "Загрузка",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "Подготовка изображений",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "Это видео было отправлено на ваш аккаунт и скоро будет доступно.",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "Все",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "Поиск",
    "SHOW_MY_MEDIA_POOL": "Показывать мои медиа",
    "SHOW_PROJECT_MEDIA_POOL": "Показывать медиа-пул для проекта",
    "SHOW_EDITOR_HEADER": "Показывать заголовок редактора",
    "SHOW_MENU_TABS": "Показывать вкладки меню",
    "SHOW_PREVIEW_SPLIT_BUTTON": "Показывать кнопку разделения предпросмотра",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "Показывать кнопки переключения предпросмотра",
    "SHOW_INOUT_POINTS_TIMELINE": "Показывать точки входа/выхода на таймлайне",
    "SHOW_INOUT_POINTS_SOURCE": "Показывать точки входа/выхода на исходнике",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "Показывать место для импорта на пустом таймлайне",
    "VIEW_SETTINGS_LANG": "Язык",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "Описание",
    "SETTINGS_HEAD_BTN_DELETE": "Удалить",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "Удалить",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "Выбрать все",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "Выбрать все",
    "SETTINGS_HEAD_BTN_CLOSE": "Закрыть",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "Закрыть",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "Ширина",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "Высота",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "Сохранять соотношение сторон",
    "SETTINGS_BTN_FIT_TO_FRAME": "Подогнать под рамку",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "Подогнать под рамку",
    "SETTINGS_BTN_FILL_FRAME": "Рамка заполнения",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "Заполнить рамку",
    "SETTINGS_TEXT_AUTO": "авто",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "Нет преобразования текста",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "Нет преобразования текста",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "Преобразование текста в верхний регистр",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "Преобразование текста в верхний регистр",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "Преобразование текста в нижний регистр",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "Преобразование текста в нижний регистр",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "Каждое слово с заглавной буквы",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "Каждое слово с заглавной буквы",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "Семейство шрифтов",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "Семейство шрифтов",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "Размер шрифта",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "Размер шрифта",
    "SETTINGS_TEXT_BTN_BOLD": "Жирный",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "Жирный",
    "SETTINGS_TEXT_BTN_ITALIC": "Курсив",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "Курсив",
    "SETTINGS_TEXT_BTN_UNDERLINE": "Подчеркивание",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "Подчеркивание",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "Слева",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "Слева",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "Справа",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "Справа",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "По центру",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "По центру",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "По ширине",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "По ширине",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "Сверху",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "Сверху",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "Слева сверху",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "Слева сверху",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "Справа сверху",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "Справа сверху",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "Слева",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "Слева",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "В центре",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "в центре",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "Справа",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "Справа",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "Слева снизу",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "Слева снизу",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "Снизу",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "Снизу",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "Справа снизу",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "Справа снизу",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "Горизонтально",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "Вертикально",
    "SETTINGS_ROTATION_TEXT_ROTATE": "Поворот",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "Введите текст",
    "NABLET_HLD_PROJECT_POSTFIX": "моменты",
    "NABLET_HLD_CAPTION": "Обнаружить моменты",
    "NABLET_HLD_DETECTED_BTN_START": "Начать",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "Создать проект(ы)",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "Отмена",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "Обнаруженное количество интервалов:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "Вы уверены, что хотите завершить задачу?",
    "NABLET_HLD_DETECTED_BTN_NO": "Нет",
    "NABLET_HLD_DETECTED_BTN_YES": "Да",
    "NB_HLD_STATUS_TEXT_DETECTING": "Обнаружение",
    "NABLET_HLD_TARGET_DURATION_SEC": "Целевая длительность (секунды)",
    "AI_MODEL": "Модель ИИ",
    "TRANSCRIBE_CAPTION": "Транскрибировать медиафайл",
    "TRANSCRIBE_PROJECT_POSTFIX": "транскрибировано",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "Транскрибирование",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "Количество текстовых элементов:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "Создать проект",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "Этот раздел находится в разработке",
    "TEXT_FORM_CAPTION_SIZE": "Размер",
    "TEXT_FORM_CAPTION_OUTLINE": "Обводка",
    "TEXT_FORM_CAPTION_FONT": "Шрифт",
    "TEXT_FORM_CAPTION_SHADOW": "Тень",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "Настройки текста",
    "TEXT_FORM_TEXT_OFFSET": "Отступ",
    "TEXT_FORM_TEXT_BLUR": "Размытие",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "Текст",
    "TIMELINE_TEXT_DRAG_N_DROP": "Перетащить",
    "TIMELINE_TEXT_ADD_LAYER": "+ Добавить слой",
    "TIMELINE_TOOLBAR_BTN_UNDO": "Отменить",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "Отменить",
    "TIMELINE_TOOLBAR_BTN_REDO": "Повторить",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "Повторить",
    "TIMELINE_TOOLBAR_BTN_DELETE": "Удалить",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "Удалить",
    "TIMELINE_TOOLBAR_BTN_COPY": "Копировать клип",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "Копировать клип",
    "TIMELINE_TOOLBAR_BTN_CUT": "Вырезать клип(ы)",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "Вырезать клип(ы)",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "Добавить маркер",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "Добавить маркер",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "Вставить",
    "TIMELINE_TOOLBAR_BTN_PASTE": "Вставить",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "Настройки",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "Настройки",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "Озвучка",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "Озвучка",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "Веб-камера",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "Веб-камера",
    "TIMELINE_TOOLBAR_BTN_LIVE": "Прямая трансляция",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "Прямая трансляция",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "Нажмите, чтобы отменить",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "Нажмите, чтобы отменить",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "Перетащить",
    "TIMELINE_FOOTER_TEXT_DURATION": "Длительность",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "Невозможно опубликовать проект",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "Требуется видеодорожка",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "Сохранить",
    "TIMELINE_FOOTER_BTN_SAVE": "Сохранить",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "Сохранить",
    "TIMELINE_FOOTER_BTN_PUBLISH": "Опубликовать",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "Опубликовать",
    "TIMELINE_SLIDER_POINTER": "Указатель слайдера",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "Указатель слайдера",
    "TRANSITION_NAME_DISSOLVE": "Растворение",
    "TRANSITION_NAME_FADE_IN": "Затухание",
    "TRANSITION_NAME_FADE_OUT": "Проявление",
    "TRANSITION_NAME_DIP_TO_BLACK": "Переход к черному",
    "TRANSITION_NAME_DIP_TO_WHITE": "Переход к белому",
    "TRANSITION_NAME_BLUR": "Размытие",
    "TRANSITION_NAME_WIPE_RIGHT": "Стирание вправо",
    "TRANSITION_NAME_WIPE_LEFT": "Стирание влево",
    "TRANSITION_NAME_WIPE_UP": "Стирание вверх",
    "TRANSITION_NAME_WIPE_DOWN": "Стирание вниз",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "Настройки перехода",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "Применить ко всем переходам на временной шкале",
    "TRANSITION_FORM_SELECTED": "выбрано:",
    "TRANSITION_FORM_LABEL_TYPE": "Тип",
    "TRANSITION_FORM_LABEL_DURATION": "Продолжительность (сек.)",
    "TRANSITION_LIST_CAPTION_TRANSITION": "Переход",
    "used_in_projects": "Медиа файл не был удален, так как используется в проектах. Если вы продолжите файл на таймлайнах соответствующих проектов станет недоступен и будет удален с вашего аккаунта.",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "Показывать диалоговое окно при импорте локальных файлов",
    "VOICE_OVER_TITLE_LAST_RECORDING": "Последняя запись",
    "VOICE_OVER_BTN_RETAKE": "Переозвучить",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "Переозвучить",
    "VOICE_OVER_BTN_DELETE_FILE": "Удалить файл",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "Удалить файл",
    "VOICE_OVER_BTN_START_RECORDING": "Начать запись",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "Начать запись",
    "VOICE_OVER_BTN_CONNECTION": "Соединение...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "Подключение...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "Файл будет удален с временной шкалы и из медиа",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "Вы уверены?",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "Закадровый голос",
    "VOICE_OVER_TEXT_MIC": "Микрофон",
    "VOICE_OVER_LABEL_SELECT_MIC": "Выберите микрофон",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "Нет звука",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "Отключить звук на временной шкале во время записи",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "Установить ползунок в начало после записи",
    "VOICE_OVER_TEXT_COUNTDOWN": "Обратный отсчет",
    "VOICE_OVER_BTN_TEST_MIC": "Тест микрофона",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "Тест микрофона",
    "VOICE_OVER_BTN_RECORDING": "Запись...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "Запись...",
    "VOICE_OVER_BTN_PLAYING": "Воспроизводится...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "Воспроизводится...",
    "VOICE_OVER_BTN_YES": "Да",
    "VOICE_OVER_BTN_YES_TOOLTIP": "Да",
    "VOICE_OVER_BTN_NO": "Нет",
    "VOICE_OVER_BTN_NO_TOOLTIP": "Нет",
    "VOICE_OVER_BTN_STOP": "Стоп",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "Стоп",
    "VOICE_OVER_BTN_DELETE": "Удалить",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "Удалить",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "Автоматическая регулировка",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "Прочие настройки",
    "WEBCAM_TEXT_RECORD_VIDEO": "Запись видео",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "Запись прямой трансляции",
    "LIVE_STREAM_URL_INPUT_LABEL": "Ссылка на прямую трансляцию",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "Введите ссылку на прямую трансляцию здесь",
    "LIVE_STREAM_BTN_CONNECTING": "Соединение...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "Соединение...",
    "LIVE_STREAM_BTN_CAPTURE": "Начать запись",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "Начать запись",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "Остановить запись",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "Остановить запись",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "Уменьшить масштаб",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "Уменьшить масштаб",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "Увеличить масштаб",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "Увеличить масштаб",
    "SETTINGS_HOTKEYS": "Настройки горячих клавиш",
    "PRESET": "Пресет",
    "DEFAULT": "По умолчанию",
    "ADD_NEW": "Добавить новый",
    "SEARCH_COMMAND": "Команда поиска",
    "COMMAND": "Комманда",
    "SHORTCUTS": "Ярлыки",
    "ALL": "Все",
    "TIMELINE": "Временная шкала",
    "TOOLS": "Инструменты",
    "PREVIEW": "Просмотр",
    "KEYBOARD_MAPPING_PRESET": "Пресет раскладки клавиатуры",
    "ENTER_PRESET_NAME": "Введите имя пресета",
    "THIS_PRESET_WILL_BE_DELETED": "Этот пресет будет немедленно удален. Вы не сможете отменить это действие.",
    "RESET_ALL_TO_DEFAULTS": "Сбросить все настройки по умолчанию",
    "HOTKEY_SETTINGS_UNDO": "Отменить",
    "HOTKEY_SETTINGS_REDO": "Повторить",
    "HOTKEY_SETTINGS_ZOOM_IN": "Увеличить масштаб",
    "HOTKEY_SETTINGS_ZOOM_OUT": "Уменьшить масштаб",
    "HOTKEY_SETTINGS_PREV_FRAME": "Предыдущий кадр",
    "HOTKEY_SETTINGS_NEXT_FRAME": "Следующий кадр",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "Добавить на временную шкалу",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "Увеличить громкость клипа",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "Уменьшить громкость клипа",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "Удалить со сдвигом",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "Отрезать предыдущее со сдвигом",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "Отрезать следующее со сдвигом",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "Выбрать клипы в текущей позиции",
    "HOTKEY_SETTINGS_CUT_CLIPS": "Вырезать клип(ы)",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "Воспроизведение/Пауза",
    "HOTKEY_SETTINGS_DELETE": "Удалить",
    "HOTKEY_SETTINGS_COPY": "Копировать",
    "HOTKEY_SETTINGS_PASTE": "Вставить",
    "HOTKEY_SETTINGS_PLAY": "Воспроизведение",
    "HOTKEY_SETTINGS_PAUSE": "Пауза",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "Воспроизвести выделенный интервал",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "Удалить выбранные точки клипа",
    "HOTKEY_SETTINGS_MARK_IN": "Установить начальную точку клипа",
    "HOTKEY_SETTINGS_MARK_OUT": "Установить конечную точку клипа",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "Переместить слайдер в начало отрезка клипа",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "Переместить слайдер в конец отрезка клипа",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "Переместить слайдер к следующей точке редактирования клипа",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "Переместить слайдер к предыдущей точке редактирования клипа",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "Показать/скрыть отображение моих медиафайлов",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "Показать/скрыть настройки редактора",
    "CLIP_SETTINGS": "Настройки клипа",
    "MESSAGE_BOX_INCOMPATIBLE": "Файлы несовместимы",
    "MESSAGE_BOX_REMOVE_EXISTING": "Файлы несовместимы (несоответствие формата)",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "Файлы несовместимы (несоответствие разрешения)",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "Файлы несовместимы (несоответствие частоты кадров)",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "Файлы несовместимы (несоответствие кодеков)",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "Файлы несовместимы (несоответствие типа таймкода DF/NDF)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "Файлы несовместимы (несоответствие цветового пространства)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "Файлы несовместимы (несоответствие параметров видеокодера)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "Файл несовместим (пожалуйста, удалите офлайн-клип)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "Модели транскрипции не найдены. Хотите скачать (~882 MB) и установить?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "Модели определения спортивных хайлайтов не найдены. Хотите скачать (~3.9 GB) и установить?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "Для определения спортивных хайлайтов требуется NVIDIA GPU с вычислительной производительностью >= 7.5",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "Запретить добавление на временную шкалу видеофайлов с разными кодеками, разрешениями, FPS, типами таймкода (DF/NDF) и цветовым пространством",
    "MARKS_CONTEXT_MENU_MARK_IN": "Отметить начало",
    "MARKS_CONTEXT_MENU_MARK_OUT": "Отметить конец",
    "MARKS_CONTEXT_MENU_CLEAR": "Очистить точки начало/конец",
    "MEDIA_ERROR_build_thumbnails_error": "Ошибка создания миниатюр",
    "MEDIA_ERROR_unsupported_media": "Неподдерживаемый файл",
    "MEDIA_ERROR_exceeded_file_size": "Превышен размер файла",
    "MEDIA_ERROR_exceeded_per_user_size": "Превышен размер на пользователя",
    "MEDIA_ERROR_low_disk_space": "Мало места на диске",
    "MEDIA_ERROR_internal_server_error": "Внутренняя ошибка сервера",
    "MEDIA_ERROR_network_error": "Ошибка сети",
    "MEDIA_ERROR_not_found": "Медиафайл не найден",
    "MEDIA_ERROR_unable_get_media_info": "Не удалось получить информацию о медиафайле",
    "MEDIA_ERROR_not_enough_tokens": "Недостаточно токенов",
  },
  zh: {
    "ADD_FOLDER_BTN": "添加文件夹",
    "ADD_FOLDER_BTN_TOOLTIP": "添加文件夹",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "將第一個匯入的檔案新增至時間軸，位置為原始檔案起始時間碼處",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "允許時間軸/媒體佈局變更",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "Bucket名称",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "访问密钥 ID",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "秘钥",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "正在导入",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "导入错误",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "导入成功",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "从 AWS Bucket 导入媒体",
    "AMAZON_IMPORT_BTN_IMPORT": "导入",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "导入",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "在新專案中詢問專案名稱",
    "AUDIO_CAPTION_AUDIO": "音频",
    "AUDIO_TEXT_FOUND_ITEMS": "找到的项目",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "未找到结果",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "看来我们无法根据您的搜索找到任何结果",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "音频设置",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "声音",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "过渡",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "淡入（秒）",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "淡出（秒）",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "搜索类型",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "搜索音乐",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "搜索音效",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "搜索",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "音乐流派",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "音效",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "按情绪分类的音乐",
    "AUDIO_MENU_ITEM_ALL": "全部",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "过渡",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "自动播放所选媒体",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "从时间轴移除资产？",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "根據媒體設定時間碼格式",
    "BATCH_IMPORT_FILES_HEAD": "匯入檔案",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "分析",
    "CAPTION_ADDED": "已新增",
    "CAPTION_SKIPPED": "已跳過",
    "COLOR_PICKER_BTN_COLOR": "选择颜色",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "选择颜色",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "背景颜色",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "背景颜色",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "正在下载媒体文件",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "匯入媒體檔案",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "正在上传保存的媒体",
    "COMMON_STATUS_TEXT_ABORTED": "中止",
    "COMMON_STATUS_TEXT_LOADING": "正在加载",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "操作已排入佇列",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "準備圖片",
    "COMMON_STATUS_TEXT_RENDERING": "渲染",
    "COMMON_STATUS_TEXT_CONVERT": "转换",
    "COMMON_YES": "是",
    "COMMON_NO": "否",
    "COMMON_OK": "确定",
    "COMMON_RESET_ALL_CHANGES": "重置所有更改",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "取消",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "取消",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "用户头像",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "您可以上传默认用户头像文件",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "头像",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "颜色主题",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "自定义 JS 脚本",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "自定义文本",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "您可以自定义编辑器文本",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "此脚本在编辑器加载时运行。可用于集成分析功能等",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "编辑 JS 脚本",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "第二重色",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "选择主背景的颜色",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "控件的主强调色。请在此处选择您的品牌颜色。",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "控件的附加颜色与按钮的主颜色搭配",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "时间轴上的音频文件有自己的风格",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "您可以上传徽标文件",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "配音文件有自己的风格",
    "CUSTOMIZATION_LABEL_DISPLAYED": "已显示",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "选择预定义主题或创建自己的主题。您可以编辑 CSS 文件来定制您的主题。",
    "CUSTOMIZATION_TITLE_BASIC_BG": "基本背景",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "主要按钮、链接",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "编辑主题的 CSS 文件",
    "CUSTOMIZATION_TITLE_AUDIO": "音频",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "配音",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "编辑文本值",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "编辑文本值",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "编辑文本值",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "格式描述",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "格式描述",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "重置所有更改",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "重置所有更改",
    "CUSTOMIZATION_BTN_CANCEL": "取消",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "取消",
    "CUSTOMIZATION_BTN_SAVE": "保存",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "保存",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "编辑 JS 脚本",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "编辑 JS 脚本",
    "CUSTOMIZATION_BTN_EDIT_CSS": "编辑 CSS",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "编辑 CSS",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "上传徽标",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "上传徽标",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "删除徽标",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "删除徽标",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "黑暗主题",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "灯光主题",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "自定义主题",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "标识",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "徽标",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "自定义编辑器",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "徽标和名称",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "公司名称",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "编辑器名称",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "接受的文件:",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "没有上传徽标",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "查看设置",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "视图设置",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "过滤器",
    "DUMMY_HEADER_BTN_FILTERS": "过滤器",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "将项目另存为...",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "管理面板",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "新项目",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "发布",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "自定义编辑器",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Adobe CEP 扩展",
    "EDITOR_MENU_MAIN_LOGS": "日誌",
    "EDITOR_MENU_MAIN_SETTINGS": "設定",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "无法发布",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "需要跟踪",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "渲染設定",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "行為",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "檢視",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "保存",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "取消",
    "FILE_INPUT_BTN": "文件输入",
    "FILE_INPUT_BTN_TOOLTIP": "文件输入",
    "FORM_FIELD_LABEL_VOLUME": "卷",
    "folder_not_empty": "文件夹不是空的。文件可在项目中使用。如果继续使用，文件将无法在相应项目的时间轴上使用。",
    "HEAD_CONTROL_IMPORT_TEXT": "导入",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "导入媒体",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "從手機匯入",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "导入带媒体的文件夹",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Amazon S3 Bucket",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Google Drive",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "URL输入",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "将项目另存为...",
    "HEADER_MENU_LIST_ITEM_DELETE": "删除",
    "HEADER_MENU_LIST_ITEM_RENAME": "重命名",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "添加许可证密钥",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "注销",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "您想离开编辑器吗？",
    "HEADER_BTN_BACK_TO_MY_ACC": "返回我的账户",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "返回我的账户",
    "HEADER_BTN_HELP": "帮助",
    "HEADER_BTN_HELP_TOOLTIP": "帮助",
    "IMAGES_TEXT_NATIVE_IMAGES": "本地图像",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "图像",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "搜索",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "选择集合",
    "IMAGES_TEXT_ALL_CATEGORIES": "所有系列",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "未找到结果",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "看来我们无法根据您的搜索找到任何结果",
    "IMAGES_TAB_AI_GENERATED": "Ai-生成",
    "IMAGES_TAB_SEARCH": "搜索",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "从 URL 导入媒体",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "点击此处链接到文件",
    "IMPORT_FROM_URL_BTN_IMPORT": "导入",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "导入",
    "IMPORT_TOKEN_INVALID": "匯入代幣無效",
    "LAYER_CONTROL_BTN_MOVE_UP": "向上移动",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "向上移动",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "拖动层",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "拖动图层",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "向下移动",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "向下移动",
    "LAYER_CONTROL_BTN_DELETE": "删除",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "删除",
    "LAYER_CONTROL_BTN_HIDE": "隐藏",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "隐藏",
    "LAYER_CONTROL_BTN_SHOW": "显示",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "显示",
    "LAYER_CONTROL_BTN_MUTE": "静音",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "静音",
    "LAYER_CONTROL_BTN_UNMUTE": "解除静音",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "解除静音",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "我的媒体",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "我的媒体",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "專案媒體",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "專案媒體",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "过渡",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "过渡",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "图像",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "图像",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "音频",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "音频",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "文本",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "文本",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "设计",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "设计",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "过滤器",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "过滤器",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "过滤器",
    "MEDIA_API_IS_NOT_AVAILABLE": "錯誤：Voiceover WebAPI 需要使用 https",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "图像设置",
    "MEDIA_FORM_CAPTION_POSITION": "位置",
    "MEDIA_FORM_CAPTION_ROTATION": "旋转",
    "MEDIA_FORM_CAPTION_SETTINGS": "设置",
    "MEDIA_FORM_CAPTION_OUTLINE": "大纲",
    "MEDIA_FORM_CAPTION_SHADOW": "阴影",
    "MEDIA_FORM_CAPTION_SIZE": "大小",
    "MEDIA_FORM_CAPTION_VIDEO": "视频",
    "MEDIA_FORM_CAPTION_AUDIO": "音频",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "不透明度",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "过滤器",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "过滤器",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "全部",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "视频",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "图片",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "音频",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "文件夹",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "配音",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "视图设置",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "查看设置",
    "MEDIA_UPLOADER_TEXT_OR": "或",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "将您的媒体拖放到此处",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "导入媒体",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "导入",
    "MEDIA_PREVIEW_TEXT_RENDERING": "渲染",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "分辨率",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "旋转角度",
    "MEDIA_INFO_LIST_ITEM_CODEC": "编解码器",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "色彩空間",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "帧频",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "赫兹 - 立体声",
    "MEDIA_INFO_LIST_ITEM_DURATION": "持续时间",
    "MEDIA_INFO_LIST_ITEM_TYPE": "类型",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "音频",
    "MEDIA_INFO_LIST_ITEM_SIZE": "大小",
    "MEDIA_INFO_LIST_TASK_STATUS": "任务状态",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "開始時間碼",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "視訊編碼器參數",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "我的媒體",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "專案媒體",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "加载更多媒体",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "加载更多媒体",
    "MEDIA_BTN_LOADING": "正在加载",
    "MEDIA_BTN_LOADING_TOOLTIP": "正在加载",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "色度键",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "位置",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "声音",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "SIZE",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "媒体设置",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "重置所有设置",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "重置所有设置",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "相似性",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "平滑度",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "关键色彩溢出减少",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "从预览中选择颜色",
    "MEDIA_SORT_OPTION_DURATION": "持续时间",
    "MEDIA_SORT_OPTION_DATE": "日期",
    "MEDIA_SORT_OPTION_SIZE": "大小",
    "MEDIA_SORT_OPTION_NAME": "名称",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "排序方式",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "顺序",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "查看",
    "MEDIA_SORT_OPTION_ASCENDING": "升序",
    "MEDIA_SORT_OPTION_DESCENDING": "降序",
    "MEDIA_SORT_OPTION_LIST": "列表",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "大图标",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "我的录音",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "我的录音",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "我的媒体",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "我的媒体",
    "MEDIA_FILES_DELETE_FORM_TITLE": "某些檔案為專案所使用，尚未移除",
    "MEDIA_FILES_DELETE_FORM_DESC": "選取的檔案將會從媒體庫中刪除，並且在專案中不再可用。",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "專案中使用的檔案",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "全部選取",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "您确定要删除选中的项目吗？",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "浏览文件夹",
    "MEDIA_CONFIRM_BTN_DELETE": "删除",
    "MEDIA_CANCEL_BTN_DELETE": "取消",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "删除",
    "MEDIA_CONFIRM_TITLE_DELETE": "删除",
    "MEDIA_TEXT_LOADING": "加载",
    "MEDIA_BTN_ADD": "添加",
    "MEDIA_BTN_ADD_TOOLTIP": "添加",
    "MEDIA_PROGRESS_TEXT_LOADING": "正在加载",
    "MEDIA_PROGRESS_TEXT_SAVING": "保存",
    "MEDIA_PROGRESS_TEXT_CONVERT": "转换",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "传输",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "分析",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "选择文件夹",
    "MEDIA_MENU_ITEM_MEDIA": "媒体",
    "MEDIA_MENU_ITEM_MOVE_TO": "移动到",
    "MEDIA_MENU_ITEM_SETTINGS": "设置",
    "MEDIA_MENU_ITEM_NABLET_HLD": "檢測體育亮點",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "转录",
    "MEDIA_MENU_ITEM_DELETE": "刪除",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "刪除選取的素材",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "瀏覽媒體",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "複製媒體位址",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "使用開始時間碼新增",
    "MEDIA_MENU_LABEL_MOVE_TO": "移至",
    "MEDIA_CONFIRM_BTN_OK": "确定",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "确定",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "HTML5 视频编辑器",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "尚未支持平板电脑和手机 :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "视频编辑器在电脑上运行良好",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "返回网站",
    "MOBILE_UPLOAD_TITLE": "將檔案上傳至「使用者儲存空間」",
    "MOBILE_UPLOAD_SUBTITLE": "支援格式：影片、音訊、照片。您的檔案將儲存於「使用者儲存空間」中",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "要切换语言，您需要重新启动应用程序",
    "MODAL_WINDOW_LOGS_TITLE": "要打开/关闭日志，您需要重新启动应用程序",
    "MODAL_WINDOW_INSTALL_COMPONENT_TITLE": "要求的元件已安裝。您需要重新啟動應用程式",
    "MESSAGE_BOX_INSTALL_RUNNING": "已有其他安裝正在進行中。\n請等待其完成。",
    "MESSAGE_BOX_INSTALL_FAILED": "安裝執行失敗。請查看日誌以了解詳細資訊",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "選擇參考檔案",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "您可以新增不同 FPS/解析度/編碼的檔案。選擇要套用專案內容的檔案",
    "MODAL_WINDOW_BUTTON_RESTART": "重新啟動",
    "MUTE_AUDIO_AT_CREATED_LAYERS": '在建立的圖層中將音訊靜音',
    "NAVIGATION_TAB_EDITOR": "编辑器",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "编辑器",
    "NAVIGATION_TAB_PROJECTS": "项目",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "项目",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "无网络连接",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "最后保存",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "分钟前",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "刚才",
    "PROJECTS_BTN_NEW_PROJECTS": "新项目",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "新项目",
    "PROJECTS_BTN_NEW_PROJECT": "新项目",
    "PROJECTS_BTN_IMPORT": "导入",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "导入",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "是",
    "PROJECTS_IMPORT_BTN_OK": "确定",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "确定",
    "PROJECTS_IMPORT_TEXT_CANCEL": "取消",
    "PROJECTS_TITLE_TEXT_COPY": "复制",
    "PROJECTS_BTN_SAVE": "保存",
    "PROJECTS_BTN_SAVE_TOOLTIP": "保存",
    "PROJECTS_BTN_CREATE": "建立",
    "PROJECTS_BTN_CREATE_TOOLTIP": "建立",
    "PROJECTS_TITLE_TEXT_RENAME": "重命名",
    "PROJECTS_TITLE_TEXT_DELETE": "删除",
    "PROJECTS_TITLE_TEXT_EXPORT": "导出",
    "PROJECTS_CONFIRM_BTN_DELETE": "删除",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "已编辑 %d 小时前",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "已编辑 刚才",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "已编辑 %d 分钟前",
    "PROJECTS_PROGRESS_TEXT_LOADING": "正在加载",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "搜索",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "您想停止导入吗？",
    "PROJECTS_TEXT_NOTHING_FOUND": "未找到",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "创建一个漂亮的新项目",
    "PROJECTS_TEXT_CAPTION": "项目",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "项目名称",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "单击此处上传或拖放项目文件",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "您一次只能上传一个文件",
    "PROJECTS_PREFIX_TEXT_EDITED": "已编辑",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "您确定要删除",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "此项目将立即删除。您无法撤销此操作。",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "项目",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "只能上传一个文件",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "文件扩展名无效。应为 *.edl.zip",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "输入您的值",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "在媒体中为该项目创建文件夹",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "打开编辑器",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "再试一次",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "为项目选择帧频",
    "PROJECTS_EXPORT_TITLE": "导出项目",
    "PROJECTS_EXPORT_INPROGRESS": "导出进行中...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "包含媒体",
    "PROJECTS_EXPORT_COMPLETE": "项目导出完成",
    "PROJECTS_EXPORT_BTN_BROWSE": "浏览",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "下载",
    "PROJECTS_EXPORT_BTN_COPY": "复制",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "媒体中的文件在此播放",
    "PREVIEW_BTN_PREV_TOOLTIP": "上一页",
    "PREVIEW_BTN_PREV": "上一页",
    "PREVIEW_BTN_PLAY_TOOLTIP": "播放",
    "PREVIEW_BTN_PLAY": "播放",
    "PREVIEW_BTN_STOP_TOOLTIP": "停止",
    "PREVIEW_BTN_STOP": "停止",
    "PREVIEW_BTN_NEXT_TOOLTIP": "下一步",
    "PREVIEW_BTN_NEXT": "下一步",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "体积",
    "PREVIEW_BTN_VOLUME": "音量",
    "PREVIEW_BTN_FRAME_CAPTURE": "捕获帧",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "捕获帧",
    "PREVIEW_BTN_FULL_SCREEN": "全屏",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "全屏",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "馬克在",
    "PREVIEW_BTN_MARK_IN": "馬克在",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "標出",
    "PREVIEW_BTN_MARK_OUT": "標出",
    "PREVIEW_HEADER_TITLE_SOURCE": "來源",
    "PREVIEW_HEADER_TITLE_TIMELINE": "時間軸",
    "PREVIEW_MODE_AUTO": "自動",
    "PREVIEW_MODE_SOURCE": "來源",
    "PREVIEW_MODE_TIMELINE": "時間軸",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "产量",
    "PUBLISH_SETTINGS_TITLE": "标题",
    "QR_CODE_DIALOG_TITLE": "掃描此 QR 碼（有效期 24 小時）",
    "QR_CODE_LOAD_ERROR": "錯誤！無法建立 QR 碼",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "防止將具有不同視訊編碼器參數的視訊檔案新增至同一時間軸",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "忽略量化参数与视频参数不匹配",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "從第一個片段開始渲染",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "詢問輸出名稱",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "取消時關閉發布設定",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "持续时间",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "编解码器",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "帧速率",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "赫兹 - 立体声",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "分辨率",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "音频",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "大小（近似值）",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "转码文件的链接将丢失",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "发布设置",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "视频渲染完成",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "输入名称",
    "SAVE_SETTINGS_BTN_RENDER_START": "开始",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "开始",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "返回我的帐户",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "返回我的账户",
    "SAVE_SETTINGS_BTN_OK": "确定",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "确定",
    "SAVE_SETTINGS_BTN_CANCEL": "取消",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "取消",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "下载",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "下载",
    "SAVE_SETTINGS_BTN_BROWSE": "浏览",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "浏览",
    "SAVE_SETTINGS_BTN_COPY": "复制",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "复制",
    "SAVE_SETTINGS_TEXT_TITLE": "标题",
    "SAVE_SETTINGS_TEXT_LOADING": "正在加载",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "準備圖片",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "此视频已提交至您的帐户，不久即可观看",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "全部",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "搜索",
    "SHOW_MY_MEDIA_POOL": "顯示我的媒體庫",
    "SHOW_PROJECT_MEDIA_POOL": "顯示專案媒體庫",
    "SHOW_EDITOR_HEADER": "顯示編輯器標題",
    "SHOW_MENU_TABS": "顯示選單標籤",
    "SHOW_PREVIEW_SPLIT_BUTTON": "顯示預覽分割按鈕",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "顯示預覽切換按鈕",
    "SHOW_INOUT_POINTS_TIMELINE": "顯示時間軸進出點",
    "SHOW_INOUT_POINTS_SOURCE": "顯示素材進出點",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "在空時間軸上顯示匯入佔位符",
    "VIEW_SETTINGS_LANG": "語言",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "描述",
    "SETTINGS_HEAD_BTN_DELETE": "删除",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "删除",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "選擇相同",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "選擇相同",
    "SETTINGS_HEAD_BTN_CLOSE": "关闭",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "关闭",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "宽度",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "高度",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "保持宽高比",
    "SETTINGS_BTN_FIT_TO_FRAME": "适合框架",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "适合框架",
    "SETTINGS_BTN_FILL_FRAME": "填充框",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "填充框架",
    "SETTINGS_TEXT_AUTO": "自动",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "文本无变换",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "文本无变换",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "文本转换为大写",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "文本转换大写",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "小写文本转换",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "小写文本转换",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "文本转换大写",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "文本转换大写",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "字体家族",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "字体族",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "字体大小 ",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "字体大小",
    "SETTINGS_TEXT_BTN_BOLD": "粗体",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "粗体",
    "SETTINGS_TEXT_BTN_ITALIC": "斜体",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "斜体",
    "SETTINGS_TEXT_BTN_UNDERLINE": "下划线",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "下划线",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "左",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "左",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "右",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "右",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "居中",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "居中",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "对齐",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "对齐",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "顶部",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "顶部",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "左上角",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "左上角",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "右上方",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "右上角",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "左",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "左",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "中间居中",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "中间居中",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "右",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "右",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "左下角",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "左下角",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "底部",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "底部",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "右下方",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "右下方",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "水平",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "垂直",
    "SETTINGS_ROTATION_TEXT_ROTATE": "旋转",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "输入文本",
    "NABLET_HLD_PROJECT_POSTFIX": "亮點",
    "NABLET_HLD_CAPTION": "檢測亮點",
    "NABLET_HLD_DETECTED_BTN_START": "開始",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "創建項目",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "取消",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "检测到的间隔数量:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "您確定要終止任務嗎？",
    "NABLET_HLD_DETECTED_BTN_NO": "否",
    "NABLET_HLD_DETECTED_BTN_YES": "是",
    "NB_HLD_STATUS_TEXT_DETECTING": "檢測中",
    "NABLET_HLD_TARGET_DURATION_SEC": "目標持續時間（秒）",
    "AI_MODEL": "AI 模型",
    "TRANSCRIBE_CAPTION": "转录媒体内容",
    "TRANSCRIBE_PROJECT_POSTFIX": "已转录",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "转录中",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "文本项数量:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "创建项目",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "本节正在开发中",
    "TEXT_FORM_CAPTION_SIZE": "大小",
    "TEXT_FORM_CAPTION_OUTLINE": "大纲",
    "TEXT_FORM_CAPTION_FONT": "字体",
    "TEXT_FORM_CAPTION_SHADOW": "阴影",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "文本设置",
    "TEXT_FORM_TEXT_OFFSET": "偏移",
    "TEXT_FORM_TEXT_BLUR": "模糊",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "文本",
    "TIMELINE_TEXT_DRAG_N_DROP": "拖放",
    "TIMELINE_TEXT_ADD_LAYER": "+ 添加图层",
    "TIMELINE_TOOLBAR_BTN_UNDO": "撤消",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "撤销",
    "TIMELINE_TOOLBAR_BTN_REDO": "重做",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "重做",
    "TIMELINE_TOOLBAR_BTN_DELETE": "删除",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "删除",
    "TIMELINE_TOOLBAR_BTN_COPY": "复制剪辑",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "复制剪辑",
    "TIMELINE_TOOLBAR_BTN_CUT": "剪切片段",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "剪切片段",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "添加标记",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "添加标记",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "粘贴",
    "TIMELINE_TOOLBAR_BTN_PASTE": "粘贴",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "设置",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "设置",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "语音播报",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "语音播报",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "网络摄像头",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "网络摄像头",
    "TIMELINE_TOOLBAR_BTN_LIVE": "直播",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "直播",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "点击取消",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "点击取消",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "拖放",
    "TIMELINE_FOOTER_TEXT_DURATION": "持续时间",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "无法发布项目",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "需要视频轨迹",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "保存",
    "TIMELINE_FOOTER_BTN_SAVE": "保存",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "保存",
    "TIMELINE_FOOTER_BTN_PUBLISH": "发布",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "发布",
    "TIMELINE_SLIDER_POINTER": "滑块指针",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "滑块指针",
    "TRANSITION_NAME_DISSOLVE": "溶解",
    "TRANSITION_NAME_FADE_IN": "淡入",
    "TRANSITION_NAME_FADE_OUT": "淡出",
    "TRANSITION_NAME_DIP_TO_BLACK": "转黑",
    "TRANSITION_NAME_DIP_TO_WHITE": "转白",
    "TRANSITION_NAME_BLUR": "模糊",
    "TRANSITION_NAME_WIPE_RIGHT": "右擦",
    "TRANSITION_NAME_WIPE_LEFT": "左擦",
    "TRANSITION_NAME_WIPE_UP": "上擦",
    "TRANSITION_NAME_WIPE_DOWN": "下擦",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "过渡设置",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "应用于时间轴上的所有转场",
    "TRANSITION_FORM_SELECTED": "已选择：",
    "TRANSITION_FORM_LABEL_TYPE": "类型",
    "TRANSITION_FORM_LABEL_DURATION": "持续时间（秒）",
    "TRANSITION_LIST_CAPTION_TRANSITION": "过渡",
    "used_in_projects": "媒体文件未被删除，因为它正在一个或多个项目中使用。如果您继续删除，该文件将无法在相应项目的时间轴上使用，并从您的账户中删除。",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "使用模態對話框匯入本地檔案",
    "VOICE_OVER_TITLE_LAST_RECORDING": "最后录音",
    "VOICE_OVER_BTN_RETAKE": "重拍",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "重拍",
    "VOICE_OVER_BTN_DELETE_FILE": "删除文件",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "删除文件",
    "VOICE_OVER_BTN_START_RECORDING": "开始录音",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "开始录音",
    "VOICE_OVER_BTN_CONNECTION": "连接...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "连接...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "文件将从时间轴和媒体中删除",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "你确定吗？",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "语音旁白",
    "VOICE_OVER_TEXT_MIC": "麦克风",
    "VOICE_OVER_LABEL_SELECT_MIC": "选择麦克风",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "无音频",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "录音时将时间线静音",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "录制后在起始位置倒带滑块",
    "VOICE_OVER_TEXT_COUNTDOWN": "倒计时",
    "VOICE_OVER_BTN_TEST_MIC": "测试麦克风",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "测试麦克风",
    "VOICE_OVER_BTN_RECORDING": "录音...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "录音...",
    "VOICE_OVER_BTN_PLAYING": "正在播放...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "正在播放...",
    "VOICE_OVER_BTN_YES": "是",
    "VOICE_OVER_BTN_YES_TOOLTIP": "是",
    "VOICE_OVER_BTN_NO": "否",
    "VOICE_OVER_BTN_NO_TOOLTIP": "否",
    "VOICE_OVER_BTN_STOP": "停止",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "停止",
    "VOICE_OVER_BTN_DELETE": "删除",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "删除",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "自动调整",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "其他設定",
    "WEBCAM_TEXT_RECORD_VIDEO": "录制视频",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "录制直播",
    "LIVE_STREAM_URL_INPUT_LABEL": "直播网址",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "单击此处链接到直播",
    "LIVE_STREAM_BTN_CONNECTING": "正在连接...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "正在连接...",
    "LIVE_STREAM_BTN_CAPTURE": "开始拍摄",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "开始拍摄",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "停止拍摄",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "停止拍摄",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "减少缩放",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "减少缩放",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "增加缩放",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "增加缩放",
    "SETTINGS_HOTKEYS": "热键设置",
    "PRESET": "预设",
    "DEFAULT": "默认",
    "ADD_NEW": "添加新内容",
    "SEARCH_COMMAND": "搜索命令",
    "COMMAND": "命令",
    "SHORTCUTS": "捷径",
    "ALL": "全部",
    "TIMELINE": "时间轴",
    "TOOLS": "工具",
    "PREVIEW": "预览",
    "KEYBOARD_MAPPING_PRESET": "键盘映射预设",
    "ENTER_PRESET_NAME": "输入预设名称",
    "THIS_PRESET_WILL_BE_DELETED": "此预设将被立即删除。您无法撤销此操作。",
    "RESET_ALL_TO_DEFAULTS": "全部重置为默认值",
    "HOTKEY_SETTINGS_UNDO": "撤销",
    "HOTKEY_SETTINGS_REDO": "重做",
    "HOTKEY_SETTINGS_ZOOM_IN": "放大",
    "HOTKEY_SETTINGS_ZOOM_OUT": "缩小",
    "HOTKEY_SETTINGS_PREV_FRAME": "上一帧",
    "HOTKEY_SETTINGS_NEXT_FRAME": "下一帧",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "添加到时间轴",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "增加剪辑音量",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "降低剪辑音量",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "波纹删除",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "波纹修剪前一个",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "下一个波纹修剪",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "在当前位置选择剪辑",
    "HOTKEY_SETTINGS_CUT_CLIPS": "剪切片段",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "播放/暂停",
    "HOTKEY_SETTINGS_DELETE": "删除",
    "HOTKEY_SETTINGS_COPY": "复制",
    "HOTKEY_SETTINGS_PASTE": "粘贴",
    "HOTKEY_SETTINGS_PLAY": "游戏",
    "HOTKEY_SETTINGS_PAUSE": "暂停",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "播放高亮顯示的間隔",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "清楚的進出點",
    "HOTKEY_SETTINGS_MARK_IN": "標示輸入點",
    "HOTKEY_SETTINGS_MARK_OUT": "標出點",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "尋求在點",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "尋找出點",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "將滑桿移至下一個剪輯編輯點",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "將滑桿移至上一個剪輯編輯點",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "切換我的媒體可見狀態",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "顯示編輯器設定切換功能",
    "CLIP_SETTINGS": "剪輯設定",
    "MESSAGE_BOX_INCOMPATIBLE": "文件不兼容",
    "MESSAGE_BOX_REMOVE_EXISTING": "文件不兼容（格式不匹配）",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "文件不兼容（分辨率不匹配）",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "文件不兼容（帧速率不匹配）",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "文件不兼容（编解码器不匹配）",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "檔案不相容（DF/NDF 時間碼格式不匹配)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "檔案不相容（色彩空間不符)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "檔案不相容（影片編碼器參數不符)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "檔案不相容（請刪除離線剪輯)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "找不到轉錄模型。是否要下載 (~882 MB) 並安裝？",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "找不到體育亮點偵測模型。是否要下載 (~3.9 GB) 並安裝？",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "體育亮點偵測需要運算能力 >= 7.5 的 NVIDIA GPU",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "防止將具有不同編解碼器、解析度、幀率、DF/NDF 時間碼及色彩空間的影片檔案加入同一條時間軸",
    "MARKS_CONTEXT_MENU_MARK_IN": "標記",
    "MARKS_CONTEXT_MENU_MARK_OUT": "標記出",
    "MARKS_CONTEXT_MENU_CLEAR": "清除入點/出點",
    "MEDIA_ERROR_build_thumbnails_error": "建立縮圖錯誤",
    "MEDIA_ERROR_unsupported_media": "不支援的媒體",
    "MEDIA_ERROR_exceeded_file_size": "超出檔案大小",
    "MEDIA_ERROR_exceeded_per_user_size": "超出每個使用者大小",
    "MEDIA_ERROR_low_disk_space": "磁碟空間不足",
    "MEDIA_ERROR_internal_server_error": "內部伺服器錯誤",
    "MEDIA_ERROR_network_error": "網路錯誤",
    "MEDIA_ERROR_not_found": "找不到媒體檔案",
    "MEDIA_ERROR_unable_get_media_info": "無法取得媒體資訊",
    "MEDIA_ERROR_not_enough_tokens": "令牌不足",
  },


  it: {
    "ADD_FOLDER_BTN": "Aggiungi cartella",
    "ADD_FOLDER_BTN_TOOLTIP": "Aggiungi cartella",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "Aggiungi il primo file importato alla timeline al timecode di inizio sorgente",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "Consenti modifica layout timeline/media",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "Nome bucket",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "ID chiave di accesso",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "Chiave segreta",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "Importazione in corso",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "Errore di importazione",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "Importazione riuscita",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "Importa media dal bucket AWS",
    "AMAZON_IMPORT_BTN_IMPORT": "Importa",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "Importa",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "Chiedi il nome del progetto in Nuovo progetto",
    "AUDIO_CAPTION_AUDIO": "Audio",
    "AUDIO_TEXT_FOUND_ITEMS": "Elementi trovati",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "Nessun risultato trovato",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "Sembra che non riusciamo a trovare risultati in base alla tua ricerca.",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "Impostazioni audio",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "Suono",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "Transizione",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "Dissolvenza in entrata (sec)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "Dissolvenza in uscita (sec)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "Cerca genere",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "Cerca musica",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "Cerca effetti sonori",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "Cerca in",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "Musica per genere",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "Effetti sonori",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "Musica per umore",
    "AUDIO_MENU_ITEM_ALL": "Tutti",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "Transizioni",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "Riproduzione automatica del media selezionato",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "Rimuovere l'asset dalla timeline?",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "Imposta il formato del timecode in base al media",
    "BATCH_IMPORT_FILES_HEAD": "Importa file",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "Analisi",
    "CAPTION_ADDED": "Aggiunto",
    "CAPTION_SKIPPED": "Saltato",
    "COLOR_PICKER_BTN_COLOR": "Seleziona colore",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "Seleziona colore",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "Colore di sfondo",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "Colore di sfondo",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "Download dei file media in corso",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "Importazione dei file media in corso",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "Caricamento dei media salvati in corso",
    "COMMON_STATUS_TEXT_ABORTED": "Annullato",
    "COMMON_STATUS_TEXT_LOADING": "Caricamento",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "Operazione in coda",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "Prepara le immagini",
    "COMMON_STATUS_TEXT_RENDERING": "Rendering",
    "COMMON_STATUS_TEXT_CONVERT": "Converti",
    "COMMON_YES": "Sì",
    "COMMON_NO": "No",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "Reimposta tutte le modifiche",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "Annulla",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "Annulla",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "Avatar utente",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "Puoi caricare un file di avatar utente predefinito.",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "Avatar",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "Tema colore",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "Script JS personalizzato",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "Testo personalizzato",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "Puoi personalizzare il testo dell'editor",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "Questo script viene eseguito al caricamento dell'editor. Può essere usato per integrare analisi ecc.",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "Modifica script JS",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "Secondo colore accento",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "Seleziona il colore dello sfondo principale.",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "Il colore accento principale per i controlli. Seleziona qui il colore del tuo brand.",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "Colore aggiuntivo dei controlli in coppia con il colore principale dei pulsanti.",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "Il file audio sulla timeline ha uno stile proprio.",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "Puoi caricare un file del tuo logo.",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "Il file di voiceover ha uno stile proprio.",
    "CUSTOMIZATION_LABEL_DISPLAYED": "visualizzato",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "Scegli uno dei temi predefiniti o creane uno tuo. Puoi modificare il file CSS per personalizzare il tema.",
    "CUSTOMIZATION_TITLE_BASIC_BG": "Sfondo di base",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "Pulsanti e link primari",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "Modifica il file CSS per il tema",
    "CUSTOMIZATION_TITLE_AUDIO": "Audio",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "Voiceover",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "Modifica i valori del testo",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "Modifica i valori del testo",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "Modifica i valori del testo",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "Descrizione del formato",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "Descrizione del formato",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "Reimposta tutte le modifiche",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "Reimposta tutte le modifiche",
    "CUSTOMIZATION_BTN_CANCEL": "Annulla",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "Annulla",
    "CUSTOMIZATION_BTN_SAVE": "Salva",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "Salva",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "Modifica script JS",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "Modifica script JS",
    "CUSTOMIZATION_BTN_EDIT_CSS": "Modifica CSS",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "Modifica CSS",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "Carica logo",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "Carica logo",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "Elimina logo",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "Elimina logo",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "Tema scuro",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "Tema chiaro",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "Tema personalizzato",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "Logo",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "Logo",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "Personalizza editor",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "Logo e nome",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "Nome azienda",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "Nome editor",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "File accettati:",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "Nessun logo caricato",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "Impostazioni visualizzazione",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "Impostazioni visualizzazione",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "Filtri",
    "DUMMY_HEADER_BTN_FILTERS": "Filtri",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Salva progetto con nome..",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "Pannello di amministrazione",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "Nuovo progetto",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "Pubblica",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "Personalizza editor",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Estensioni Adobe CEP",
    "EDITOR_MENU_MAIN_LOGS": "Registri",
    "EDITOR_MENU_MAIN_SETTINGS": "Impostazioni",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "Impossibile pubblicare",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "La traccia è obbligatoria",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "Impostazioni di rendering",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "Comportamento",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "Visualizzazione",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "Salva",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "Annulla",
    "FILE_INPUT_BTN": "Input file",
    "FILE_INPUT_BTN_TOOLTIP": "Input file",
    "FORM_FIELD_LABEL_VOLUME": "Volume",
    "folder_not_empty": "La cartella non è vuota. I file possono essere usati nei progetti. Se continui, il file non sarà disponibile sulla timeline dei progetti corrispondenti.",
    "HEAD_CONTROL_IMPORT_TEXT": "Importa",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "Importa media",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "Importa dal telefono",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "Importa cartella con media",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Bucket Amazon S3",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Google Drive",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "Input URL",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Salva progetto con nome..",
    "HEADER_MENU_LIST_ITEM_DELETE": "Elimina",
    "HEADER_MENU_LIST_ITEM_RENAME": "Rinomina",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "Aggiungi chiave di licenza",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "Esci",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "Vuoi uscire dall'editor?",
    "HEADER_BTN_BACK_TO_MY_ACC": "Torna al mio account",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "Torna al mio account",
    "HEADER_BTN_HELP": "Aiuto",
    "HEADER_BTN_HELP_TOOLTIP": "Aiuto",
    "IMAGES_TEXT_NATIVE_IMAGES": "Immagine nativa",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "Immagini",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "Cerca in",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "Seleziona raccolta",
    "IMAGES_TEXT_ALL_CATEGORIES": "Tutte le raccolte",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "Nessun risultato trovato",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "Sembra che non riusciamo a trovare risultati in base alla tua ricerca.",
    "IMAGES_TAB_AI_GENERATED": "Generato da IA",
    "IMAGES_TAB_SEARCH": "Cerca",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "Importa media da URL",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "Fai clic qui per collegare un file",
    "IMPORT_FROM_URL_BTN_IMPORT": "Importa",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "Importa",
    "IMPORT_TOKEN_INVALID": "Token di importazione non valido",
    "LAYER_CONTROL_BTN_MOVE_UP": "Sposta su",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "Sposta su",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "Trascina livello",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "Trascina livello",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "Sposta giù",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "Sposta giù",
    "LAYER_CONTROL_BTN_DELETE": "Elimina",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "Elimina",
    "LAYER_CONTROL_BTN_HIDE": "Nascondi",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "Nascondi",
    "LAYER_CONTROL_BTN_SHOW": "Mostra",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "Mostra",
    "LAYER_CONTROL_BTN_MUTE": "Disattiva audio",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "Disattiva audio",
    "LAYER_CONTROL_BTN_UNMUTE": "Riattiva audio",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "Riattiva audio",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "I miei media",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "I miei media",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "Media di progetto",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "Media di progetto",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "Transizioni",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "Transizioni",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "Immagini",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "Immagini",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "Testo",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "Testo",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "Design",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "Design",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "Filtri",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "Filtri",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "Filtri",
    "MEDIA_API_IS_NOT_AVAILABLE": "Errore: Voiceover WebAPI richiede https",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "Impostazioni immagine",
    "MEDIA_FORM_CAPTION_POSITION": "Posizione",
    "MEDIA_FORM_CAPTION_ROTATION": "Rotazione",
    "MEDIA_FORM_CAPTION_SETTINGS": "Impostazioni",
    "MEDIA_FORM_CAPTION_OUTLINE": "Contorno",
    "MEDIA_FORM_CAPTION_SHADOW": "Ombra",
    "MEDIA_FORM_CAPTION_SIZE": "Dimensione",
    "MEDIA_FORM_CAPTION_VIDEO": "Video",
    "MEDIA_FORM_CAPTION_AUDIO": "Audio",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "Opacità",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "Filtro",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "Filtro",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "Tutti",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "Video",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "Immagine",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "Audio",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "Cartella",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "Voce fuori campo",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "Impostazioni di visualizzazione",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "Impostazioni di visualizzazione",
    "MEDIA_UPLOADER_TEXT_OR": "o",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "Trascina qui i tuoi media",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "importa media",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "Importazione in corso",
    "MEDIA_PREVIEW_TEXT_RENDERING": "Rendering",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "Risoluzione",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "Gradi di rotazione",
    "MEDIA_INFO_LIST_ITEM_CODEC": "Codec",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "Spazio colore",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "Frame rate",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - Stereo",
    "MEDIA_INFO_LIST_ITEM_DURATION": "Durata",
    "MEDIA_INFO_LIST_ITEM_TYPE": "Tipo",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "Audio",
    "MEDIA_INFO_LIST_ITEM_SIZE": "Dimensione",
    "MEDIA_INFO_LIST_TASK_STATUS": "Stato attività",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "Timecode di inizio",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "Parametri encoder video",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "I miei media",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "Media di progetto",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "Carica altri media",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "Carica altri media",
    "MEDIA_BTN_LOADING": "Caricamento",
    "MEDIA_BTN_LOADING_TOOLTIP": "Caricamento",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "Chiave cromatica",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "Posizione",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "Suono",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "DIMENSIONE",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "Impostazioni media",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "Reimposta tutte le impostazioni",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "Reimposta tutte le impostazioni",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "Somiglianza",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "Uniformità",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "Riduzione della fuoriuscita del colore chiave",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "Scegli il colore dall'anteprima",
    "MEDIA_SORT_OPTION_DURATION": "Durata",
    "MEDIA_SORT_OPTION_DATE": "Data",
    "MEDIA_SORT_OPTION_SIZE": "Dimensione",
    "MEDIA_SORT_OPTION_NAME": "Nome",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "Ordina per",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "Ordine",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "Visualizzazione",
    "MEDIA_SORT_OPTION_ASCENDING": "Crescente",
    "MEDIA_SORT_OPTION_DESCENDING": "Decrescente",
    "MEDIA_SORT_OPTION_LIST": "Elenco",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "Icone grandi",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "Le mie registrazioni",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "Le mie registrazioni",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "I miei media",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "I miei media",
    "MEDIA_FILES_DELETE_FORM_TITLE": "Alcuni file sono usati dai progetti e non sono stati rimossi",
    "MEDIA_FILES_DELETE_FORM_DESC": "I file selezionati verranno eliminati dalla libreria media e non saranno più disponibili nei progetti",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "File usati nei progetti",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "Seleziona tutto",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "Sei sicuro di voler rimuovere gli elementi selezionati?",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "Sfoglia per cartella",
    "MEDIA_CONFIRM_BTN_DELETE": "Elimina",
    "MEDIA_CANCEL_BTN_DELETE": "Annulla",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "Elimina",
    "MEDIA_CONFIRM_TITLE_DELETE": "Elimina",
    "MEDIA_TEXT_LOADING": "Caricamento",
    "MEDIA_BTN_ADD": "Aggiungi",
    "MEDIA_BTN_ADD_TOOLTIP": "Aggiungi",
    "MEDIA_PROGRESS_TEXT_LOADING": "Caricamento",
    "MEDIA_PROGRESS_TEXT_SAVING": "Salvataggio",
    "MEDIA_PROGRESS_TEXT_CONVERT": "Converti",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "Trasferimento",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "Analisi",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "Seleziona cartella",
    "MEDIA_MENU_ITEM_MEDIA": "Media",
    "MEDIA_MENU_ITEM_MOVE_TO": "Sposta in",
    "MEDIA_MENU_ITEM_SETTINGS": "Impostazioni",
    "MEDIA_MENU_ITEM_NABLET_HLD": "Rileva momenti salienti sportivi",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "Trascrivi",
    "MEDIA_MENU_ITEM_DELETE": "Elimina",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "Elimina clip selezionate",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "Sfoglia media",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "Copia indirizzo media",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "Aggiungi usando il timecode di inizio",
    "MEDIA_MENU_LABEL_MOVE_TO": "Sposta in",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "Editor video HTML5",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "Tablet e mobile non sono ancora supportati :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "L'editor video funziona bene sul tuo computer",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "Torna al sito web",
    "MOBILE_UPLOAD_TITLE": "Carica file nello spazio utente",
    "MOBILE_UPLOAD_SUBTITLE": "Supporta: video, audio, foto. I tuoi file verranno salvati nello spazio utente",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "Per cambiare lingua devi riavviare l'applicazione",
    "MODAL_WINDOW_LOGS_TITLE": "Per attivare/disattivare i registri devi riavviare l'applicazione",
    "MODAL_WINDOW_INSTALL_COMPONENT_TITLE": "Il componente richiesto è stato installato. Devi riavviare l'applicazione",
    "MESSAGE_BOX_INSTALL_RUNNING": "Un'altra installazione è in corso.\\nAttendi il completamento.",
    "MESSAGE_BOX_INSTALL_FAILED": "L'installazione non è riuscita. Controlla i registri per i dettagli",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "Seleziona un file di riferimento",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "Aggiungi file con FPS/risoluzione/codec diversi. Seleziona il file le cui proprietà verranno applicate al progetto",
    "MODAL_WINDOW_BUTTON_RESTART": "Riavvia",
    "MUTE_AUDIO_AT_CREATED_LAYERS": "Disattiva l'audio nei livelli creati",
    "NAVIGATION_TAB_EDITOR": "Editor",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "Editor",
    "NAVIGATION_TAB_PROJECTS": "Progetti",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "Progetti",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "Nessuna connessione di rete",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "Ultimo salvataggio",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "min fa",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "proprio ora",
    "PROJECTS_BTN_NEW_PROJECTS": "Nuovo progetto",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "Nuovo progetto",
    "PROJECTS_BTN_NEW_PROJECT": "Nuovo progetto",
    "PROJECTS_BTN_IMPORT": "Importa",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "Importa",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "Sì",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "Annulla",
    "PROJECTS_TITLE_TEXT_COPY": "Copia",
    "PROJECTS_BTN_SAVE": "Salva",
    "PROJECTS_BTN_SAVE_TOOLTIP": "Salva",
    "PROJECTS_BTN_CREATE": "Crea",
    "PROJECTS_BTN_CREATE_TOOLTIP": "Crea",
    "PROJECTS_TITLE_TEXT_RENAME": "Rinomina",
    "PROJECTS_TITLE_TEXT_DELETE": "Elimina",
    "PROJECTS_TITLE_TEXT_EXPORT": "Esporta",
    "PROJECTS_CONFIRM_BTN_DELETE": "Elimina",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "Modificato %d ore fa",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "Modificato proprio ora",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "Modificato %d minuti fa",
    "PROJECTS_PROGRESS_TEXT_LOADING": "Caricamento",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "Ricerca in corso",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "Vuoi interrompere l'importazione?",
    "PROJECTS_TEXT_NOTHING_FOUND": "Nessun elemento trovato",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "Crea un nuovo bellissimo progetto",
    "PROJECTS_TEXT_CAPTION": "Progetti",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "Nome progetto",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "Fai clic per caricare oppure trascina qui un file di progetto",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "Puoi caricare un solo file alla volta",
    "PROJECTS_PREFIX_TEXT_EDITED": "Modificato",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "Sei sicuro di voler eliminare",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "Questo progetto verrà eliminato immediatamente. Non puoi annullare questa azione.",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "Progetto",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "Può essere caricato un solo file",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "Estensione file non valida. Dovrebbe essere *.edl.zip",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "Inserisci il tuo valore",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "Crea una cartella per questo progetto nei miei media",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "Apri l'editor",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "Riprova",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "Seleziona il frame rate per il progetto",
    "PROJECTS_EXPORT_TITLE": "Esporta progetto",
    "PROJECTS_EXPORT_INPROGRESS": "Esportazione in corso...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "Includi media",
    "PROJECTS_EXPORT_COMPLETE": "Esportazione progetto completata",
    "PROJECTS_EXPORT_BTN_BROWSE": "Sfoglia",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "Scarica",
    "PROJECTS_EXPORT_BTN_COPY": "Copia",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "I file dei media vengono riprodotti qui",
    "PREVIEW_BTN_PREV_TOOLTIP": "Prec",
    "PREVIEW_BTN_PREV": "Prec",
    "PREVIEW_BTN_PLAY_TOOLTIP": "Riproduci",
    "PREVIEW_BTN_PLAY": "Riproduci",
    "PREVIEW_BTN_STOP_TOOLTIP": "Stop",
    "PREVIEW_BTN_STOP": "Stop",
    "PREVIEW_BTN_NEXT_TOOLTIP": "Succ",
    "PREVIEW_BTN_NEXT": "Succ",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "Volume",
    "PREVIEW_BTN_VOLUME": "Volume",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "Punto di ingresso",
    "PREVIEW_BTN_MARK_IN": "Punto di ingresso",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "Punto di uscita",
    "PREVIEW_BTN_MARK_OUT": "Punto di uscita",
    "PREVIEW_BTN_FRAME_CAPTURE": "Cattura frame",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "Cattura frame",
    "PREVIEW_BTN_FULL_SCREEN": "Schermo intero",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "Schermo intero",
    "PREVIEW_HEADER_TITLE_SOURCE": "Sorgente",
    "PREVIEW_HEADER_TITLE_TIMELINE": "Timeline",
    "PREVIEW_MODE_AUTO": "Auto",
    "PREVIEW_MODE_SOURCE": "Anteprima sorgente",
    "PREVIEW_MODE_TIMELINE": "Anteprima timeline",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "output",
    "PUBLISH_SETTINGS_TITLE": "Titolo",
    "QR_CODE_DIALOG_TITLE": "Scansiona il codice QR (valido 24 ore)",
    "QR_CODE_LOAD_ERROR": "Errore! Impossibile generare un codice QR",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "Impedisci l'aggiunta di file video con parametri encoder video diversi alla stessa timeline",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "Ignora la mancata corrispondenza dei parametri video del quantizzatore",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "Inizia il rendering dalla prima clip",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "Chiedi il nome del file di output",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "Chiudi le impostazioni di pubblicazione all'annullamento",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "Durata",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "Codec",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "Frame rate",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - Stereo",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "Risoluzione",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "Audio",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "Dimensione (approssimativa)",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "Il collegamento al file di transcodifica andrà perso",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "Impostazioni di pubblicazione",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "Rendering video completato",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "Inserisci nome",
    "SAVE_SETTINGS_BTN_RENDER_START": "Avvia",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "Avvia",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "Torna al mio account",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "Torna al mio account",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "Annulla",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "Annulla",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "Scarica",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "Scarica",
    "SAVE_SETTINGS_BTN_BROWSE": "Sfoglia",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "Sfoglia",
    "SAVE_SETTINGS_BTN_COPY": "Copia",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "Copia",
    "SAVE_SETTINGS_TEXT_TITLE": "Titolo",
    "SAVE_SETTINGS_TEXT_LOADING": "Caricamento",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "Prepara le immagini",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "Questo video è stato inviato al tuo account e dovrebbe essere disponibile a breve.",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "Tutti",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "Cerca",
    "SHOW_MY_MEDIA_POOL": "Mostra la mia libreria media",
    "SHOW_PROJECT_MEDIA_POOL": "Mostra la libreria media di progetto",
    "SHOW_EDITOR_HEADER": "Mostra l'intestazione dell'editor",
    "SHOW_MENU_TABS": "Mostra le schede del menu",
    "SHOW_PREVIEW_SPLIT_BUTTON": "Mostra pulsante di divisione anteprima",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "Mostra pulsanti di cambio anteprima",
    "SHOW_INOUT_POINTS_TIMELINE": "Mostra punti in/out della timeline",
    "SHOW_INOUT_POINTS_SOURCE": "Mostra punti in/out della sorgente",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "Mostra segnaposto di importazione su timeline vuota",
    "VIEW_SETTINGS_LANG": "Lingua",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "Descrizione",
    "SETTINGS_HEAD_BTN_DELETE": "Elimina",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "Elimina",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "Seleziona uguale",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "Seleziona uguale",
    "SETTINGS_HEAD_BTN_CLOSE": "Chiudi",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "Chiudi",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "Larghezza",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "Altezza",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "Mantieni le proporzioni",
    "SETTINGS_BTN_FIT_TO_FRAME": "Adatta al fotogramma",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "Adatta al fotogramma",
    "SETTINGS_BTN_FILL_FRAME": "Riempi fotogramma",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "Riempi fotogramma",
    "SETTINGS_TEXT_AUTO": "auto",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "Nessuna trasformazione testo",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "Nessuna trasformazione testo",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "Testo maiuscolo",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "Testo maiuscolo",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "Testo minuscolo",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "Testo minuscolo",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "Testo iniziale maiuscola",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "Testo iniziale maiuscola",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "Famiglia di font",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "Famiglia di font",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "Dimensione font",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "Dimensione font",
    "SETTINGS_TEXT_BTN_BOLD": "Grassetto",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "Grassetto",
    "SETTINGS_TEXT_BTN_ITALIC": "Corsivo",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "Corsivo",
    "SETTINGS_TEXT_BTN_UNDERLINE": "Sottolineato",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "Sottolineato",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "Sinistra",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "Sinistra",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "Destra",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "Destra",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "Centro",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "Centro",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "Giustifica",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "Giustifica",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "Alto",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "Alto",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "In alto a sinistra",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "In alto a sinistra",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "In alto a destra",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "In alto a destra",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "Sinistra",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "Sinistra",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "Centro medio",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "Centro medio",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "Destra",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "Destra",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "In basso a sinistra",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "In basso a sinistra",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "In basso",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "In basso",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "In basso a destra",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "In basso a destra",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "Orizzontale",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "Verticale",
    "SETTINGS_ROTATION_TEXT_ROTATE": "Ruota",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "Inserisci testo",
    "NABLET_HLD_PROJECT_POSTFIX": "momenti salienti",
    "NABLET_HLD_CAPTION": "Rileva momenti salienti",
    "NABLET_HLD_DETECTED_BTN_START": "Avvia",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "Crea progetto/i",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "Annulla",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "Numero di intervalli rilevati:",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "Sei sicuro di voler terminare l'attività?",
    "NABLET_HLD_DETECTED_BTN_NO": "No",
    "NABLET_HLD_DETECTED_BTN_YES": "Sì",
    "NB_HLD_STATUS_TEXT_DETECTING": "Rilevamento in corso",
    "NABLET_HLD_TARGET_DURATION_SEC": "Durata target in secondi",
    "AI_MODEL": "Modello IA",
    "TRANSCRIBE_CAPTION": "Trascrivi media",
    "TRANSCRIBE_PROJECT_POSTFIX": "trascritto",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "Trascrizione in corso",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "Numero di elementi di testo:",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "Crea progetto",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "Questa sezione è in sviluppo",
    "TEXT_FORM_CAPTION_SIZE": "Dimensione",
    "TEXT_FORM_CAPTION_OUTLINE": "Contorno",
    "TEXT_FORM_CAPTION_FONT": "Font",
    "TEXT_FORM_CAPTION_SHADOW": "Ombra",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "Impostazioni testo",
    "TEXT_FORM_TEXT_OFFSET": "Offset",
    "TEXT_FORM_TEXT_BLUR": "Sfocatura",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "Testo",
    "TIMELINE_TEXT_DRAG_N_DROP": "Trascina e rilascia",
    "TIMELINE_TEXT_ADD_LAYER": "+ Aggiungi livello",
    "TIMELINE_TOOLBAR_BTN_UNDO": "Annulla",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "Annulla",
    "TIMELINE_TOOLBAR_BTN_REDO": "Ripeti",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "Ripeti",
    "TIMELINE_TOOLBAR_BTN_DELETE": "Elimina",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "Elimina",
    "TIMELINE_TOOLBAR_BTN_COPY": "Copia clip",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "Copia clip",
    "TIMELINE_TOOLBAR_BTN_CUT": "Taglia clip",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "Taglia clip",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "Aggiungi segnaposto",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "Aggiungi segnaposto",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "Incolla",
    "TIMELINE_TOOLBAR_BTN_PASTE": "Incolla",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "Impostazioni",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "Impostazioni",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "Voiceover",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "Voiceover",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "Webcam",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "Webcam",
    "TIMELINE_TOOLBAR_BTN_LIVE": "Streaming live",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "Streaming live",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "Clicca per annullare",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "Clicca per annullare",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "Trascina e rilascia",
    "TIMELINE_FOOTER_TEXT_DURATION": "Durata",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "Impossibile pubblicare il progetto",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "La traccia video è obbligatoria",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "Salva",
    "TIMELINE_FOOTER_BTN_SAVE": "Salva",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "Salva",
    "TIMELINE_FOOTER_BTN_PUBLISH": "Pubblica",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "Pubblica",
    "TIMELINE_SLIDER_POINTER": "Puntatore cursore",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "Puntatore cursore",
    "TRANSITION_NAME_DISSOLVE": "Dissolvenza",
    "TRANSITION_NAME_FADE_IN": "Dissolvenza in entrata",
    "TRANSITION_NAME_FADE_OUT": "Dissolvenza in uscita",
    "TRANSITION_NAME_DIP_TO_BLACK": "Dissolvenza al nero",
    "TRANSITION_NAME_DIP_TO_WHITE": "Dissolvenza al bianco",
    "TRANSITION_NAME_BLUR": "Sfocatura",
    "TRANSITION_NAME_WIPE_RIGHT": "Tendina a destra",
    "TRANSITION_NAME_WIPE_LEFT": "Tendina a sinistra",
    "TRANSITION_NAME_WIPE_UP": "Tendina in alto",
    "TRANSITION_NAME_WIPE_DOWN": "Tendina in basso",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "Impostazioni transizione",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "Applica a tutte le transizioni della timeline",
    "TRANSITION_FORM_SELECTED": "selezionati:",
    "TRANSITION_FORM_LABEL_TYPE": "Tipo",
    "TRANSITION_FORM_LABEL_DURATION": "Durata (sec)",
    "TRANSITION_LIST_CAPTION_TRANSITION": "Transizione",
    "used_in_projects": "Il file media non è stato eliminato perché è in uso in uno o più progetti. Se continui, il file non sarà disponibile sulla timeline nei progetti corrispondenti e verrà eliminato dal tuo account.",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "Usa la finestra modale per importare file locali",
    "VOICE_OVER_TITLE_LAST_RECORDING": "Ultima registrazione",
    "VOICE_OVER_BTN_RETAKE": "Rifai",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "Rifai",
    "VOICE_OVER_BTN_DELETE_FILE": "Elimina file",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "Elimina file",
    "VOICE_OVER_BTN_START_RECORDING": "Avvia registrazione",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "Avvia registrazione",
    "VOICE_OVER_BTN_CONNECTION": "Connessione...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "Connessione...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "Il file verrà eliminato dalla timeline e dai media.",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "Sei sicuro?",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "Narrazione vocale",
    "VOICE_OVER_TEXT_MIC": "Microfono",
    "VOICE_OVER_LABEL_SELECT_MIC": "Seleziona microfono",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "Nessun audio",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "Disattiva la timeline durante la registrazione",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "Riavvolgi il cursore all'inizio dopo la registrazione",
    "VOICE_OVER_TEXT_COUNTDOWN": "Conto alla rovescia",
    "VOICE_OVER_BTN_TEST_MIC": "Prova microfono",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "Prova microfono",
    "VOICE_OVER_BTN_RECORDING": "Registrazione in corso...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "Registrazione in corso...",
    "VOICE_OVER_BTN_PLAYING": "Riproduzione in corso...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "Riproduzione in corso...",
    "VOICE_OVER_BTN_YES": "Sì",
    "VOICE_OVER_BTN_YES_TOOLTIP": "Sì",
    "VOICE_OVER_BTN_NO": "No",
    "VOICE_OVER_BTN_NO_TOOLTIP": "No",
    "VOICE_OVER_BTN_STOP": "Stop",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "Stop",
    "VOICE_OVER_BTN_DELETE": "Elimina",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "Elimina",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "Regolazione automatica",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "Altre impostazioni",
    "WEBCAM_TEXT_RECORD_VIDEO": "Registra video",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "Registra streaming live",
    "LIVE_STREAM_URL_INPUT_LABEL": "URL streaming live",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "Fai clic qui per collegare uno streaming live",
    "LIVE_STREAM_BTN_CONNECTING": "Connessione in corso...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "Connessione in corso...",
    "LIVE_STREAM_BTN_CAPTURE": "Avvia acquisizione",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "Avvia acquisizione",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "Interrompi acquisizione",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "Interrompi acquisizione",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "Riduci zoom",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "Riduci zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "Aumenta zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "Aumenta zoom",
    "SETTINGS_HOTKEYS": "Impostazioni scorciatoie",
    "PRESET": "Preimpostazione",
    "DEFAULT": "Predefinito",
    "ADD_NEW": "Aggiungi nuovo",
    "SEARCH_COMMAND": "Cerca comando",
    "COMMAND": "Comando",
    "SHORTCUTS": "Scorciatoie",
    "ALL": "Tutti",
    "TIMELINE": "Timeline",
    "TOOLS": "Strumenti",
    "PREVIEW": "Anteprima",
    "KEYBOARD_MAPPING_PRESET": "Preimpostazione mappatura tastiera",
    "ENTER_PRESET_NAME": "Inserisci nome preimpostazione",
    "THIS_PRESET_WILL_BE_DELETED": "Questa preimpostazione verrà eliminata immediatamente. Non puoi annullare questa azione.",
    "RESET_ALL_TO_DEFAULTS": "Reimposta tutto ai predefiniti",
    "HOTKEY_SETTINGS_UNDO": "Annulla",
    "HOTKEY_SETTINGS_REDO": "Ripeti",
    "HOTKEY_SETTINGS_ZOOM_IN": "Ingrandisci",
    "HOTKEY_SETTINGS_ZOOM_OUT": "Riduci",
    "HOTKEY_SETTINGS_PREV_FRAME": "Fotogramma precedente",
    "HOTKEY_SETTINGS_NEXT_FRAME": "Fotogramma successivo",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "Aggiungi alla timeline",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "Aumenta volume clip",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "Riduci volume clip",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "Eliminazione a catena",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "Taglio a catena precedente",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "Taglio a catena successivo",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "Seleziona clip nella posizione corrente",
    "HOTKEY_SETTINGS_CUT_CLIPS": "Taglia clip",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "Riproduci/Pausa",
    "HOTKEY_SETTINGS_DELETE": "Elimina",
    "HOTKEY_SETTINGS_COPY": "Copia",
    "HOTKEY_SETTINGS_PASTE": "Incolla",
    "HOTKEY_SETTINGS_PLAY": "Riproduci",
    "HOTKEY_SETTINGS_PAUSE": "Pausa",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "Riproduci l'intervallo evidenziato",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "Cancella punti in/out",
    "HOTKEY_SETTINGS_MARK_IN": "Punto di ingresso",
    "HOTKEY_SETTINGS_MARK_OUT": "Punto di uscita",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "Vai al punto di ingresso",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "Vai al punto di uscita",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "Sposta il cursore al punto di modifica successivo",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "Sposta il cursore al punto di modifica precedente",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "Attiva/disattiva visibilità dei miei media",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "Attiva/disattiva visibilità impostazioni editor",
    "CLIP_SETTINGS": "Impostazioni clip",
    "MESSAGE_BOX_INCOMPATIBLE": "I file non sono compatibili",
    "MESSAGE_BOX_REMOVE_EXISTING": "I file non sono compatibili (formato non corrispondente)",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "I file non sono compatibili (risoluzione non corrispondente)",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "I file non sono compatibili (frame rate non corrispondente)",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "I file non sono compatibili (codec non corrispondenti)",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "I file non sono compatibili (formato timecode DF/NDF non corrispondente)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "I file non sono compatibili (spazio colore non corrispondente)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "I file non sono compatibili (parametri encoder video non corrispondenti)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "Il file è incompatibile (elimina la clip offline)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "Modelli di trascrizione non trovati.\\nVuoi scaricarli (~882 MB) e installarli?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "Modelli di rilevamento momenti salienti sportivi non trovati.\\nVuoi scaricarli (~3.9 GB) e installarli?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "Il rilevamento momenti salienti sportivi richiede NVIDIA GPU con capacità di calcolo >= 7.5",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "Impedisci l'aggiunta di file video con codec, risoluzioni, FPS, timecode DF/NDF, spazio colore diversi alla stessa timeline",
    "MARKS_CONTEXT_MENU_MARK_IN": "Punto di ingresso",
    "MARKS_CONTEXT_MENU_MARK_OUT": "Punto di uscita",
    "MARKS_CONTEXT_MENU_CLEAR": "Cancella punti in/out",
    "MEDIA_ERROR_build_thumbnails_error": "Errore di creazione miniature",
    "MEDIA_ERROR_unsupported_media": "Media non supportato",
    "MEDIA_ERROR_exceeded_file_size": "Dimensione file superata",
    "MEDIA_ERROR_exceeded_per_user_size": "Dimensione per utente superata",
    "MEDIA_ERROR_low_disk_space": "Spazio su disco insufficiente",
    "MEDIA_ERROR_internal_server_error": "Errore interno del server",
    "MEDIA_ERROR_network_error": "Errore di rete",
    "MEDIA_ERROR_not_found": "File media non trovato",
    "MEDIA_ERROR_unable_get_media_info": "Impossibile ottenere le informazioni del media",
    "MEDIA_ERROR_not_enough_tokens": "Token non sufficienti",
  },
  fr: {
    "ADD_FOLDER_BTN": "Ajouter un dossier",
    "ADD_FOLDER_BTN_TOOLTIP": "Ajouter un dossier",
    "ADD_FIRST_IMPORTED_FILE_TO_TIMELINE_AT_SOURCE_START_TIMECODE": "Ajouter le premier fichier importé à la timeline au timecode de début de la source",
    "ALLOW_TIMELINE_MEDIA_LAYOUT_CHANGE": "Autoriser le changement de disposition timeline/média",
    "AMAZON_IMPORT_PLACEHOLDER_BUCKET_NAME": "Nom du bucket",
    "AMAZON_IMPORT_PLACEHOLDER_ACCESS_ID_KEY": "ID de clé d'accès",
    "AMAZON_IMPORT_PLACEHOLDER_SECRET_KEY": "Clé secrète",
    "AMAZON_IMPORT_PROGRESS_TEXT_IMPORTING": "Importation en cours",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORT_ERROR": "Erreur d'importation",
    "AMAZON_IMPORT_CONDITION_TEXT_IMPORTED_SUCCESSFULLY": "Importé avec succès",
    "AMAZON_IMPORT_HEAD_TEXT_IMPORT_MEDIA_FROM_AWS": "Importer des médias depuis un bucket AWS",
    "AMAZON_IMPORT_BTN_IMPORT": "Importer",
    "AMAZON_IMPORT_BTN_IMPORT_TOOLTIP": "Importer",
    "ASK_PROJECT_NAME_ON_NEW_PROJECT_BEHAVIOUR_SETTING": "Demander le nom du projet dans Nouveau projet",
    "AUDIO_CAPTION_AUDIO": "Audio",
    "AUDIO_TEXT_FOUND_ITEMS": "Éléments trouvés",
    "AUDIO_TEXT_NO_RESULTS_FOUND": "Aucun résultat trouvé",
    "AUDIO_TEXT_CANNOT_FIND_RESULTS": "Il semble que nous ne puissions trouver aucun résultat correspondant à votre recherche.",
    "AUDIO_SETTINGS_FORM_TITLE_SETTINGS_AUDIO": "Paramètres audio",
    "AUDIO_SETTINGS_FORM_CAPTION_SOUND": "Son",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITION": "Transition",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_IN": "Fondu d'entrée (s)",
    "AUDIO_SETTINGS_FORM_LABEL_FADE_OUT": "Fondu de sortie (s)",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_GENRE": "Rechercher un genre",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_MUSIC": "Rechercher de la musique",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_SOUND_EFFECTS": "Rechercher des effets sonores",
    "AUDIO_INPUT_PLACEHOLDER_SEARCH_IN": "Rechercher dans",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_GENRE": "Musique par genre",
    "AUDIO_LIST_CATEGORIES_SOUND_EFFECTS": "Effets sonores",
    "AUDIO_LIST_CATEGORIES_MUSIC_BY_MOOD": "Musique par humeur",
    "AUDIO_MENU_ITEM_ALL": "Tout",
    "AUDIO_SETTINGS_FORM_CAPTION_TRANSITIONS": "Transitions",
    "AUTO_PLAY_SELECTED_MEDIA_BEHAVIOUR_SETTING": "Lecture automatique du média sélectionné",
    "BASE_ASSETS_SETTINGS_TEXT_REMOVE_ASSETS_FROM_TIMELINE": "Supprimer l'élément de la timeline ?",
    "BEHAVIOUR_SETTINGS_SET_TIMECODE_FORMAT_BASED_ON_MEDIA": "Définir le format de timecode selon le média",
    "BATCH_IMPORT_FILES_HEAD": "Importer des fichiers",
    "BATCH_IMPORT_FILES_PROGRESS_TEXT": "Analyse",
    "CAPTION_ADDED": "Ajouté",
    "CAPTION_SKIPPED": "Ignoré",
    "COLOR_PICKER_BTN_COLOR": "Choisir une couleur",
    "COLOR_PICKER_BTN_COLOR_TOOLTIP": "Choisir une couleur",
    "COLOR_PICKER_TEXT_TEXT_BACKGROUND_COLOR": "Couleur d'arrière-plan",
    "COLOR_PICKER_BACKGROUND_COLOR_TOOLTIP": "Couleur d'arrière-plan",
    "COMMON_STATUS_TEXT_DOWNLOADING_MEDIA_FILES": "Téléchargement des fichiers média",
    "COMMON_STATUS_TEXT_IMPORT_MEDIA_FILES": "Importation des fichiers média",
    "COMMON_STATUS_TEXT_UPLOADING_SAVED_MEDIA": "Téléversement des médias enregistrés",
    "COMMON_STATUS_TEXT_ABORTED": "Abandonné",
    "COMMON_STATUS_TEXT_LOADING": "Chargement",
    "COMMON_STATUS_TEXT_OPERATION_IS_QUEUED": "L'opération est en file d'attente",
    "COMMON_STATUS_TEXT_PREPARE_IMAGES": "Préparer les images",
    "COMMON_STATUS_TEXT_RENDERING": "Rendu",
    "COMMON_STATUS_TEXT_CONVERT": "Convertir",
    "COMMON_YES": "Oui",
    "COMMON_NO": "Non",
    "COMMON_OK": "OK",
    "COMMON_RESET_ALL_CHANGES": "Réinitialiser toutes les modifications",
    "CONFIRMATION_DIALOG_BTN_CANCEL": "Annuler",
    "CONFIRMATION_DIALOG_BTN_CANCEL_TOOLTIP": "Annuler",
    "CUSTOMIZATION_FORM_CAPTION_USER_AVATAR": "Avatar utilisateur",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_UPLOAD_AVATAR": "Vous pouvez téléverser un fichier d'avatar utilisateur par défaut.",
    "CUSTOMIZATION_FORM_FIELD_NAME_AVATAR": "Avatar",
    "CUSTOMIZATION_FORM_CAPTION_COLOR_THEME": "Thème de couleur",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_JS_SCRIPT": "Script JS personnalisé",
    "CUSTOMIZATION_FORM_CAPTION_CUSTOM_TEXT": "Texte personnalisé",
    "CUSTOMIZATION_FORM_FIELD_DESC_YOU_CAN_CUSTOMIZE_TEXT": "Vous pouvez personnaliser le texte de l'éditeur",
    "CUSTOMIZATION_FORM_FIELD_DESC_THIS_SCRIPT_RUNS_ON_LOADING": "Ce script s'exécute au chargement de l'éditeur. Peut être utilisé pour intégrer des analyses, etc.",
    "CUSTOMIZATION_TITLE_EDIT_JS_SCRIPT": "Modifier le script JS",
    "CUSTOMIZATION_TITLE_SECOND_ACCENT_COLOR": "Deuxième couleur d'accent",
    "CUSTOMIZATION_DESC_SELECT_BG_COLOR": "Sélectionnez la couleur de l'arrière-plan principal.",
    "CUSTOMIZATION_DESC_MAIN_ACCENT_COLOR_FOR_CONTROLS": "La couleur d'accent principale pour les contrôles. Sélectionnez ici la couleur de votre marque.",
    "CUSTOMIZATION_DESC_ADDITIONAL_COLOR_FOR_CONTROLS": "Couleur supplémentaire des contrôles en paire avec la couleur principale des boutons.",
    "CUSTOMIZATION_DESC_AUDIO_FILES_STYLE": "Le fichier audio sur la timeline a son propre style.",
    "CUSTOMIZATION_DESC_YOU_CAN_UPLOAD_LOGO": "Vous pouvez téléverser un fichier de votre logo.",
    "CUSTOMIZATION_DESC_VOICE_OVER_STYLE": "Le fichier de voix off a son propre style.",
    "CUSTOMIZATION_LABEL_DISPLAYED": "affiché",
    "CUSTOMIZATION_TITLE_CHOOSE_THEME": "Choisissez l'un des thèmes prédéfinis ou créez le vôtre. Vous pouvez modifier le fichier CSS pour personnaliser votre thème.",
    "CUSTOMIZATION_TITLE_BASIC_BG": "Arrière-plan de base",
    "CUSTOMIZATION_TITLE_PRIMARY_BTNS": "Boutons et liens principaux",
    "CUSTOMIZATION_TITLE_EDIT_CSS_FOR_THEME": "Modifier le fichier CSS du thème",
    "CUSTOMIZATION_TITLE_AUDIO": "Audio",
    "CUSTOMIZATION_TITLE_VOICE_OVER": "Voix off",
    "CUSTOMIZATION_TITLE_EDIT_TEXT_VALUES": "Modifier les valeurs du texte",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES": "Modifier les valeurs du texte",
    "CUSTOMIZATION_BTN_EDIT_TEXT_VALUES_TOOLTIP": "Modifier les valeurs du texte",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION": "Description du format",
    "CUSTOMIZATION_BTN_FORMAT_DESCRIPTION_TOOLTIP": "Description du format",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES": "Réinitialiser toutes les modifications",
    "CUSTOMIZATION_BTN_RESET_ALL_CHANGES_TOOLTIP": "Réinitialiser toutes les modifications",
    "CUSTOMIZATION_BTN_CANCEL": "Annuler",
    "CUSTOMIZATION_BTN_CANCEL_TOOLTIP": "Annuler",
    "CUSTOMIZATION_BTN_SAVE": "Enregistrer",
    "CUSTOMIZATION_BTN_SAVE_TOOLTIP": "Enregistrer",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT": "Modifier le script JS",
    "CUSTOMIZATION_BTN_EDIT_JS_SCRIPT_TOOLTIP": "Modifier le script JS",
    "CUSTOMIZATION_BTN_EDIT_CSS": "Modifier le CSS",
    "CUSTOMIZATION_BTN_EDIT_CSS_TOOLTIP": "Modifier le CSS",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO": "Téléverser le logo",
    "CUSTOMIZATION_BTN_UPLOAD_LOGO_TOOLTIP": "Téléverser le logo",
    "CUSTOMIZATION_BTN_DELETE_LOGO": "Supprimer le logo",
    "CUSTOMIZATION_BTN_DELETE_LOGO_TOOLTIP": "Supprimer le logo",
    "CUSTOMIZATION_CSS_OPTION_DARK_THEME": "Thème sombre",
    "CUSTOMIZATION_CSS_OPTION_LIGHT_THEME": "Thème clair",
    "CUSTOMIZATION_CSS_OPTION_CUSTOM_THEME": "Thème personnalisé",
    "CUSTOMIZATION_FORM_FIELD_NAME_LOGO": "Logo",
    "CUSTOMIZATION_FORM_CAPTION_LOGO": "Logo",
    "CUSTOMIZATION_CAPTION_CUSTOMIZE_EDITOR": "Personnaliser l'éditeur",
    "CUSTOMIZATION_CAPTION_LOGO_AND_NAME": "Logo et nom",
    "CUSTOMIZATION_CAPTION_COMPANY_NAME": "Nom de l'entreprise",
    "CUSTOMIZATION_CAPTION_EDITOR_NAME": "Nom de l'éditeur",
    "CUSTOMIZATION_TEXT_ACCEPTED_FILES": "Fichiers acceptés :",
    "CUSTOMIZATION_TEXT_NO_UPLOADED_LOGO": "Aucun logo téléversé",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS_TOOLTIP": "Paramètres d'affichage",
    "DUMMY_HEADER_BTN_VIEW_SETTINGS": "Paramètres d'affichage",
    "DUMMY_HEADER_BTN_FILTERS_TOOLTIP": "Filtres",
    "DUMMY_HEADER_BTN_FILTERS": "Filtres",
    "EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Enregistrer le projet sous..",
    "EDITOR_MENU_LIST_ITEM_ADMIN_PANEL": "Panneau d'administration",
    "EDITOR_MENU_LIST_ITEM_NEW_PROJECT": "Nouveau projet",
    "EDITOR_MENU_LIST_ITEM_PUBLISH": "Publier",
    "EDITOR_MENU_LIST_ITEM_CUSTOMIZE_EDITOR": "Personnaliser l'éditeur",
    "EDITOR_MENU_ADOBE_CEP_EXTENTIONS": "Extensions Adobe CEP",
    "EDITOR_MENU_MAIN_LOGS": "Journaux",
    "EDITOR_MENU_MAIN_SETTINGS": "Paramètres",
    "EDITOR_MENU_TITLE_UNABLE_TO_PUBLISH": "Impossible de publier",
    "EDITOR_MENU_TEXT_VIDEO_TRACK_IS_REQUIRED": "La piste est requise",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS": "Paramètres de rendu",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS": "Comportement",
    "EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS": "Affichage",
    "EDITOR_MAIN_SETTINGS_BTN_SAVE": "Enregistrer",
    "EDITOR_MAIN_SETTINGS_BTN_CANCEL": "Annuler",
    "FILE_INPUT_BTN": "Entrée de fichier",
    "FILE_INPUT_BTN_TOOLTIP": "Entrée de fichier",
    "FORM_FIELD_LABEL_VOLUME": "Volume",
    "folder_not_empty": "Le dossier n'est pas vide. Les fichiers peuvent être utilisés dans les projets. Si vous continuez, le fichier ne sera pas disponible sur la timeline des projets correspondants.",
    "HEAD_CONTROL_IMPORT_TEXT": "Importer",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_MEDIA": "Importer des médias",
    "HEAD_CONTROL_IMPORT_FROM_PHONE_BY_QRCODE": "Importer depuis le téléphone",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_IMPORT_FOLDER_WITH_MEDIA": "Importer un dossier avec des médias",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_AMAZON_S3_BUCKET": "Bucket Amazon S3",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_DROPBOX": "Dropbox",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_GOOGLE_DRIVE": "Google Drive",
    "HEAD_CONTROL_IMPORT_MENU_ITEM_URL_INPUT": "Saisie d'URL",
    "HEADER_MENU_LIST_ITEM_SAVE_PROJECT_AS": "Enregistrer le projet sous..",
    "HEADER_MENU_LIST_ITEM_DELETE": "Supprimer",
    "HEADER_MENU_LIST_ITEM_RENAME": "Renommer",
    "HEADER_PROFILE_MENU_ITEM_ADD_LICENSE_KEY": "Ajouter une clé de licence",
    "HEADER_PROFILE_MENU_ITEM_LOG_OUT": "Se déconnecter",
    "HEADER_TEXT_DO_YOU_WANT_TO_LEAVE_EDITOR": "Voulez-vous quitter l'éditeur ?",
    "HEADER_BTN_BACK_TO_MY_ACC": "Retour à Mon compte",
    "HEADER_BTN_BACK_TO_MY_ACC_TOOLTIP": "Retour à Mon compte",
    "HEADER_BTN_HELP": "Aide",
    "HEADER_BTN_HELP_TOOLTIP": "Aide",
    "IMAGES_TEXT_NATIVE_IMAGES": "Image native",
    "IMAGES_TEXT_PEXELS": "Pexels",
    "IMAGES_TEXT_UNSPLASH": "Unsplash",
    "IMAGES_HEADER_CAPTION": "Images",
    "IMAGES_PLACEHOLDER_SEARCH_IN": "Rechercher dans",
    "IMAGES_PLACEHOLDER_SELECT_COLLECTION": "Sélectionner une collection",
    "IMAGES_TEXT_ALL_CATEGORIES": "Toutes les collections",
    "IMAGES_TEXT_NO_RESULTS_FOUND": "Aucun résultat trouvé",
    "IMAGES_TEXT_CANNOT_FIND_RESULTS": "Il semble que nous ne puissions trouver aucun résultat correspondant à votre recherche.",
    "IMAGES_TAB_AI_GENERATED": "Généré par IA",
    "IMAGES_TAB_SEARCH": "Rechercher",
    "IMPORT_FROM_URL_TEXT_IMPORT_MEDIA_FROM_URL": "Importer des médias depuis une URL",
    "IMPORT_FROM_URL_PLACEHOLDER_CLICK_TO_LINK_FILE": "Cliquez ici pour lier un fichier",
    "IMPORT_FROM_URL_BTN_IMPORT": "Importer",
    "IMPORT_FROM_URL_BTN_IMPORT_TOOLTIP": "Importer",
    "IMPORT_TOKEN_INVALID": "Jeton d'importation invalide",
    "LAYER_CONTROL_BTN_MOVE_UP": "Monter",
    "LAYER_CONTROL_BTN_MOVE_UP_TOOLTIP": "Monter",
    "LAYER_CONTROL_BTN_DRAG_LAYER": "Glisser le calque",
    "LAYER_CONTROL_BTN_DRAG_LAYER_TOOLTIP": "Glisser le calque",
    "LAYER_CONTROL_BTN_MOVE_DOWN": "Descendre",
    "LAYER_CONTROL_BTN_MOVE_DOWN_TOOLTIP": "Descendre",
    "LAYER_CONTROL_BTN_DELETE": "Supprimer",
    "LAYER_CONTROL_BTN_DELETE_TOOLTIP": "Supprimer",
    "LAYER_CONTROL_BTN_HIDE": "Masquer",
    "LAYER_CONTROL_BTN_HIDE_TOOLTIP": "Masquer",
    "LAYER_CONTROL_BTN_SHOW": "Afficher",
    "LAYER_CONTROL_BTN_SHOW_TOOLTIP": "Afficher",
    "LAYER_CONTROL_BTN_MUTE": "Couper le son",
    "LAYER_CONTROL_BTN_MUTE_TOOLTIP": "Couper le son",
    "LAYER_CONTROL_BTN_UNMUTE": "Réactiver le son",
    "LAYER_CONTROL_BTN_UNMUTE_TOOLTIP": "Réactiver le son",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA": "Mes médias",
    "LEFT_TOOLBAR_MENU_BTN_MY_MEDIA_TOOLTIP": "Mes médias",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA": "Médias du projet",
    "LEFT_TOOLBAR_MENU_BTN_PROJECT_MEDIA_TOOLTIP": "Médias du projet",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS": "Transitions",
    "LEFT_TOOLBAR_MENU_BTN_TRANSITIONS_TOOLTIP": "Transitions",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES": "Images",
    "LEFT_TOOLBAR_MENU_BTN_IMAGES_TOOLTIP": "Images",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_AUDIO_TOOLTIP": "Audio",
    "LEFT_TOOLBAR_MENU_BTN_TEXT": "Texte",
    "LEFT_TOOLBAR_MENU_BTN_TEXT_TOOLTIP": "Texte",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN": "Conception",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_TOOLTIP": "Conception",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS": "Filtres",
    "LEFT_TOOLBAR_MENU_BTN_FILTERS_TOOLTIP": "Filtres",
    "LEFT_TOOLBAR_MENU_BTN_DESIGN_FILTERS": "Filtres",
    "MEDIA_API_IS_NOT_AVAILABLE": "Erreur : la WebAPI Voiceover nécessite https",
    "MEDIA_FORM_TITLE_SETTINGS_IMAGE": "Paramètres de l'image",
    "MEDIA_FORM_CAPTION_POSITION": "Position",
    "MEDIA_FORM_CAPTION_ROTATION": "Rotation",
    "MEDIA_FORM_CAPTION_SETTINGS": "Paramètres",
    "MEDIA_FORM_CAPTION_OUTLINE": "Contour",
    "MEDIA_FORM_CAPTION_SHADOW": "Ombre",
    "MEDIA_FORM_CAPTION_SIZE": "Taille",
    "MEDIA_FORM_CAPTION_VIDEO": "Vidéo",
    "MEDIA_FORM_CAPTION_AUDIO": "Audio",
    "MEDIA_FORM_SLIDER_LABEL_OPACITY": "Opacité",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS": "Filtre",
    "MEDIA_HEAD_CONTROL_BTN_FILTERS_TOOLTIP": "Filtre",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_ALL": "Tout",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VIDEO": "Vidéo",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_IMAGE": "Image",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_AUDIO": "Audio",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_FOLDER": "Dossier",
    "MEDIA_HEAD_CONTROL_FILTERS_MENU_ITEM_VOICEOVER": "Voix off",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS": "Paramètres d'affichage",
    "MEDIA_HEAD_CONTROL_BTN_VIEW_SETTINGS_TOOLTIP": "Paramètres d'affichage",
    "MEDIA_UPLOADER_TEXT_OR": "ou",
    "MEDIA_UPLOADER_TEXT_DND_YOUR_MEDIA": "Glissez-déposez vos médias ici",
    "MEDIA_UPLOADER_TEXT_IMPORT_MEDIA": "importer des médias",
    "MEDIA_PREVIEW_TEXT_IMPORTING": "Importation en cours",
    "MEDIA_PREVIEW_TEXT_RENDERING": "Rendu",
    "MEDIA_INFO_LIST_ITEM_RESOLUTION": "Résolution",
    "MEDIA_INFO_LIST_ITEM_ROTATION": "Degrés de rotation",
    "MEDIA_INFO_LIST_ITEM_CODEC": "Codecs",
    "MEDIA_INFO_LIST_ITEM_COLOR_SPACE": "Espace colorimétrique",
    "MEDIA_INFO_LIST_ITEM_FRAME_RATE": "Cadence",
    "MEDIA_INFO_LIST_ITEM_HZ_STEREO": "Hz - Stéréo",
    "MEDIA_INFO_LIST_ITEM_DURATION": "Durée",
    "MEDIA_INFO_LIST_ITEM_TYPE": "Type",
    "MEDIA_INFO_LIST_ITEM_AUDIO": "Audio",
    "MEDIA_INFO_LIST_ITEM_SIZE": "Taille",
    "MEDIA_INFO_LIST_TASK_STATUS": "État de la tâche",
    "MEDIA_INFO_LIST_TASK_STARTTIME_CODE_FRAMES": "Timecode de début",
    "MEDIA_INFO_LIST_ITEM_VIDEO_ENCODER_PARAMS": "Paramètres de l'encodeur vidéo",
    "MEDIA_LIST_HEADER_TEXT_MEDIA": "Mes médias",
    "MEDIA_LIST_HEADER_TEXT_PROJECT_MEDIA": "Médias du projet",
    "MEDIA_BTN_LOAD_MORE_MEDIA": "Charger plus de médias",
    "MEDIA_BTN_LOAD_MORE_MEDIA_TOOLTIP": "Charger plus de médias",
    "MEDIA_BTN_LOADING": "Chargement",
    "MEDIA_BTN_LOADING_TOOLTIP": "Chargement",
    "MEDIA_VIDEO_FORM_CAPTION_CHROMA_KEY": "Incrustation",
    "MEDIA_VIDEO_FORM_CAPTION_POSITION": "Position",
    "MEDIA_VIDEO_FORM_CAPTION_SOUND": "Son",
    "MEDIA_VIDEO_FORM_CAPTION_SIZE": "TAILLE",
    "MEDIA_VIDEO_FORM_TITLE_SETTINGS_MEDIA": "Paramètres du média",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS": "Réinitialiser tous les paramètres",
    "MEDIA_VIDEO_FORM_BTN_RESET_ALL_SETTINGS_TOOLTIP": "Réinitialiser tous les paramètres",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SIMILARITY": "Similitude",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SMOOTHNESS": "Lissage",
    "MEDIA_VIDEO_FORM_SLIDER_LABEL_SPILL_REDUCTION": "Réduction des reflets de la couleur clé",
    "MEDIA_VIDEO_FORM_TOOLTIP_PICK_COLOR_FROM_PREVIEW": "Choisir une couleur dans l'aperçu",
    "MEDIA_SORT_OPTION_DURATION": "Durée",
    "MEDIA_SORT_OPTION_DATE": "Date",
    "MEDIA_SORT_OPTION_SIZE": "Taille",
    "MEDIA_SORT_OPTION_NAME": "Nom",
    "MEDIA_SORT_GROUP_SORT_BY_TOOLTIP": "Trier par",
    "MEDIA_SORT_GROUP_ORDER_TOOLTIP": "Ordre",
    "MEDIA_SORT_GROUP_VIEW_TOOLTIP": "Affichage",
    "MEDIA_SORT_OPTION_ASCENDING": "Croissant",
    "MEDIA_SORT_OPTION_DESCENDING": "Décroissant",
    "MEDIA_SORT_OPTION_LIST": "Liste",
    "MEDIA_SORT_OPTION_LARGE_ICONS": "Grandes icônes",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS": "Mes enregistrements",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_RECORDINGS_TOOLTIP": "Mes enregistrements",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA": "Mes médias",
    "MEDIA_FILE_FILTERS_LIST_ITEM_MY_MEDIA_TOOLTIP": "Mes médias",
    "MEDIA_FILES_DELETE_FORM_TITLE": "Certains fichiers sont utilisés par des projets et n'ont pas été supprimés",
    "MEDIA_FILES_DELETE_FORM_DESC": "Les fichiers sélectionnés seront supprimés de la bibliothèque média et ne seront plus disponibles dans les projets",
    "MEDIA_FILES_DELETE_FORM_SELECT_CAPTION": "Fichiers utilisés dans les projets",
    "MEDIA_FILES_DELETE_FORM_SELECT_ALL_LABEL": "Tout sélectionner",
    "MEDIA_CONFIRM_DESC_ARE_YOU_SURE_TO_REMOVE_SELECTED": "Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?",
    "MEDIA_CONFIRM_TITLE_BROWSER_FOR_FOLDER": "Parcourir pour un dossier",
    "MEDIA_CONFIRM_BTN_DELETE": "Supprimer",
    "MEDIA_CANCEL_BTN_DELETE": "Annuler",
    "MEDIA_CONFIRM_BTN_DELETE_TOOLTIP": "Supprimer",
    "MEDIA_CONFIRM_TITLE_DELETE": "Supprimer",
    "MEDIA_TEXT_LOADING": "Chargement",
    "MEDIA_BTN_ADD": "Ajouter",
    "MEDIA_BTN_ADD_TOOLTIP": "Ajouter",
    "MEDIA_PROGRESS_TEXT_LOADING": "Chargement",
    "MEDIA_PROGRESS_TEXT_SAVING": "Enregistrement",
    "MEDIA_PROGRESS_TEXT_CONVERT": "Convertir",
    "MEDIA_PROGRESS_TEXT_TRANSFER": "Transfert",
    "MEDIA_PROGRESS_TEXT_ANALYSIS": "Analyse",
    "MEDIA_MENU_ITEM_SELECT_FOLDER": "Sélectionner un dossier",
    "MEDIA_MENU_ITEM_MEDIA": "Média",
    "MEDIA_MENU_ITEM_MOVE_TO": "Déplacer vers",
    "MEDIA_MENU_ITEM_SETTINGS": "Paramètres",
    "MEDIA_MENU_ITEM_NABLET_HLD": "Détecter les moments forts sportifs",
    "MEDIA_MENU_ITEM_TRANSCRIBE": "Transcrire",
    "MEDIA_MENU_ITEM_DELETE": "Supprimer",
    "MEDIA_MENU_ITEM_DELETE_SELECTED_CLIPS": "Supprimer les clips sélectionnés",
    "MEDIA_MENU_ITEM_BROWSE_MEDIA": "Parcourir les médias",
    "MEDIA_MENU_ITEM_COPY_MEDIA_ADDRESS": "Copier l'adresse du média",
    "MEDIA_MENU_ITEM_INSERT_USING_START_TIMECODE": "Ajouter en utilisant le timecode de début",
    "MEDIA_MENU_LABEL_MOVE_TO": "Déplacer vers",
    "MEDIA_CONFIRM_BTN_OK": "OK",
    "MEDIA_CONFIRM_BTN_OK_TOOLTIP": "OK",
    "MOBILE_PLUG_TEXT_HTML_VIDEO_EDITOR": "Éditeur vidéo HTML5",
    "MOBILE_PLUG_TEXT_TABLETS_MOBILES_ARENT_SUPPORTED": "Les tablettes et mobiles ne sont pas encore pris en charge :(",
    "MOBILE_PLUG_TEXT_WORKS_WELL_ON_THE_PC": "L'éditeur vidéo fonctionne bien sur votre ordinateur",
    "MOBILE_PLUG_LINK_TEXT_GO_BACK_TO_WEB": "Revenir au site web",
    "MOBILE_UPLOAD_TITLE": "Téléverser des fichiers vers le stockage de l'utilisateur",
    "MOBILE_UPLOAD_SUBTITLE": "Prend en charge : vidéo, audio, photos. Vos fichiers seront enregistrés dans le stockage de l'utilisateur",
    "MODAL_WINDOW_LANGUAGE_CHANGE_TITLE": "Pour changer de langue, vous devez redémarrer l'application",
    "MODAL_WINDOW_LOGS_TITLE": "Pour activer/désactiver les journaux, vous devez redémarrer l'application",
    "MODAL_WINDOW_INSTALL_COMPONENT_TITLE": "Le composant demandé a été installé. Vous devez redémarrer l'application",
    "MESSAGE_BOX_INSTALL_RUNNING": "Une autre installation est en cours.\\nVeuillez attendre qu'elle soit terminée.",
    "MESSAGE_BOX_INSTALL_FAILED": "L'installation n'a pas pu s'exécuter. Consultez les journaux pour plus de détails",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_TITLE": "Sélectionnez un fichier de référence",
    "MODAL_WINDOW_REFERENCE_FILE_CHOICE_DESCRIPTION": "Vous ajoutez des fichiers avec différents FPS/résolution/codec. Sélectionnez le fichier dont les propriétés seront appliquées au projet",
    "MODAL_WINDOW_BUTTON_RESTART": "Redémarrer",
    "MUTE_AUDIO_AT_CREATED_LAYERS": "Couper l'audio sur les calques créés",
    "NAVIGATION_TAB_EDITOR": "Éditeur",
    "NAVIGATION_TAB_EDITOR_TOOLTIP": "Éditeur",
    "NAVIGATION_TAB_PROJECTS": "Projets",
    "NAVIGATION_TAB_PROJECTS_TOOLTIP": "Projets",
    "OFFLINE_MODE_PLUG_TEXT_NO_NETWORK_CONNECTION": "Aucune connexion réseau",
    "OFFLINE_MODE_PLUG_TEXT_LAST_SAVED": "Dernière sauvegarde",
    "OFFLINE_MODE_PLUG_TEXT_MIN_AGO": "min",
    "OFFLINE_MODE_PLUG_TEXT_JUST_NOW": "à l'instant",
    "PROJECTS_BTN_NEW_PROJECTS": "Nouveau projet",
    "PROJECTS_BTN_NEW_PROJECTS_TOOLTIP": "Nouveau projet",
    "PROJECTS_BTN_NEW_PROJECT": "Nouveau projet",
    "PROJECTS_BTN_IMPORT": "Importer",
    "PROJECTS_BTN_IMPORT_TOOLTIP": "Importer",
    "PROJECTS_IMPORT_CONFIRM_TEXT_YES": "Oui",
    "PROJECTS_IMPORT_BTN_OK": "OK",
    "PROJECTS_IMPORT_BTN_OK_TOOLTIP": "OK",
    "PROJECTS_IMPORT_TEXT_CANCEL": "Annuler",
    "PROJECTS_TITLE_TEXT_COPY": "Copier",
    "PROJECTS_BTN_SAVE": "Enregistrer",
    "PROJECTS_BTN_SAVE_TOOLTIP": "Enregistrer",
    "PROJECTS_BTN_CREATE": "Créer",
    "PROJECTS_BTN_CREATE_TOOLTIP": "Créer",
    "PROJECTS_TITLE_TEXT_RENAME": "Renommer",
    "PROJECTS_TITLE_TEXT_DELETE": "Supprimer",
    "PROJECTS_TITLE_TEXT_EXPORT": "Exporter",
    "PROJECTS_CONFIRM_BTN_DELETE": "Supprimer",
    "PROJECTS_POINT_TIME_MEASUREMENT_HOURS_AGO": "Modifié il y a %d heures",
    "PROJECTS_POINT_TIME_MEASUREMENT_JUST_NOW": "Modifié à l'instant",
    "PROJECTS_POINT_TIME_MEASUREMENT_MINUTES_AGO": "Modifié il y a %d minutes",
    "PROJECTS_PROGRESS_TEXT_LOADING": "Chargement",
    "PROJECTS_PROGRESS_TEXT_SEARCHING": "Recherche en cours",
    "PROJECTS_IMPORT_CONFIRM_TITLE_DO_YOU_WANNA_STOP_IMPORT": "Voulez-vous arrêter l'importation ?",
    "PROJECTS_TEXT_NOTHING_FOUND": "Rien trouvé",
    "PROJECTS_TEXT_CREATE_A_NEW_PROJECT": "Créez un nouveau magnifique projet",
    "PROJECTS_TEXT_CAPTION": "Projets",
    "PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME": "Nom du projet",
    "PROJECTS_UPLOAD_TEXT_CLICK_TO_UPLOAD_DND_FILE": "Cliquez pour téléverser ou glissez-déposez un fichier de projet ici",
    "PROJECTS_UPLOAD_TEXT_YOU_CAN_UPLOAD_ONE_FILE": "Vous ne pouvez téléverser qu'un seul fichier à la fois",
    "PROJECTS_PREFIX_TEXT_EDITED": "Modifié",
    "PROJECTS_CONFIRM_TITLE_ARE_YOU_SURE_TO_DELETE": "Êtes-vous sûr de vouloir supprimer",
    "PROJECTS_CONFIRM_DESC_PROJECT_WILL_BE_DELETED_IMMEDIATELY": "Ce projet sera supprimé immédiatement. Vous ne pouvez pas annuler cette action.",
    "PROJECTS_CONFIRM_TITLE_PROJECT": "Projet",
    "PROJECTS_IMPORT_ONLY_ONE_FILE_TO_UPLOAD": "Un seul fichier peut être téléversé",
    "PROJECTS_IMPORT_INVALID_FILE_EXTENSION": "Extension de fichier invalide. Doit être *.edl.zip",
    "PROJECTS_IMPORT_PLACEHOLDER_ENTER_YOUR_VALUE": "Saisissez votre valeur",
    "PROJECTS_IMPORT_FORM_LABEL_CREATE_FOLDER_IN_MEDIA": "Créer un dossier pour ce projet dans Mes médias",
    "PROJECTS_IMPORT_TEXT_OPEN_EDITOR": "Ouvrir l'éditeur",
    "PROJECTS_IMPORT_TEXT_TRY_AGAIN": "Réessayer",
    "PROJECTS_IMPORT_TITLE_SELECT_FRAME_RATE": "Sélectionnez la cadence pour le projet",
    "PROJECTS_EXPORT_TITLE": "Exporter le projet",
    "PROJECTS_EXPORT_INPROGRESS": "Exportation en cours...",
    "PROJECTS_EXPORT_INCLUDE_MEDIA": "Inclure les médias",
    "PROJECTS_EXPORT_COMPLETE": "Exportation du projet terminée",
    "PROJECTS_EXPORT_BTN_BROWSE": "Parcourir",
    "PROJECTS_EXPORT_BTN_DOWNLOAD": "Télécharger",
    "PROJECTS_EXPORT_BTN_COPY": "Copier",
    "PREVIEW_PLACEHOLDER_FILES_FROM_MEDIA_PLAYED_HERE": "Les fichiers des médias sont lus ici",
    "PREVIEW_BTN_PREV_TOOLTIP": "Préc",
    "PREVIEW_BTN_PREV": "Préc",
    "PREVIEW_BTN_PLAY_TOOLTIP": "Lire",
    "PREVIEW_BTN_PLAY": "Lire",
    "PREVIEW_BTN_STOP_TOOLTIP": "Arrêter",
    "PREVIEW_BTN_STOP": "Arrêter",
    "PREVIEW_BTN_NEXT_TOOLTIP": "Suiv",
    "PREVIEW_BTN_NEXT": "Suiv",
    "PREVIEW_BTN_VOLUME_TOOLTIP": "Volume",
    "PREVIEW_BTN_VOLUME": "Volume",
    "PREVIEW_BTN_MARK_IN_TOOLTIP": "Point d'entrée",
    "PREVIEW_BTN_MARK_IN": "Point d'entrée",
    "PREVIEW_BTN_MARK_OUT_TOOLTIP": "Point de sortie",
    "PREVIEW_BTN_MARK_OUT": "Point de sortie",
    "PREVIEW_BTN_FRAME_CAPTURE": "Capturer une image",
    "PREVIEW_BTN_FRAME_CAPTURE_TOOLTIP": "Capturer une image",
    "PREVIEW_BTN_FULL_SCREEN": "Plein écran",
    "PREVIEW_BTN_FULL_SCREEN_TOOLTIP": "Plein écran",
    "PREVIEW_HEADER_TITLE_SOURCE": "Source",
    "PREVIEW_HEADER_TITLE_TIMELINE": "Timeline",
    "PREVIEW_MODE_AUTO": "Auto",
    "PREVIEW_MODE_SOURCE": "Aperçu source",
    "PREVIEW_MODE_TIMELINE": "Aperçu timeline",
    "PUBLISH_SETTINGS_OUTPUT_NAME": "sortie",
    "PUBLISH_SETTINGS_TITLE": "Titre",
    "QR_CODE_DIALOG_TITLE": "Scannez le code QR (valable 24 heures)",
    "QR_CODE_LOAD_ERROR": "Erreur ! Impossible de générer un code QR",
    "PREVENT_ADDING_VIDEO_FILES_WITH_DIFF_VIDEO_ENCODER_PARAMS": "Empêcher l'ajout de fichiers vidéo avec des paramètres d'encodeur vidéo différents sur la même timeline",
    "IGNORE_QUANTIZER_VIDEO_PARAMS_MISMATCH": "Ignorer la non-concordance des paramètres vidéo du quantificateur",
    "RENDER_SETTINGS_START_RENDERING_FROM_THE_FIRST_CLIP": "Commencer le rendu à partir du premier clip",
    "RENDER_SETTINGS_ASK_PUBLISH_OUTPUT_NAME": "Demander le nom du fichier de sortie",
    "RENDER_SETTINGS_CLOSE_PUBLISH_SETTINGS_ON_CANCEL": "Fermer les paramètres de publication à l'annulation",
    "SAVE_SETTINGS_LIST_ITEM_DURATION": "Durée",
    "SAVE_SETTINGS_LIST_ITEM_CODEC": "Codec",
    "SAVE_SETTINGS_LIST_ITEM_FRAME_RATE": "Cadence",
    "SAVE_SETTINGS_LIST_ITEM_HZ_STEREO": "Hz - Stéréo",
    "SAVE_SETTINGS_LIST_ITEM_RESOLUTION": "Résolution",
    "SAVE_SETTINGS_LIST_ITEM_AUDIO": "Audio",
    "SAVE_SETTINGS_LIST_ITEM_SIZE_APPROXIMATE": "Taille (approximative)",
    "SAVE_SETTINGS_LINK_TO_TRANSCODING_WILL_BE_LOST": "Le lien vers le fichier de transcodage sera perdu",
    "SAVE_SETTINGS_CAPTION_PUBLISH_SETTINGS": "Paramètres de publication",
    "SAVE_SETTINGS_CAPTION_VIDEO_RENDER_COMPLETE": "Rendu vidéo terminé",
    "SAVE_SETTINGS_INPUT_PLACEHOLDER_RENDER_NAME": "Saisissez un nom",
    "SAVE_SETTINGS_BTN_RENDER_START": "Démarrer",
    "SAVE_SETTINGS_BTN_RENDER_START_TOOLTIP": "Démarrer",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC": "Retour à Mon compte",
    "SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP": "Retour à Mon compte",
    "SAVE_SETTINGS_BTN_OK": "OK",
    "SAVE_SETTINGS_BTN_OK_TOOLTIP": "OK",
    "SAVE_SETTINGS_BTN_CANCEL": "Annuler",
    "SAVE_SETTINGS_BTN_CANCEL_TOOLTIP": "Annuler",
    "SAVE_SETTINGS_BTN_DOWNLOAD": "Télécharger",
    "SAVE_SETTINGS_BTN_DOWNLOAD_TOOLTIP": "Télécharger",
    "SAVE_SETTINGS_BTN_BROWSE": "Parcourir",
    "SAVE_SETTINGS_BTN_BROWSE_TOOLTIP": "Parcourir",
    "SAVE_SETTINGS_BTN_COPY": "Copier",
    "SAVE_SETTINGS_BTN_COPY_TOOLTIP": "Copier",
    "SAVE_SETTINGS_TEXT_TITLE": "Titre",
    "SAVE_SETTINGS_TEXT_LOADING": "Chargement",
    "SAVE_SETTINGS_TEXT_PREPARE_IMAGES": "Préparer les images",
    "SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT": "Cette vidéo a été soumise à votre compte et devrait être disponible prochainement.",
    "SEARCH_DROP_DOWN_MENU_ITEM_ALL": "Tout",
    "SEARCH_INPUT_PLACEHOLDER_SEARCH": "Rechercher",
    "SHOW_MY_MEDIA_POOL": "Afficher ma bibliothèque média",
    "SHOW_PROJECT_MEDIA_POOL": "Afficher la bibliothèque média du projet",
    "SHOW_EDITOR_HEADER": "Afficher l'en-tête de l'éditeur",
    "SHOW_MENU_TABS": "Afficher les onglets du menu",
    "SHOW_PREVIEW_SPLIT_BUTTON": "Afficher le bouton de division de l'aperçu",
    "SHOW_PREVIEW_SWITCH_BUTTONS": "Afficher les boutons de changement d'aperçu",
    "SHOW_INOUT_POINTS_TIMELINE": "Afficher les points d'entrée/sortie de la timeline",
    "SHOW_INOUT_POINTS_SOURCE": "Afficher les points d'entrée/sortie de la source",
    "SHOW_DROP_PLACE_HOLDER_TIMELINE": "Afficher l'espace réservé d'importation sur une timeline vide",
    "VIEW_SETTINGS_LANG": "Langue",
    "SETTINGS_HEAD_TEXT_DESCRIPTION": "Description",
    "SETTINGS_HEAD_BTN_DELETE": "Supprimer",
    "SETTINGS_HEAD_BTN_DELETE_TOOLTIP": "Supprimer",
    "SETTINGS_HEAD_BTN_SELECT_SAME": "Sélectionner identique",
    "SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP": "Sélectionner identique",
    "SETTINGS_HEAD_BTN_CLOSE": "Fermer",
    "SETTINGS_HEAD_BTN_CLOSE_TOOLTIP": "Fermer",
    "SETTINGS_SIZE_ICON_TEXT_WIDTH": "Largeur",
    "SETTINGS_SIZE_ICON_TEXT_HEIGHT": "Hauteur",
    "SETTINGS_SIZE_ICON_TEXT_KEEP_ASPECT_RATIO": "Conserver les proportions",
    "SETTINGS_BTN_FIT_TO_FRAME": "Ajuster au cadre",
    "SETTINGS_BTN_FIT_TO_FRAME_TOOLTIP": "Ajuster au cadre",
    "SETTINGS_BTN_FILL_FRAME": "Remplir le cadre",
    "SETTINGS_BTN_FILL_FRAME_TOOLTIP": "Remplir le cadre",
    "SETTINGS_TEXT_AUTO": "auto",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE": "Aucune transformation du texte",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_NONE_TOOLTIP": "Aucune transformation du texte",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE": "Texte en majuscules",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_UPPERCASE_TOOLTIP": "Texte en majuscules",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE": "Texte en minuscules",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_LOWERCASE_TOOLTIP": "Texte en minuscules",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE": "Texte en capitales",
    "SETTINGS_TEXT_BTN_TEXT_TRANSFORM_CAPITALIZE_TOOLTIP": "Texte en capitales",
    "SETTINGS_TEXT_BTN_FONT_FAMILY": "Famille de police",
    "SETTINGS_TEXT_BTN_FONT_FAMILY_TOOLTIP": "Famille de police",
    "SETTINGS_TEXT_BTN_FONT_SIZE": "Taille de police",
    "SETTINGS_TEXT_BTN_FONT_SIZE_TOOLTIP": "Taille de police",
    "SETTINGS_TEXT_BTN_BOLD": "Gras",
    "SETTINGS_TEXT_BTN_BOLD_TOOLTIP": "Gras",
    "SETTINGS_TEXT_BTN_ITALIC": "Italique",
    "SETTINGS_TEXT_BTN_ITALIC_TOOLTIP": "Italique",
    "SETTINGS_TEXT_BTN_UNDERLINE": "Souligné",
    "SETTINGS_TEXT_BTN_UNDERLINE_TOOLTIP": "Souligné",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT": "Gauche",
    "SETTINGS_TEXT_ALIGN_BTN_LEFT_TOOLTIP": "Gauche",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT": "Droite",
    "SETTINGS_TEXT_ALIGN_BTN_RIGHT_TOOLTIP": "Droite",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER": "Centre",
    "SETTINGS_TEXT_ALIGN_BTN_CENTER_TOOLTIP": "Centre",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY": "Justifier",
    "SETTINGS_TEXT_ALIGN_BTN_JUSTIFY_TOOLTIP": "Justifier",
    "SETTINGS_TEXT_POSITION_BTN_TOP": "Haut",
    "SETTINGS_TEXT_POSITION_BTN_TOP_TOOLTIP": "Haut",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT": "En haut à gauche",
    "SETTINGS_TEXT_POSITION_BTN_TOP_LEFT_TOOLTIP": "En haut à gauche",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT": "En haut à droite",
    "SETTINGS_TEXT_POSITION_BTN_TOP_RIGHT_TOOLTIP": "En haut à droite",
    "SETTINGS_TEXT_POSITION_BTN_LEFT": "Gauche",
    "SETTINGS_TEXT_POSITION_BTN_LEFT_TOOLTIP": "Gauche",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER": "Centre moyen",
    "SETTINGS_TEXT_POSITION_BTN_MIDDLE_CENTER_TOOLTIP": "Centre moyen",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT": "Droite",
    "SETTINGS_TEXT_POSITION_BTN_RIGHT_TOOLTIP": "Droite",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT": "En bas à gauche",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_LEFT_TOOLTIP": "En bas à gauche",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM": "En bas",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_TOOLTIP": "En bas",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT": "En bas à droite",
    "SETTINGS_TEXT_POSITION_BTN_BOTTOM_RIGHT_TOOLTIP": "En bas à droite",
    "SETTINGS_ROTATION_TEXT_HORIZONTAL": "Horizontal",
    "SETTINGS_ROTATION_TEXT_VERTICAL": "Vertical",
    "SETTINGS_ROTATION_TEXT_ROTATE": "Pivoter",
    "SETTINGS_PLACEHOLDER_ENTER_TEXT": "Saisir du texte",
    "NABLET_HLD_PROJECT_POSTFIX": "moments forts",
    "NABLET_HLD_CAPTION": "Détecter les moments forts",
    "NABLET_HLD_DETECTED_BTN_START": "Démarrer",
    "NABLET_HLD_DETECTED_BTN_CREATE_PROJECT": "Créer un/des projet(s)",
    "NABLET_HLD_DETECTED_BTN_CANCEL": "Annuler",
    "NABLET_HLD_DETECTED_INTERVALS_COUNT": "Nombre d'intervalles détectés :",
    "NABLET_HLD_DETECTED_CLOSE_CONFIRMATION": "Êtes-vous sûr de vouloir terminer la tâche ?",
    "NABLET_HLD_DETECTED_BTN_NO": "Non",
    "NABLET_HLD_DETECTED_BTN_YES": "Oui",
    "NB_HLD_STATUS_TEXT_DETECTING": "Détection en cours",
    "NABLET_HLD_TARGET_DURATION_SEC": "Durée cible en secondes",
    "AI_MODEL": "Modèle IA",
    "TRANSCRIBE_CAPTION": "Transcrire un média",
    "TRANSCRIBE_PROJECT_POSTFIX": "transcrit",
    "TRANSCRIBE_STATUS_TEXT_TRANSCRIBING": "Transcription en cours",
    "TRANSCRIBED_TEXT_ITEMS_COUNT": "Nombre d'éléments de texte :",
    "TRANSCRIBE_BTN_CREATE_PROJECT": "Créer un projet",
    "SECTION_PLACEHOLDER_TEXT_SECTION_IN_DEVELOPMENT": "Cette section est en cours de développement",
    "TEXT_FORM_CAPTION_SIZE": "Taille",
    "TEXT_FORM_CAPTION_OUTLINE": "Contour",
    "TEXT_FORM_CAPTION_FONT": "Police",
    "TEXT_FORM_CAPTION_SHADOW": "Ombre",
    "TEXT_FORM_TEXT_TITLE_SETTINGS": "Paramètres du texte",
    "TEXT_FORM_TEXT_OFFSET": "Décalage",
    "TEXT_FORM_TEXT_BLUR": "Flou",
    "TEXT_HEADER_TEXT_CAPTION_TEXT": "Texte",
    "TIMELINE_TEXT_DRAG_N_DROP": "Glisser-déposer",
    "TIMELINE_TEXT_ADD_LAYER": "+ Ajouter un calque",
    "TIMELINE_TOOLBAR_BTN_UNDO": "Annuler",
    "TIMELINE_TOOLBAR_BTN_UNDO_TOOLTIP": "Annuler",
    "TIMELINE_TOOLBAR_BTN_REDO": "Rétablir",
    "TIMELINE_TOOLBAR_BTN_REDO_TOOLTIP": "Rétablir",
    "TIMELINE_TOOLBAR_BTN_DELETE": "Supprimer",
    "TIMELINE_TOOLBAR_BTN_DELETE_TOOLTIP": "Supprimer",
    "TIMELINE_TOOLBAR_BTN_COPY": "Copier le clip",
    "TIMELINE_TOOLBAR_BTN_COPY_TOOLTIP": "Copier le clip",
    "TIMELINE_TOOLBAR_BTN_CUT": "Couper le(s) clip(s)",
    "TIMELINE_TOOLBAR_BTN_CUT_TOOLTIP": "Couper le(s) clip(s)",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER_TOOLTIP": "Ajouter un marqueur",
    "TIMELINE_TOOLBAR_BTN_ADD_MARKER": "Ajouter un marqueur",
    "TIMELINE_TOOLBAR_BTN_PASTE_TOOLTIP": "Coller",
    "TIMELINE_TOOLBAR_BTN_PASTE": "Coller",
    "TIMELINE_TOOLBAR_BTN_SETTINGS_TOOLTIP": "Paramètres",
    "TIMELINE_TOOLBAR_BTN_SETTINGS": "Paramètres",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER": "Voix off",
    "TIMELINE_TOOLBAR_BTN_VOICE_OVER_TOOLTIP": "Voix off",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA": "Webcaméra",
    "TIMELINE_TOOLBAR_BTN_WEBCAMERA_TOOLTIP": "Webcaméra",
    "TIMELINE_TOOLBAR_BTN_LIVE": "Diffusion en direct",
    "TIMELINE_TOOLBAR_BTN_LIVE_TOOLTIP": "Diffusion en direct",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL": "Cliquez pour annuler",
    "TIMELINE_TOOLBAR_BTN_CLICK_TO_CANCEL_TOOLTIP": "Cliquez pour annuler",
    "TIMELINE_LAYER_TITLE_DRAG_N_DROP": "Glisser-déposer",
    "TIMELINE_FOOTER_TEXT_DURATION": "Durée",
    "TIMELINE_FOOTER_TITLE_UNABLE_TO_PUBLISH": "Impossible de publier le projet",
    "TIMELINE_FOOTER_TEXT_VIDEO_TRACK_IS_REQUIRED": "La piste vidéo est requise",
    "TIMELINE_FOOTER_TITLE_TEXT_SAVE": "Enregistrer",
    "TIMELINE_FOOTER_BTN_SAVE": "Enregistrer",
    "TIMELINE_FOOTER_BTN_SAVE_TOOLTIP": "Enregistrer",
    "TIMELINE_FOOTER_BTN_PUBLISH": "Publier",
    "TIMELINE_FOOTER_BTN_PUBLISH_TOOLTIP": "Publier",
    "TIMELINE_SLIDER_POINTER": "Pointeur du curseur",
    "TIMELINE_SLIDER_POINTER_TOOLTIP": "Pointeur du curseur",
    "TRANSITION_NAME_DISSOLVE": "Fondu enchaîné",
    "TRANSITION_NAME_FADE_IN": "Fondu d'entrée",
    "TRANSITION_NAME_FADE_OUT": "Fondu de sortie",
    "TRANSITION_NAME_DIP_TO_BLACK": "Fondu au noir",
    "TRANSITION_NAME_DIP_TO_WHITE": "Fondu au blanc",
    "TRANSITION_NAME_BLUR": "Flou",
    "TRANSITION_NAME_WIPE_RIGHT": "Volet vers la droite",
    "TRANSITION_NAME_WIPE_LEFT": "Volet vers la gauche",
    "TRANSITION_NAME_WIPE_UP": "Volet vers le haut",
    "TRANSITION_NAME_WIPE_DOWN": "Volet vers le bas",
    "TRANSITION_FORM_TITLE_SETTINGS_TRANSITION": "Paramètres de transition",
    "TRANSITION_FORM_SWITCH_TEXT_APPLY_TO_ALL_TRANSITIONS": "Appliquer à toutes les transitions de la timeline",
    "TRANSITION_FORM_SELECTED": "sélectionnés :",
    "TRANSITION_FORM_LABEL_TYPE": "Type",
    "TRANSITION_FORM_LABEL_DURATION": "Durée (s)",
    "TRANSITION_LIST_CAPTION_TRANSITION": "Transition",
    "used_in_projects": "Le fichier média n'a pas été supprimé car il est utilisé dans un ou plusieurs projets. Si vous continuez, le fichier ne sera pas disponible sur la timeline des projets correspondants et sera supprimé de votre compte.",
    "USE_MODAL_DLG_FOR_IMPORT_LOCAL_FILES": "Utiliser la boîte de dialogue modale pour importer des fichiers locaux",
    "VOICE_OVER_TITLE_LAST_RECORDING": "Dernier enregistrement",
    "VOICE_OVER_BTN_RETAKE": "Refaire",
    "VOICE_OVER_BTN_RETAKE_TOOLTIP": "Refaire",
    "VOICE_OVER_BTN_DELETE_FILE": "Supprimer le fichier",
    "VOICE_OVER_BTN_DELETE_FILE_TOOLTIP": "Supprimer le fichier",
    "VOICE_OVER_BTN_START_RECORDING": "Démarrer l'enregistrement",
    "VOICE_OVER_BTN_START_RECORDING_TOOLTIP": "Démarrer l'enregistrement",
    "VOICE_OVER_BTN_CONNECTION": "Connexion...",
    "VOICE_OVER_BTN_CONNECTION_TOOLTIP": "Connexion...",
    "VOICE_OVER_TEXT_VOICE_OVER_BTN_FILE_WILL_BE_DELETED_FROM_MEDIA_AND_TIMELINE": "Le fichier sera supprimé de la timeline et des médias.",
    "VOICE_OVER_TEXT_ARE_YOU_SURE": "Êtes-vous sûr ?",
    "VOICE_OVER_TEXT_VOICE_NARRATION": "Narration vocale",
    "VOICE_OVER_TEXT_MIC": "Microphone",
    "VOICE_OVER_LABEL_SELECT_MIC": "Sélectionner un microphone",
    "VOICE_OVER_MENU_ITEM_NO_AUDIO": "Aucun audio",
    "VOICE_OVER_TEXT_MUTE_TIMELINE": "Couper le son de la timeline pendant l'enregistrement",
    "VOICE_OVER_TEXT_REWIND_SLIDER_AT_START_OF_RECORD": "Rembobiner le curseur au début après l'enregistrement",
    "VOICE_OVER_TEXT_COUNTDOWN": "Compte à rebours",
    "VOICE_OVER_BTN_TEST_MIC": "Tester le micro",
    "VOICE_OVER_BTN_TEST_MIC_TOOLTIP": "Tester le micro",
    "VOICE_OVER_BTN_RECORDING": "Enregistrement en cours...",
    "VOICE_OVER_BTN_RECORDING_TOOLTIP": "Enregistrement en cours...",
    "VOICE_OVER_BTN_PLAYING": "Lecture en cours...",
    "VOICE_OVER_BTN_PLAYING_TOOLTIP": "Lecture en cours...",
    "VOICE_OVER_BTN_YES": "Oui",
    "VOICE_OVER_BTN_YES_TOOLTIP": "Oui",
    "VOICE_OVER_BTN_NO": "Non",
    "VOICE_OVER_BTN_NO_TOOLTIP": "Non",
    "VOICE_OVER_BTN_STOP": "Arrêter",
    "VOICE_OVER_BTN_STOP_TOOLTIP": "Arrêter",
    "VOICE_OVER_BTN_DELETE": "Supprimer",
    "VOICE_OVER_BTN_DELETE_TOOLTIP": "Supprimer",
    "VOICE_OVER_VOLUME_TEXT_AUTO_ADJUSTING": "Ajustement automatique",
    "VOICE_OVER_VOLUME_TEXT_OTHER_SETTINGS": "Autres paramètres",
    "WEBCAM_TEXT_RECORD_VIDEO": "Enregistrer une vidéo",
    "LIVE_STREAM_TEXT_RECORD_STREAM": "Enregistrer une diffusion en direct",
    "LIVE_STREAM_URL_INPUT_LABEL": "URL de diffusion en direct",
    "LIVE_STREAM_URL_INPUT_PLACEHOLDER": "Cliquez ici pour lier une diffusion en direct",
    "LIVE_STREAM_BTN_CONNECTING": "Connexion en cours...",
    "LIVE_STREAM_BTN_CONNECTING_TOOLTIP": "Connexion en cours...",
    "LIVE_STREAM_BTN_CAPTURE": "Démarrer la capture",
    "LIVE_STREAM_BTN_CAPTURE_TOOLTIP": "Démarrer la capture",
    "LIVE_STREAM_BTN_CAPTURE_STOP": "Arrêter la capture",
    "LIVE_STREAM_BTN_CAPTURE_STOP_TOOLTIP": "Arrêter la capture",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM_TOOLTIP": "Réduire le zoom",
    "ZOOM_SLIDER_BTN_DECREASE_ZOOM": "Réduire le zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM_TOOLTIP": "Augmenter le zoom",
    "ZOOM_SLIDER_BTN_INCREASE_ZOOM": "Augmenter le zoom",
    "SETTINGS_HOTKEYS": "Paramètres des raccourcis",
    "PRESET": "Préréglage",
    "DEFAULT": "Par défaut",
    "ADD_NEW": "Ajouter nouveau",
    "SEARCH_COMMAND": "Rechercher une commande",
    "COMMAND": "Commande",
    "SHORTCUTS": "Raccourcis",
    "ALL": "Tout",
    "TIMELINE": "Timeline",
    "TOOLS": "Outils",
    "PREVIEW": "Aperçu",
    "KEYBOARD_MAPPING_PRESET": "Préréglage de mappage clavier",
    "ENTER_PRESET_NAME": "Saisissez le nom du préréglage",
    "THIS_PRESET_WILL_BE_DELETED": "Ce préréglage sera supprimé immédiatement. Vous ne pouvez pas annuler cette action.",
    "RESET_ALL_TO_DEFAULTS": "Tout réinitialiser aux valeurs par défaut",
    "HOTKEY_SETTINGS_UNDO": "Annuler",
    "HOTKEY_SETTINGS_REDO": "Rétablir",
    "HOTKEY_SETTINGS_ZOOM_IN": "Zoom avant",
    "HOTKEY_SETTINGS_ZOOM_OUT": "Zoom arrière",
    "HOTKEY_SETTINGS_PREV_FRAME": "Image précédente",
    "HOTKEY_SETTINGS_NEXT_FRAME": "Image suivante",
    "HOTKEY_SETTINGS_ADD_TO_TIMELINE": "Ajouter à la timeline",
    "HOTKEY_SETTINGS_INCREASE_CLIP_VOLUME": "Augmenter le volume du clip",
    "HOTKEY_SETTINGS_DECREASE_CLIP_VOLUME": "Diminuer le volume du clip",
    "HOTKEY_SETTINGS_RIPPLE_DELETE": "Suppression en cascade",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_PREV": "Rognage en cascade précédent",
    "HOTKEY_SETTINGS_RIPPLE_TRIM_NEXT": "Rognage en cascade suivant",
    "HOTKEY_SETTINGS_SELECT_CLIPS_AT_CURRENT_POSITION": "Sélectionner les clips à la position actuelle",
    "HOTKEY_SETTINGS_CUT_CLIPS": "Couper le(s) clip(s)",
    "HOTKEY_SETTINGS_PLAY_PAUSE": "Lecture/Pause",
    "HOTKEY_SETTINGS_DELETE": "Supprimer",
    "HOTKEY_SETTINGS_COPY": "Copier",
    "HOTKEY_SETTINGS_PASTE": "Coller",
    "HOTKEY_SETTINGS_PLAY": "Lire",
    "HOTKEY_SETTINGS_PAUSE": "Pause",
    "HOTKEY_SETTINGS_PLAY_TIMELINE_SEGMENT": "Lire l'intervalle mis en évidence",
    "HOTKEY_SETTINGS_CLEAR_IN_OUT_MARK_POINTS": "Effacer les points d'entrée/sortie",
    "HOTKEY_SETTINGS_MARK_IN": "Point d'entrée",
    "HOTKEY_SETTINGS_MARK_OUT": "Point de sortie",
    "HOTKEY_SETTINGS_SEEK_TO_IN_POINT": "Aller au point d'entrée",
    "HOTKEY_SETTINGS_SEEK_TO_OUT_POINT": "Aller au point de sortie",
    "HOTKEY_SETTINGS_NEXT_EDITING_POINT": "Déplacer le curseur au point de montage suivant",
    "HOTKEY_SETTINGS_PREV_EDITING_POINT": "Déplacer le curseur au point de montage précédent",
    "HOTKEY_SETTINGS_TOGGLE_MY_MEDIA_VISIBLE": "Afficher/masquer mes médias",
    "HOTKEY_SETTINGS_TOGGLE_SETTINGS_VISIBLE": "Afficher/masquer les paramètres de l'éditeur",
    "CLIP_SETTINGS": "Paramètres du clip",
    "MESSAGE_BOX_INCOMPATIBLE": "Les fichiers ne sont pas compatibles",
    "MESSAGE_BOX_REMOVE_EXISTING": "Les fichiers ne sont pas compatibles (format non concordant)",
    "MESSAGE_BOX_VIDEO_RESOLUTION_MISMATCH": "Les fichiers ne sont pas compatibles (résolution non concordante)",
    "MESSAGE_BOX_VIDEO_FPS_MISMATCH": "Les fichiers ne sont pas compatibles (cadence non concordante)",
    "MESSAGE_BOX_VIDEO_CODECS_MISMATCH": "Les fichiers ne sont pas compatibles (codecs non concordants)",
    "MESSAGE_BOX_VIDEO_DF_NDF_TIMECODE_FORMAT_MISMATCH": "Les fichiers ne sont pas compatibles (format de timecode DF/NDF non concordant)",
    "MESSAGE_BOX_VIDEO_COLOR_SPACE_MISMATCH": "Les fichiers ne sont pas compatibles (espace colorimétrique non concordant)",
    "MESSAGE_BOX_VIDEO_ENCODER_PARAMS_MISMATCH": "Les fichiers ne sont pas compatibles (paramètres d'encodeur vidéo non concordants)",
    "MESSAGE_BOX_PLEASE_DELETE_OFFLINE_CLIP": "Le fichier est incompatible (veuillez supprimer le clip hors ligne)",
    "MESSAGE_BOX_TRANSCRIBE_MODELS_NOT_FOUND_CONFIRMATION": "Modèles de transcription introuvables.\\nSouhaitez-vous les télécharger (~882 Mo) et les installer ?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_NOT_FOUND_CONFIRMATION": "Modèles de détection des moments forts sportifs introuvables.\\nSouhaitez-vous les télécharger (~3.9 Go) et les installer ?",
    "MESSAGE_BOX_HLD_ONNX_MODELS_REQUIRES_GPU": "La détection des moments forts sportifs nécessite un NVIDIA GPU avec une capacité de calcul >= 7.5",
    "VIDEO_PREVENT_ADDING_BEHAVIOUR_SETTING": "Empêcher l'ajout de fichiers vidéo avec des codecs, résolutions, FPS, timecode DF/NDF, espace colorimétrique différents sur la même timeline",
    "MARKS_CONTEXT_MENU_MARK_IN": "Point d'entrée",
    "MARKS_CONTEXT_MENU_MARK_OUT": "Point de sortie",
    "MARKS_CONTEXT_MENU_CLEAR": "Effacer les points d'entrée/sortie",
    "MEDIA_ERROR_build_thumbnails_error": "Erreur de génération de vignettes",
    "MEDIA_ERROR_unsupported_media": "Média non pris en charge",
    "MEDIA_ERROR_exceeded_file_size": "Taille de fichier dépassée",
    "MEDIA_ERROR_exceeded_per_user_size": "Taille par utilisateur dépassée",
    "MEDIA_ERROR_low_disk_space": "Espace disque insuffisant",
    "MEDIA_ERROR_internal_server_error": "Erreur interne du serveur",
    "MEDIA_ERROR_network_error": "Erreur réseau",
    "MEDIA_ERROR_not_found": "Fichier média introuvable",
    "MEDIA_ERROR_unable_get_media_info": "Impossible d'obtenir les informations du média",
    "MEDIA_ERROR_not_enough_tokens": "Jetons insuffisants",
  },
}
